var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminCreationSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 120,
    viewBox: "0 0 162 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_8666)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5645 28.1458C24.0159 26.7213 24.6027 25.2968 25.325 23.9706C25.6862 23.2829 26.1376 22.6935 26.6793 22.1532C27.221 21.6128 27.8079 21.1708 28.5753 21.0725C28.9364 21.0234 29.3427 21.1216 29.6587 21.4164C29.9747 21.7111 30.1102 22.104 30.2004 22.497C30.3359 23.2829 30.1102 24.1671 29.6136 24.8056C29.117 25.3951 28.485 25.8372 27.8079 26.1319C27.1307 26.4266 26.4536 26.6231 25.7313 26.7213C25.009 26.8196 24.2416 26.7704 23.5645 26.574C22.8422 26.3775 22.165 25.9354 21.6685 25.346C21.1719 24.7565 20.8559 23.9706 20.7205 23.1847C20.585 22.3988 20.5399 21.6128 20.585 20.8269C20.6753 19.2551 20.9913 17.7324 21.4427 16.2588C21.9393 14.7852 22.5262 13.3607 23.4742 12.1327C23.9707 11.5433 24.5124 10.9538 25.1896 10.5609C25.8667 10.1679 26.6342 9.9223 27.4467 9.97142C28.2142 10.0205 28.9816 10.217 29.6587 10.7573C29.9747 11.0521 30.2907 11.445 30.381 11.9362C30.4713 12.4274 30.4262 12.9186 30.2456 13.3607C30.065 13.8028 29.8393 14.1466 29.5233 14.4413C29.2073 14.7361 28.9364 14.9817 28.6204 15.1781C27.9884 15.6202 27.3564 16.0132 26.6793 16.3079C26.0022 16.6026 25.2799 16.7991 24.5124 16.8973C24.1513 16.9464 23.745 16.8973 23.3387 16.8973L22.7067 16.7008C22.5262 16.6026 22.3456 16.5044 22.165 16.4061C21.4427 15.9149 20.9913 15.129 20.7205 14.3431C20.4496 13.5572 20.3593 12.7221 20.3593 11.9362C20.3593 10.3644 20.585 8.74342 21.1267 7.26982C21.6685 5.79622 22.4359 4.46999 23.2936 3.24199C24.1964 2.06311 25.1896 0.933349 26.2279 -0.0490494L26.273 7.05607e-05C25.325 1.12983 24.377 2.25959 23.5645 3.48759C22.7519 4.71558 22.0747 6.04182 21.6685 7.4663C21.2622 8.89078 21.0365 10.3644 21.1267 11.838C21.1719 12.5748 21.2622 13.3116 21.4879 13.9501C21.7136 14.5887 22.0747 15.1781 22.5713 15.4729L22.9776 15.6693L23.429 15.7676C23.745 15.7676 24.061 15.8167 24.377 15.7676C25.009 15.7184 25.6862 15.522 26.273 15.2273C26.905 14.9817 27.4919 14.6378 28.0787 14.2449C28.3496 14.0484 28.6204 13.8028 28.8462 13.6063C29.0719 13.4098 29.2524 13.1151 29.3427 12.8695C29.5684 12.2801 29.4782 11.7397 29.0267 11.3468C28.5753 10.9538 27.9433 10.7573 27.3113 10.7082C26.9953 10.7082 26.6793 10.7082 26.3633 10.7573C26.0473 10.8556 25.7764 10.9538 25.4604 11.1012C24.8736 11.3959 24.377 11.8871 23.9256 12.4274C23.0227 13.5081 22.4359 14.8834 21.9393 16.3079C21.4879 17.7324 21.1719 19.206 21.0365 20.6796C20.9913 21.4164 20.9913 22.1532 21.1267 22.89C21.2622 23.6268 21.4879 24.2653 21.9393 24.8056C22.797 25.8863 24.2416 26.2792 25.5959 26.0828C26.273 25.9845 26.9502 25.8372 27.5822 25.5424C28.2142 25.2477 28.801 24.9039 29.2524 24.3636C29.7039 23.8724 29.8844 23.0864 29.7942 22.3988C29.749 22.0549 29.6136 21.7111 29.3879 21.5146C29.1622 21.269 28.8462 21.1708 28.5302 21.2199C27.853 21.269 27.2662 21.7111 26.7696 22.2023C26.273 22.6935 25.7764 23.2829 25.4153 23.9215C24.6479 25.1986 24.061 26.6231 23.6096 28.0476L23.5645 28.1458Z",
    fill: "#52AF48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68799 93.1314C4.46913 95.2927 3.20514 97.454 1.76057 99.517C1.58 99.7626 1.39943 100.008 1.17371 100.254C1.08343 100.352 0.947998 100.499 0.857713 100.598C0.767427 100.647 0.722284 100.745 0.541713 100.794C0.361142 100.843 0.180571 100.745 0.0902855 100.598C0 100.45 0 100.303 0 100.205C0 100.106 0 100.008 0 99.9099C0.0451428 99.7135 0.0902855 99.517 0.180571 99.3696C0.361142 99.0258 0.586856 98.7802 0.767427 98.5837C1.17371 98.1416 1.62514 97.6996 2.12171 97.3066C2.61828 96.9136 3.20514 96.6189 3.88228 96.5207C5.19142 96.2751 6.63599 97.061 7.1777 98.5346C7.31313 98.8784 7.35827 99.2714 7.35827 99.6643C7.35827 100.057 7.26799 100.45 7.13256 100.794C6.8617 101.482 6.45542 101.973 6.13942 102.464C6.00399 102.71 5.86856 102.955 5.82342 103.152C5.82342 103.201 5.77827 103.25 5.77827 103.299C5.77827 103.348 5.77827 103.397 5.77827 103.447V103.545C5.77827 103.545 5.77827 103.545 5.77827 103.594C5.77827 103.594 5.82342 103.643 5.82342 103.692C5.9137 103.889 6.13942 104.085 6.36513 104.282C6.59084 104.478 6.81656 104.724 6.99713 104.969C7.40341 105.51 7.71941 106.148 7.8097 106.787C7.89998 107.474 7.85484 108.113 7.71941 108.752H7.62913C7.62913 108.113 7.62913 107.474 7.40341 106.934C7.22284 106.345 6.90684 105.853 6.5457 105.46C6.36513 105.264 6.13942 105.068 5.9137 104.871C5.68799 104.675 5.41713 104.527 5.19142 104.183C5.14628 104.085 5.05599 103.987 5.01085 103.84C5.01085 103.79 4.9657 103.692 4.9657 103.643V103.496C4.9657 103.397 4.9657 103.299 4.9657 103.201C4.9657 103.103 4.9657 103.004 5.01085 102.906C5.10113 102.513 5.23656 102.169 5.41713 101.875C5.73313 101.285 6.13942 100.794 6.31999 100.303C6.41027 100.057 6.45542 99.8608 6.45542 99.5661C6.45542 99.3205 6.41027 99.0258 6.36513 98.7802C6.09427 97.7978 5.05599 97.061 4.01771 97.2083C2.97942 97.3557 2.03142 98.1416 1.17371 98.9767C0.947998 99.1731 0.767427 99.3696 0.631999 99.6152C0.586856 99.7135 0.541713 99.8608 0.49657 99.9591C0.49657 100.008 0.49657 100.057 0.49657 100.156C0.49657 100.205 0.49657 100.254 0.49657 100.254C0.49657 100.254 0.451428 100.205 0.406285 100.205C0.406285 100.205 0.451428 100.205 0.49657 100.156C0.586856 100.057 0.722284 99.9591 0.81257 99.8608C1.03828 99.6643 1.21885 99.4187 1.39943 99.1731C2.88914 97.2083 4.24342 95.1453 5.5977 93.0823L5.68799 93.1314Z",
    fill: "#52AF48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.953 27.6053C145.901 28.3912 146.624 29.4227 147.12 30.6016C147.346 31.191 147.572 31.8296 147.572 32.5172C147.572 32.8611 147.572 33.254 147.391 33.5979C147.301 33.7944 147.211 33.9417 147.075 34.0891C146.94 34.2364 146.714 34.3347 146.714 34.3838L146.759 34.3347C146.759 34.2856 146.759 34.3347 146.804 34.3838C146.849 34.482 146.895 34.6294 146.94 34.7276C147.075 34.9732 147.211 35.1697 147.436 35.3171C147.617 35.4644 147.843 35.6118 148.068 35.71C148.159 35.7592 148.294 35.8083 148.429 35.8083C148.565 35.8574 148.745 35.8574 148.926 35.9556C149.107 36.0539 149.332 36.2504 149.423 36.4468C149.558 36.6433 149.603 36.8398 149.648 37.0363C149.739 37.4292 149.739 37.724 149.739 38.0678C149.739 38.4116 149.739 38.7555 149.648 39.0993C149.558 39.4432 149.377 39.787 149.106 39.9344L149.061 39.8852C149.332 39.3449 149.242 38.7555 149.106 38.166C149.016 37.8713 148.971 37.5766 148.881 37.331C148.791 37.0854 148.7 36.9872 148.565 36.938C148.475 36.8889 148.384 36.8889 148.249 36.8889C148.113 36.8398 147.933 36.7907 147.752 36.7416C147.436 36.5942 147.12 36.3977 146.895 36.1521C146.669 35.9065 146.443 35.5627 146.308 35.268C146.217 35.1206 146.172 34.9241 146.127 34.7276C146.127 34.6294 146.082 34.5312 146.082 34.3347C146.082 34.1382 146.217 33.9417 146.353 33.8926C146.579 33.7452 146.624 33.7452 146.714 33.647C146.804 33.5979 146.849 33.4996 146.895 33.4014C146.985 33.2049 147.03 32.9102 147.075 32.6155C147.075 32.0752 146.94 31.4366 146.759 30.8472C146.398 29.6683 145.766 28.5877 144.953 27.7526V27.6053Z",
    fill: "#FBB051"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.241 89.5949C138.227 90.5773 140.439 91.0194 142.651 90.9212C143.193 90.872 143.735 90.8229 144.276 90.7738C144.818 90.6756 145.36 90.5282 145.856 90.3808C146.894 90.037 147.933 89.644 148.926 89.1528C150.912 88.1704 152.763 86.8933 154.794 85.8618C155.788 85.3706 156.826 84.8794 157.909 84.5356C158.993 84.1917 160.076 83.9461 161.205 83.897V83.9952C160.121 84.3391 159.128 84.732 158.09 85.1741C157.097 85.6653 156.104 86.2056 155.156 86.746C153.214 87.8757 151.228 88.9564 149.152 89.8896C148.113 90.3317 147.03 90.7247 145.946 91.0194C145.405 91.1176 144.863 91.265 144.276 91.3141C143.735 91.3632 143.148 91.4124 142.606 91.4124C140.349 91.3632 138.137 90.7738 136.151 89.6932L136.241 89.5949Z",
    fill: "#2D5B27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43498 47.0077C10.6538 46.8112 11.963 47.3024 12.6853 48.3831C13.5881 49.6111 13.4978 51.5267 12.5498 52.7056C12.1887 53.1477 11.7824 53.4424 11.331 53.7371C11.0601 53.9336 10.7441 54.1301 10.4281 54.2283C8.71269 54.7687 6.36527 52.853 6.00413 50.9864C5.64298 48.9234 7.80984 47.2533 9.43498 47.0077Z",
    fill: "#FBB051"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.378 2.21055C116.875 2.40703 117.371 2.65263 117.687 3.14383C118.319 4.02799 118.139 5.40335 117.552 6.33663C116.333 8.4979 112.676 8.44879 112.135 5.69807C111.638 3.04559 114.256 1.47375 116.378 2.21055Z",
    fill: "#52AF48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81 100C103.091 100 121 82.0914 121 60.0001C121 37.9089 103.091 20.0003 81 20.0003C58.9086 20.0003 41 37.9089 41 60.0001C41 82.0914 58.9086 100 81 100Z",
    fill: "#50AF38"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_417_8666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 20,
    width: 80,
    height: 80
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81 99.9996C103.091 99.9996 121 82.0911 121 59.9998C121 37.9085 103.091 20 81 20C58.9086 20 41 37.9085 41 59.9998C41 82.0911 58.9086 99.9996 81 99.9996Z",
    fill: "#50AF38"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_417_8666)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.59
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.768 22.5872C90.8453 22.4328 90.6136 21.815 90.7294 21.7378C90.6136 21.8536 90.3433 21.815 90.1889 21.8536C90.0731 21.9309 89.9572 22.0853 89.88 22.2011C89.7256 22.4328 89.7642 22.4328 89.9958 22.5872C90.2275 22.703 90.6522 22.9347 90.768 22.5872Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3665 22.5871C86.2507 22.5485 85.7102 22.7802 85.5943 22.8574C85.4399 23.0119 85.4013 23.3207 85.5171 23.4752C85.5557 23.5524 85.8646 23.8227 85.9418 23.8227C86.0963 23.8613 86.0963 23.8227 86.1735 23.6682C86.2507 23.5524 86.5982 22.6644 86.3665 22.5871Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4363 20.5795C84.5135 19.7301 83.1235 20.4251 83.2007 20.927C83.2393 21.1201 83.7799 21.3903 83.9729 21.3517C84.2818 21.2745 84.4363 20.8498 84.4363 20.5795Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5211 21.0428C76.2122 21.0042 75.9419 20.734 75.5944 20.927C75.3628 21.0815 75.3242 21.4289 75.5172 21.622C75.6717 21.7764 76.0192 22.0081 76.2508 21.9309C76.4439 21.9309 76.7913 21.0815 76.5211 21.0428Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0345 22.3941C79.9959 22.9346 81.27 23.0504 81.27 22.1624C81.27 21.2744 80.0731 21.8535 80.0345 22.3941Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5867 26.7958C83.3551 26.7572 83.0462 28.1086 83.7798 27.7225C84.2817 27.4908 84.1273 26.8731 83.5867 26.7958Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7488 23.205C75.7102 23.1278 75.4399 23.205 75.3627 23.2436C75.2082 23.3209 75.1696 23.5139 75.131 23.6297C74.9766 23.9772 74.7449 24.5564 75.2855 24.7494C76.2507 25.0969 75.9032 23.6683 75.7488 23.205Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9999 26.7572C91.5018 26.7958 92.0037 25.9078 91.386 25.8305C90.8841 25.7533 90.9999 26.7572 90.9999 26.7572Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3165 31.4674C53.2392 31.4674 53.7798 31.5446 53.7798 31.5446C53.9728 31.3129 54.0114 30.7724 53.6253 30.7338C53.162 30.6952 52.8145 31.4288 53.3165 31.4674Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2664 32.7031C70.4981 32.317 70.1506 31.9695 69.8803 31.8151C69.5328 31.6606 69.3012 31.6606 69.0309 32.0854C68.4517 32.9734 69.9961 33.205 70.2664 32.7031Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4592 26.4097C60.6908 26.7185 60.5364 26.8344 60.9611 26.7571C61.3472 26.6799 61.3858 26.5641 61.2314 26.2552C60.9997 25.7533 59.9572 25.6761 60.4592 26.4097Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0578 35.9848C56.0964 35.4443 57.4091 35.5601 57.2547 36.4095C57.1002 37.2975 56.0192 36.5254 56.0578 35.9848Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2199 27.3749C78.2199 27.5293 78.4902 27.5293 78.606 27.6066C78.7219 27.6838 78.7605 27.9154 78.7605 28.0313C78.7605 28.456 78.4516 28.4946 78.2199 28.1857C78.0269 27.9927 77.7566 27.6066 77.7952 27.3363C77.7952 26.9116 78.2585 26.873 78.2199 27.3749Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3473 24.8652C71.3473 25.0969 71.0385 24.9038 70.9999 24.8652C70.9613 24.8266 70.7682 24.5949 70.7296 24.5563C70.5365 24.3247 70.6138 23.7455 70.8454 23.5911C71.1929 23.398 71.8493 23.3594 71.8493 23.8999C71.8493 24.093 71.7335 24.3633 71.6176 24.4791C71.5018 24.6721 71.3473 24.7108 71.3473 24.8652Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.9072 24.5563C67.216 24.7494 67.2933 25.1355 67.1002 25.4444C66.8299 25.8691 66.4824 25.676 66.2894 25.3671C66.135 25.1355 65.9805 24.788 66.135 24.5177C66.328 24.1702 66.6755 24.4019 66.9072 24.5563Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3627 36.371C75.9033 36.371 76.521 37.1432 75.7875 37.1818C75.2855 37.2204 75.0153 36.371 75.3627 36.371Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5443 28.6489C72.4671 29.4983 71.2316 28.6103 71.386 28.1083C71.4246 27.9153 72.0424 27.7609 72.1968 27.8381C72.4671 27.9539 72.5443 28.4172 72.5443 28.6489Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4323 29.5369C63.9342 29.4983 63.5481 30.2319 63.5868 30.4636C63.5868 30.5408 63.7026 30.7339 63.664 30.7725C63.6254 30.8497 63.2393 30.8497 63.162 30.8111C62.8918 30.7339 62.7373 30.2705 62.7373 30.0003C62.7373 29.8458 62.6987 29.8458 62.8532 29.73C63.0076 29.6528 63.2779 29.5369 63.4323 29.5369Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4519 22.6643C88.4905 22.4713 88.2202 21.9307 88.2974 21.8149C88.2202 21.9307 87.9113 21.9307 87.7955 22.008C87.6797 22.0852 87.6024 22.2396 87.5252 22.3554C87.4094 22.5871 87.448 22.5871 87.6797 22.7029C87.9113 22.8188 88.336 23.0118 88.4519 22.6643Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.0503 23.1663C83.9345 23.1663 83.3939 23.4365 83.3167 23.5137C83.1623 23.6682 83.2009 23.9771 83.3167 24.1315C83.3939 24.2087 83.7028 24.4404 83.78 24.4404C83.9345 24.479 83.9345 24.4018 84.0117 24.2473C84.0503 24.1315 84.3206 23.2049 84.0503 23.1663Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9654 21.3903C81.9268 20.5409 80.6527 21.3903 80.7685 21.8536C80.8071 22.0467 81.3862 22.2397 81.5793 22.1625C81.8496 22.1239 81.9654 21.6606 81.9654 21.3903Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0887 22.7416C73.7799 22.7416 73.471 22.4713 73.1621 22.7416C72.9304 22.9346 72.969 23.2435 73.1621 23.4751C73.3165 23.6296 73.7026 23.784 73.9343 23.7068C74.1273 23.6296 74.3976 22.7416 74.0887 22.7416Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7566 23.6682C77.7566 24.2088 79.0693 24.1702 78.9535 23.2821C78.8377 22.4327 77.7566 23.1663 77.7566 23.6682Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8107 27.6837C81.5791 27.6837 81.386 29.0351 82.1196 28.5718C82.5829 28.2629 82.3513 27.6451 81.8107 27.6837Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5868 24.9812C73.5482 24.9039 73.2779 25.0198 73.2007 25.0584C73.0849 25.1742 73.0463 25.3286 73.0076 25.4831C72.8918 25.8306 72.7374 26.4483 73.2779 26.5642C74.3204 26.8344 73.8185 25.4059 73.5868 24.9812Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1507 22.9733C70.614 23.2049 71.1932 21.7764 70.5754 21.7764C70.0735 21.7764 69.5716 22.6644 70.1507 22.9733Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1468 26.7571C89.6874 26.7571 90.0735 25.7918 89.4171 25.7918C88.9152 25.7918 89.1468 26.7571 89.1468 26.7571Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2741 35.7531C52.1969 35.7531 52.7374 35.7917 52.7374 35.7531C52.8919 35.5214 52.8533 34.9423 52.5058 34.9423C52.0039 34.9809 51.7336 35.7531 52.2741 35.7531Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9228 26.7184C61.502 26.6798 61.0773 26.255 60.8456 26.1006C60.6526 25.9848 60.1892 25.6759 59.9576 25.6759C59.5715 25.7145 59.6487 26.1778 59.8418 26.4095C60.0734 26.6798 60.614 26.757 60.9228 26.7184Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0192 22.5485C66.3281 22.5871 66.5598 22.008 66.4825 21.8149C66.4439 21.7377 65.9806 21.6219 65.942 21.6605C65.749 21.8149 65.7104 22.5099 66.0192 22.5485Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.224 35.0195C69.4171 34.5948 69.031 34.2859 68.7221 34.2087C68.336 34.0929 68.1429 34.1315 67.9113 34.5562C67.448 35.5214 68.9923 35.5987 69.224 35.0195Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7606 29.8845C59.0308 30.1548 58.8764 30.3092 59.3011 30.1934C59.6486 30.0776 59.7258 29.9617 59.5328 29.6529C59.2239 29.1895 58.1814 29.2668 58.7606 29.8845Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7836 30.4637C54.7836 30.541 55.3242 30.541 55.3628 30.3479C55.44 29.8074 54.7836 29.846 54.7836 30.4637Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4788 39.923C55.4788 39.3824 56.7529 39.3438 56.7143 40.2318C56.6371 41.0813 55.5174 40.4635 55.4788 39.923Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5211 28.8421C76.5211 28.9966 76.83 28.958 76.9072 28.9966C77.023 29.0738 77.1002 29.2668 77.1002 29.4213C77.1775 29.846 76.83 29.8846 76.5597 29.6529C76.3667 29.4599 76.0192 29.151 76.0192 28.8421C76.0578 28.456 76.5211 28.3402 76.5211 28.8421Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4169 27.1433C69.4169 27.3749 69.108 27.2205 69.0694 27.1819C69.0308 27.1433 68.7991 26.9502 68.7605 26.9116C68.5288 26.7186 68.5674 26.1008 68.7605 25.9464C69.0694 25.7147 69.7644 25.5989 69.7644 26.1394C69.7644 26.3325 69.6871 26.6027 69.6099 26.7572C69.5327 26.9116 69.4169 26.9888 69.4169 27.1433Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9769 27.2976C65.3244 27.452 65.4402 27.8381 65.2858 28.1856C65.0541 28.6103 64.7066 28.4559 64.475 28.1856C64.2819 27.9926 64.0889 27.6451 64.2047 27.3362C64.3591 27.0273 64.7066 27.1818 64.9769 27.2976Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.745 38.1084C75.2856 38.0312 75.9805 38.7648 75.247 38.8806C74.745 38.9578 74.3589 38.147 74.745 38.1084Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0387 30.7724C71.0773 31.6218 69.7259 30.8882 69.8418 30.3863C69.8804 30.1932 70.4595 29.9616 70.614 30.0002C70.8842 30.0774 71.0387 30.5021 71.0387 30.7724Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5714 21.2745C69.5714 21.3903 69.2625 21.7378 69.1467 21.7764C68.915 21.7764 68.3745 21.7378 68.3358 21.5061C68.2586 21.0814 68.4903 20.3092 68.8764 20.5023C69.0308 20.5409 69.61 21.0428 69.5714 21.2745Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.081 32.6645C62.5829 32.5873 62.274 33.3209 62.3512 33.5525C62.3512 33.6297 62.5057 33.7842 62.4671 33.8614C62.4285 33.9386 62.0423 33.9772 61.9651 33.9772C61.6949 33.9386 61.4632 33.4753 61.4246 33.205C61.386 33.0506 61.386 33.0892 61.5018 32.9348C61.6562 32.8575 61.9265 32.7031 62.081 32.6645Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6063 28.1084C58.6835 28.4945 59.6873 28.4559 59.4557 27.9154C59.3398 27.6451 58.5676 27.7609 58.6063 28.1084Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9728 28.7647C64.6678 28.6488 64.3589 27.6064 64.0114 27.6836C63.8956 27.7222 63.3551 27.8766 63.3165 27.9925C63.2779 28.3786 63.4323 28.8419 63.9728 28.7647Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3011 30.5793C59.2239 30.1932 58.2973 30.3091 58.3359 30.5793C58.3745 30.8496 58.5676 31.1585 58.7992 31.1585C59.1081 31.1971 59.3398 30.8882 59.3011 30.5793Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9615 30.4638C71.3862 30.3093 71.5792 30.8885 71.6178 30.3093C71.6564 30.0391 71.4634 29.4985 71.2317 29.3827C70.5754 29.0352 70.1506 30.7726 70.9615 30.4638Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4555 25.8691C70.0733 25.6375 70.3049 24.4792 69.4941 24.6722C68.915 24.8267 68.9922 26.0236 69.4555 25.8691Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9923 19.9617C78.9537 19.8459 78.3746 19.8459 78.2974 19.9231C78.2201 20.039 78.1043 20.5023 78.1815 20.6181C78.2974 20.7725 78.8379 20.7725 78.9923 20.6567C79.1854 20.4251 79.0696 20.1934 78.9923 19.9617Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2627 24.3248C59.2241 24.2089 58.6449 24.2089 58.5677 24.2862C58.4905 24.402 58.3746 24.8653 58.4519 24.9811C58.5677 25.1356 59.1082 25.1356 59.2627 25.0197C59.4557 24.7881 59.3785 24.5564 59.2627 24.3248Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8262 23.6683C65.8262 23.5911 65.6718 23.1278 65.6332 23.0505C65.4788 22.8575 65.0927 23.0505 65.0154 23.2822C64.9768 23.4366 65.1699 23.8227 65.3243 23.9386C65.5174 24.0544 65.8262 23.9386 65.8262 23.6683Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4632 25.9075C61.4632 25.8303 61.3088 25.367 61.2702 25.2897C61.1157 25.0967 60.7296 25.2897 60.6524 25.5214C60.6138 25.6758 60.8068 26.0619 60.9613 26.1778C61.1543 26.3322 61.4632 26.1778 61.4632 25.9075Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6333 20.6567C75.6333 20.3092 74.8997 19.8073 74.5909 20.0389C74.3592 20.1934 74.5522 21.12 74.7453 21.2359C75.0156 21.3903 75.6333 21.3131 75.6333 20.6567Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6717 27.8768C75.4787 27.4907 74.8223 27.3748 74.6679 27.7996C74.4748 28.3015 74.7837 28.6104 75.2084 28.7648C75.7489 28.9192 75.9034 28.2629 75.6717 27.8768Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8842 35.6372C50.4981 35.7917 50.112 34.865 50.7684 34.672C51.4247 34.5175 51.2317 35.5214 50.8842 35.6372Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.274 35.174C72.3512 35.367 72.3126 35.5987 72.2353 35.7531C72.0809 36.1006 71.6948 36.3323 71.3859 35.869C71.1929 35.6373 71.579 35.4056 71.6948 35.2126C71.9265 34.9423 72.1195 34.7879 72.274 35.174Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7875 25.0582C65.9034 25.0196 66.3281 25.174 66.4053 25.2898C66.4825 25.4829 66.637 26.0234 66.4439 26.1392C66.0578 26.3323 65.2856 26.4095 65.3242 25.9848C65.3242 25.8304 65.5945 25.0968 65.7875 25.0582Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6949 29.1121C62.0424 28.9577 62.1582 29.3438 62.0424 29.6141C61.9652 29.8071 61.7721 30.1932 61.5404 30.2704C61.3088 30.309 61.1157 29.9616 61.1157 29.7685C61.1157 29.4982 61.4632 29.228 61.6949 29.1121Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0618 34.6334C56.9074 34.4017 57.4479 34.1701 57.6024 34.0928C57.834 33.977 58.1043 34.1315 58.1043 34.4017C58.1043 34.5562 57.7954 34.865 57.641 34.9423C57.4479 35.0581 57.2163 34.865 57.0618 34.6334Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8185 41.1585C53.664 40.9269 54.2046 40.6952 54.359 40.618C54.5907 40.5021 54.8609 40.6566 54.8609 40.9269C54.8609 41.0813 54.5521 41.3902 54.3976 41.4674C54.166 41.5832 53.9343 41.3902 53.8185 41.1585Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.637 34.4403C66.7528 34.7878 66.4054 35.2897 66.0965 34.865C65.7876 34.4789 66.4826 34.0928 66.637 34.4403Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0349 40.4248C70.1507 40.7723 69.8032 41.2743 69.4943 40.8495C69.1854 40.4634 69.8804 40.0387 70.0349 40.4248Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0773 24.8267C81.1931 25.1742 80.8456 25.6761 80.5367 25.2514C80.2279 24.8653 80.9228 24.4406 81.0773 24.8267Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7529 30.5021C66.9459 31.0427 66.6757 31.8149 66.1737 31.1585C65.9421 30.811 65.9421 30.3091 66.1737 30.116C66.444 29.923 66.6371 30.1932 66.7529 30.5021Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.606 27.6451C68.413 27.9925 69.3396 28.2242 69.5327 28.2242C70.0732 28.1856 69.8029 27.7995 69.6871 27.452C69.6099 27.259 69.5327 26.7956 69.2624 26.7956C68.9921 26.7956 68.7218 27.4134 68.606 27.6451Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5172 22.7417C65.3242 23.0892 66.2508 23.3209 66.4438 23.3209C66.9844 23.2823 66.7141 22.8962 66.5983 22.5487C66.5211 22.3556 66.4438 21.8923 66.1736 21.8923C65.9033 21.8923 65.633 22.5101 65.5172 22.7417Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3279 25.7917C66.1349 26.1392 67.0615 26.3708 67.2546 26.3708C67.7951 26.3322 67.5248 25.9461 67.409 25.5986C67.3318 25.4056 67.2546 24.9422 66.9843 24.9422C66.7526 24.9422 66.4438 25.56 66.3279 25.7917Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1812 32.5484C78.2584 32.394 78.0654 31.7762 78.1812 31.699C78.0654 31.7762 77.7951 31.7376 77.6407 31.8148C77.5248 31.892 77.409 32.0079 77.3318 32.1237C77.1774 32.3553 77.216 32.3553 77.4476 32.5098C77.6407 32.6256 78.0268 32.8959 78.1812 32.5484Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7796 32.3167C73.6638 32.2781 73.0846 32.4712 73.0074 32.5484C72.853 32.7028 72.8144 33.0117 72.8916 33.1662C72.9302 33.2434 73.2005 33.5136 73.2777 33.5523C73.4321 33.5909 73.4321 33.5523 73.5093 33.3978C73.5866 33.282 74.0113 32.394 73.7796 32.3167Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.857 23.012C73.8184 23.3981 74.6678 23.9386 74.9767 23.6298C75.2084 23.3981 74.8609 22.8576 74.745 22.5873C74.6678 22.3942 74.3203 22.3556 74.0114 22.3942C73.7412 22.4328 73.8956 22.7417 73.857 23.012Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9649 30.2318C72.0807 29.421 70.6522 30.0002 70.7294 30.5021C70.7294 30.6952 71.2699 30.9654 71.463 30.9654C71.7333 30.9268 71.9263 30.4635 71.9649 30.2318Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0113 30.2705C63.7024 30.2319 63.4322 29.923 63.0847 30.116C62.8144 30.2705 62.7758 30.5793 62.9689 30.811C63.0847 31.0041 63.4708 31.1971 63.6638 31.1585C63.8955 31.1199 64.2816 30.3091 64.0113 30.2705Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4477 31.7762C67.3705 32.3168 68.6833 32.4712 68.6833 31.6218C68.7219 30.7338 67.525 31.2743 67.4477 31.7762Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7681 36.4094C70.5365 36.3708 70.1504 37.6836 70.9226 37.3361C71.4631 37.1044 71.3087 36.448 70.7681 36.4094Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1234 32.3554C63.0848 32.2782 62.8145 32.3168 62.7373 32.3554C62.5828 32.4326 62.5442 32.587 62.467 32.7415C62.3126 33.089 62.0423 33.6295 62.5442 33.8612C63.5481 34.2859 63.2778 32.8187 63.1234 32.3554Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1118 25.4828C80.0346 25.5214 79.8802 26.062 79.9574 26.1778C80.1504 26.4481 80.691 26.3709 80.7682 26.1006C80.9226 25.5214 80.4979 25.2898 80.1118 25.4828Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1118 29.8072C60.5365 30.1161 61.3473 28.8033 60.7295 28.6875C60.189 28.6103 59.5326 29.4211 60.1118 29.8072Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1813 36.7183C78.6833 36.7956 79.2238 35.9075 78.6061 35.8303C78.1041 35.7145 78.1813 36.7183 78.1813 36.7183Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9882 24.3631C68.4515 24.4403 68.8763 22.9345 67.8724 23.282C67.1002 23.5523 67.1774 24.2473 67.9882 24.3631Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.884 26.3324C60.9226 25.985 60.9998 25.8305 60.8067 25.7533C60.5365 25.6375 60.382 25.6375 60.189 25.9077C59.7257 26.4869 60.884 26.371 60.884 26.3324Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1773 41.5445C57.409 41.1584 57.1001 40.7723 56.8299 40.6564C56.4824 40.4634 56.2507 40.4634 55.9804 40.8881C55.3241 41.7375 56.8685 42.085 57.1773 41.5445Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0422 31.4675C82.0422 31.5447 82.9689 31.5447 83.0075 31.3902C83.2005 30.8883 82.1195 30.8497 82.0422 31.4675Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5596 28.1083C76.6368 27.5677 77.9109 27.7608 77.7179 28.6102C77.5248 29.4596 76.4823 28.6102 76.5596 28.1083Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1157 21.0041C80.9226 20.9655 80.691 20.4636 80.691 20.2706C80.6523 20.0003 80.8068 19.8072 81.1157 19.7686C81.6562 19.73 81.5404 21.0428 81.1157 21.0041Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7643 21.9695C69.8415 21.429 71.1156 21.622 70.9226 22.4714C70.7295 23.3209 69.6871 22.4714 69.7643 21.9695Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0925 28.2629C64.938 28.2243 64.5519 28.3402 64.4747 28.2243C64.2817 28.0313 64.5905 27.7224 64.3203 27.5294C64.0886 27.3749 64.3203 27.2591 64.243 26.9116C64.2044 26.6799 64.8608 26.7958 64.938 26.873C65.1311 27.066 65.1697 27.3363 65.1697 27.6066C65.2083 27.6838 65.2083 28.3016 65.0925 28.2629Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4014 36.6412C65.3628 36.7956 65.6717 36.7956 65.7489 36.8728C65.8647 36.9501 65.8647 37.1817 65.8647 37.2976C65.8647 37.7223 65.5172 37.7223 65.2856 37.452C65.1311 37.2203 64.8222 36.8728 64.8995 36.564C64.9767 36.1779 65.4786 36.1779 65.4014 36.6412Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9304 25.6373C62.4285 25.5601 62.1196 24.5176 62.8918 24.5176C63.2779 24.5176 63.471 25.7145 62.9304 25.6373Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6447 33.8227C58.6061 34.0157 58.3358 33.8613 58.2972 33.7841C58.2586 33.7455 58.0656 33.5138 58.027 33.4752C57.8339 33.2435 57.9498 32.6644 58.1814 32.51C58.5289 32.3169 59.2239 32.3555 59.1467 32.8961C59.108 33.0891 58.9922 33.3208 58.8764 33.4752C58.8378 33.591 58.6833 33.6296 58.6447 33.8227Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1157 25.4443C70.9999 25.3285 70.9227 25.0968 70.9999 24.981C71.0385 24.9038 71.4632 24.7493 71.5404 24.7879C71.6563 24.8266 71.7335 25.2127 71.6949 25.2899C71.6563 25.3671 71.1929 25.5215 71.1157 25.4443Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2431 33.2433C54.552 33.475 54.6292 33.8611 54.3975 34.17C54.1272 34.5561 53.7798 34.363 53.5867 34.0542C53.4323 33.8225 53.3164 33.4364 53.4709 33.2047C53.6639 32.8186 54.0114 33.0889 54.2431 33.2433Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.054 24.8651C64.861 24.8265 64.5521 24.5949 64.4362 24.479C64.359 24.3632 64.4362 23.7841 64.5907 23.7455C64.7451 23.7068 65.054 23.6682 65.1698 23.7841C65.3243 23.9385 65.3629 24.9038 65.054 24.8651Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0809 45.5215C62.6215 45.5601 63.2006 46.3709 62.4284 46.3709C61.9265 46.3323 61.6948 45.4829 62.0809 45.5215Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6485 37.6449C59.5327 38.4557 58.3358 37.5291 58.5288 37.0658C58.6061 36.8727 59.1852 36.7569 59.3783 36.8341C59.6099 36.9499 59.6871 37.4133 59.6485 37.6449Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8028 28.0313C59.7642 28.1471 59.4167 28.456 59.3009 28.456C59.0692 28.4174 58.5287 28.3015 58.5287 28.0699C58.5287 27.6452 58.8762 26.9502 59.2237 27.1432C59.3781 27.2205 59.88 27.8382 59.8028 28.0313Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5365 38.0311C51.0384 38.0311 50.6523 38.726 50.6523 38.9577C50.6523 39.0349 50.7682 39.228 50.7295 39.2666C50.6909 39.3438 50.3048 39.3052 50.2276 39.3052C49.9573 39.228 49.8415 38.7646 49.8415 38.4558C49.8415 38.3013 49.8029 38.3013 49.9573 38.1855C50.0732 38.1469 50.3434 38.0697 50.5365 38.0311Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0193 36.1006C55.6718 36.2936 56.2895 36.9886 56.4826 37.1045C56.9459 37.3747 56.9459 36.9114 57.0231 36.5639C57.0617 36.3709 57.2934 35.9075 57.0231 35.7531C56.8301 35.5987 56.2509 35.9848 56.0193 36.1006Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1738 30.3091C55.8263 30.5022 56.4441 31.1971 56.6371 31.313C57.1004 31.5832 57.1004 31.1199 57.1777 30.7724C57.2163 30.5794 57.4479 30.1161 57.1777 29.9616C56.9846 29.8072 56.4055 30.1933 56.1738 30.3091Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1697 33.2823C54.8222 33.4753 55.44 34.1703 55.633 34.2861C56.0963 34.5564 56.0963 34.0931 56.1736 33.7456C56.2122 33.5525 56.4438 33.0892 56.1736 32.9348C55.9805 32.8189 55.4014 33.1664 55.1697 33.2823Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2701 45.5214C61.4245 45.4441 61.6176 44.8264 61.7334 44.8264C61.579 44.8264 61.3859 44.6333 61.2315 44.5947C61.1157 44.5947 60.9226 44.6333 60.8068 44.6719C60.5751 44.7492 60.5751 44.7878 60.691 45.0194C60.7296 45.2511 60.9226 45.6758 61.2701 45.5214Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.718 42.8573C57.6408 42.7415 57.0617 42.6257 56.9458 42.6257C56.7142 42.6643 56.5211 42.8959 56.5211 43.089C56.5211 43.1662 56.5983 43.5523 56.637 43.6295C56.7142 43.7454 56.7528 43.7068 56.9072 43.6295C57.0231 43.5523 57.8725 43.0504 57.718 42.8573Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9691 35.1739C62.6988 35.4828 63.1235 36.4094 63.5482 36.2936C63.8571 36.2164 63.8957 35.5986 63.9343 35.3284C63.973 35.1353 63.7027 34.9037 63.4324 34.7492C63.2008 34.5948 63.1235 34.9809 62.9691 35.1739Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4168 20.8884C69.2237 20.8112 68.9148 21.3903 68.9148 21.5834C68.9148 21.7378 68.7218 22.317 69.1079 22.4714C69.1851 22.51 69.6484 22.3942 69.7256 22.2398C69.8029 22.0853 69.8415 21.3517 69.8029 21.1587C69.7643 21.0815 69.5326 20.9656 69.4168 20.8884Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3705 40.1161C57.9111 39.4983 56.4439 39.1894 56.1736 39.6528C56.0964 39.8072 56.3667 40.3477 56.5597 40.425C56.83 40.5794 57.2161 40.3091 57.3705 40.1161Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7296 35.7145C50.4979 35.5215 50.4593 35.0968 50.0732 35.0968C49.7643 35.0968 49.5713 35.3284 49.5713 35.5987C49.5713 35.8303 49.7643 36.2164 49.9574 36.2937C50.189 36.3709 50.9612 35.9076 50.7296 35.7145Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7759 38.9193C52.4284 39.3054 53.3937 40.1934 53.8956 39.4598C54.3975 38.7649 53.1234 38.5332 52.7759 38.9193Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4439 29.2282C66.6755 29.3055 67.2933 29.1124 67.2547 28.8035C67.2161 28.5719 66.7528 28.5719 66.5597 28.5333C66.3281 28.4561 66.0964 28.3788 65.942 28.6877C65.7875 28.9194 66.2122 29.151 66.4439 29.2282Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0732 28.7648C60.3049 28.842 60.6137 28.649 60.5365 28.3401C60.4979 28.1084 60.3435 28.0698 60.189 28.0312C59.9574 27.954 59.7257 27.8768 59.5713 28.1857C59.4168 28.4559 59.8801 28.6876 60.0732 28.7648Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2085 31.7377C75.0926 31.4288 74.5907 31.3902 74.4749 31.6605C74.2432 32.2397 75.4401 32.2397 75.2085 31.7377Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9692 44.5947C52.7761 44.4403 51.7336 45.2897 52.5831 45.4441C53.1236 45.5599 53.3553 44.9422 52.9692 44.5947Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8377 36.9501C48.8763 36.8729 48.5675 36.7571 48.5289 36.7571C48.3744 36.7571 48.22 36.8343 48.1041 36.9115C47.7953 37.1046 47.2547 37.4135 47.5636 37.8768C48.1041 38.842 48.7219 37.4521 48.8377 36.9501Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7915 40.6952C66.7143 40.6952 66.2896 41.0427 66.2896 41.1971C66.3282 41.506 66.7915 41.7763 66.9845 41.5832C67.4479 41.1971 67.2162 40.7724 66.7915 40.6952Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0733 22.3556C79.803 22.124 79.0308 22.7417 79.5328 23.0506C79.803 23.1664 80.3436 22.5873 80.0733 22.3556Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5172 25.2127C75.0539 25.7532 75.9419 26.371 76.1736 26.1007C76.2508 25.9849 76.5597 25.5216 76.4825 25.4443C76.2894 25.0582 75.8647 24.788 75.5172 25.2127Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9883 20.8498C78.2586 21.0814 78.915 20.4251 78.7219 20.232C78.5289 20.039 78.1814 19.9231 77.9883 20.0776C77.7567 20.232 77.7567 20.6567 77.9883 20.8498Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9536 48.9577C59.3397 49.3051 60.2664 48.8804 59.8417 48.4557C59.417 48.0696 58.915 48.9577 58.9536 48.9577Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3321 33.0504C57.6795 33.3592 58.8765 32.3554 57.834 32.0851C57.0232 31.8921 56.7143 32.4712 57.3321 33.0504Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3089 24.9424C61.7336 24.981 62.5444 23.5911 61.4633 23.8613C61.1545 23.9385 61.0772 23.9772 61.0386 24.286C61.0386 24.4405 61.1159 24.9424 61.3089 24.9424Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.054 46.7569C65.0154 46.7955 65.7876 47.3361 65.9034 47.2202C66.3281 46.9114 65.4787 46.2936 65.054 46.7569Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3898 40.9268C62.7372 40.5407 63.7025 41.3901 63.0847 41.9693C62.4284 42.5484 62.0423 41.3129 62.3898 40.9268Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4902 32.4712C68.8377 32.0851 69.803 32.9345 69.1852 33.5137C68.5288 34.0928 68.1427 32.8573 68.4902 32.4712Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7604 29.6914C59.1079 29.3053 60.0731 30.1547 59.4554 30.7339C58.8376 31.313 58.4515 30.0775 58.7604 29.6914Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6137 26.8728C70.5751 26.6412 70.7681 26.3709 70.9998 26.2937C71.077 26.2551 71.2701 26.2165 71.3473 26.2551C71.4631 26.2937 71.4245 26.2937 71.4245 26.4095C71.4631 26.564 71.4245 26.9501 71.3473 27.0659C71.1929 27.2589 70.6523 27.1045 70.6137 26.8728Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1118 37.5291C69.9573 37.4133 70.0732 36.8341 70.1504 36.6797C70.2662 36.448 70.4979 36.3322 70.7681 36.4867C71.2701 36.7955 70.4207 37.838 70.1118 37.5291Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1506 32.0466C60.4981 31.6605 61.4633 32.5099 60.8455 33.089C60.1892 33.6682 59.8031 32.4327 60.1506 32.0466Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7373 34.672C52.6601 34.5562 52.274 34.4403 52.2354 34.2859C52.1968 34.0156 52.6215 33.9384 52.5057 33.6295C52.4285 33.3593 52.6601 33.3979 52.7759 33.089C52.8532 32.8959 53.3551 33.3593 53.3937 33.4751C53.4323 33.7454 53.3165 34.0156 53.2007 34.2087C53.162 34.2473 52.8146 34.7492 52.7373 34.672Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.247 24.1703C65.0925 24.0545 65.0153 23.8228 65.0153 23.6298C65.0153 23.2437 65.247 22.8962 65.7489 23.1278C66.0192 23.2823 65.7875 23.6298 65.7489 23.8614C65.6331 24.2475 65.5559 24.4792 65.247 24.1703Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3359 41.8149C48.2201 41.9307 48.4904 42.1238 48.4904 42.201C48.529 42.3554 48.4131 42.5099 48.3359 42.6257C48.1043 42.9732 47.7954 42.7801 47.7954 42.4326C47.7954 42.1624 47.7568 41.6991 47.9498 41.4674C48.2587 41.1971 48.6448 41.4674 48.3359 41.8149Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3359 25.1355C68.4517 25.2513 68.5676 25.3671 68.6834 25.3671C68.8378 25.3285 68.9923 25.4444 69.1081 25.5602C69.4556 25.8305 69.2239 26.1007 68.8764 26.1007C68.6062 26.1007 68.1428 26.0621 67.9498 25.8305C67.6409 25.483 68.027 24.788 68.3359 25.1355Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6988 30.0004C73.0463 29.6143 74.0115 30.4637 73.3938 31.0429C72.7374 31.6606 72.3513 30.3865 72.6988 30.0004Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3397 35.6758C59.3011 35.5214 59.3783 35.2511 59.4941 35.2125C59.5714 35.1739 59.9961 35.2897 60.0733 35.367C60.1505 35.4442 59.9961 35.8303 59.9188 35.8689C59.803 35.9075 59.3397 35.7917 59.3397 35.6758Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7413 31.6219C63.7027 31.4288 63.7799 31.0427 63.9729 31.0041C64.0888 30.9655 64.6679 31.0813 64.7451 31.1972C64.8224 31.313 64.6679 31.8535 64.5521 31.8921C64.3976 31.9694 63.7799 31.7763 63.7413 31.6219Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5907 31.8151C54.4749 31.6993 54.3204 31.3132 54.3204 31.1588C54.3204 31.0043 54.7065 30.5796 54.861 30.6568C55.0154 30.6954 55.3243 30.8499 55.3243 31.0043C55.3629 31.1974 54.861 32.0082 54.5907 31.8151Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5405 27.0273C61.5405 27.1046 60.9999 26.6798 60.9999 26.6412C60.8069 26.4868 60.2663 26.4096 60.2277 26.7571C60.1891 27.2204 61.4632 27.4907 61.5405 27.0273Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8842 30.0004C60.9228 30.0004 60.9228 30.1163 60.9228 30.1163C60.9614 30.1549 61.0386 30.1549 61.0772 30.1549C61.2316 30.1935 61.3089 30.1935 61.4247 30.039C61.5019 29.9618 61.7336 29.7302 61.7336 29.6143C61.7336 29.5757 61.193 29.5757 61.1544 29.5757C61.0386 29.6143 61.0386 29.6143 60.9614 29.6916C60.9228 29.7302 60.8842 30.0004 60.8842 30.0004Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9767 29.8072C64.1659 29.73 64.7836 31.1199 65.2856 31.0427C65.4786 31.0041 65.7489 30.4636 65.7103 30.2705C65.6717 30.0002 65.2469 29.8458 64.9767 29.8072Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4361 26.2164C64.4747 26.3708 64.2045 26.7183 64.0886 26.7956C63.857 26.95 63.6253 26.7183 63.5481 26.5639C63.4709 26.4095 63.4323 26.062 63.7025 25.9847C63.9342 25.8689 64.4361 25.9461 64.4361 26.2164Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.946 28.842C56.9074 29.4211 55.9421 29.9231 55.8263 29.0736C55.6719 28.2628 56.9846 28.1856 56.946 28.842Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3589 24.3247C64.4362 24.4019 64.359 25.0583 64.2817 25.1355C64.1659 25.2899 63.8184 25.0583 63.6254 24.9424C63.2779 24.7108 63.3551 24.4405 63.7412 24.2861C63.8956 24.2474 64.2045 24.2088 64.3589 24.3247Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0771 30.4249C80.7296 30.116 80.6524 29.5755 81.2315 29.8844C81.8107 30.1546 81.4632 30.7724 81.0771 30.4249Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8648 37.7608C55.5559 38.0311 56.3281 38.5716 56.5212 38.6488C57.0617 38.8033 56.9459 38.3785 56.9459 37.9924C56.9459 37.7994 57.0617 37.2975 56.7914 37.2202C56.5212 37.1044 56.0578 37.6063 55.8648 37.7608Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.745 32.0466C54.4362 32.3168 55.2084 32.8574 55.4014 32.9346C55.9419 33.089 55.8261 32.6643 55.8261 32.2782C55.8261 32.0852 55.9419 31.5832 55.6717 31.506C55.44 31.4288 54.9381 31.8921 54.745 32.0466Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4363 35.2126C54.1274 35.4829 54.8996 36.0234 55.0927 36.1006C55.6332 36.2551 55.5174 35.8304 55.5174 35.4443C55.5174 35.2512 55.6332 34.7493 55.363 34.6721C55.0927 34.5562 54.5908 35.0582 54.4363 35.2126Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0077 45.7915C63.1622 45.6757 63.2008 45.0193 63.3166 44.9807C63.2008 45.0193 62.9305 44.8649 62.7761 44.8649C62.6602 44.8649 62.4672 44.9807 62.3513 45.0579C62.1197 45.2124 62.1583 45.2124 62.3127 45.444C62.4672 45.6757 62.7374 46.0618 63.0077 45.7915Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9922 44.0156C58.8764 43.9384 58.2972 43.8998 58.1814 43.9384C57.9884 44.0156 57.8339 44.2859 57.8725 44.4789C57.9111 44.5561 58.027 44.9422 58.1042 44.9808C58.22 45.0967 58.2586 45.0581 58.3745 44.9422C58.4903 44.8264 59.1853 44.1314 58.9922 44.0156Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4286 35.3671C62.2355 35.7146 62.8147 36.5254 63.2394 36.3323C63.5483 36.1779 63.3938 35.5601 63.3938 35.2898C63.3938 35.0582 63.0849 34.9037 62.7761 34.8265C62.5444 34.7493 62.583 35.1354 62.4286 35.3671Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0656 41.3902C58.4517 40.6566 56.9459 40.6952 56.7915 41.1972C56.7528 41.3902 57.1389 41.8535 57.332 41.8921C57.6023 41.9308 57.9498 41.6219 58.0656 41.3902Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6137 38.533C50.3435 38.3786 50.2276 37.9925 49.8029 38.0697C49.5326 38.1083 49.3396 38.4172 49.4168 38.6875C49.4554 38.9191 49.7257 39.228 49.9574 39.2666C50.2276 39.3052 50.884 38.6875 50.6137 38.533Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3164 41.2356C53.0461 41.6989 54.2044 42.3167 54.5519 41.5445C54.8608 40.6951 53.548 40.7723 53.3164 41.2356Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.552 28.8034C64.7836 28.842 65.3628 28.4946 65.2469 28.2243C65.1697 28.0312 64.7064 28.1085 64.5133 28.1085C64.2817 28.1085 64.0114 28.0698 63.9342 28.3787C63.8184 28.649 64.2817 28.7648 64.552 28.8034Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2201 29.7298C58.4518 29.7684 58.722 29.4982 58.5676 29.2279C58.4904 29.0348 58.3359 29.0348 58.1429 28.9962C57.9112 28.9962 57.641 28.9576 57.5637 29.2665C57.5251 29.5754 57.9884 29.6912 58.2201 29.7298Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6255 29.3438C73.4324 29.0735 72.9305 29.1508 72.8919 29.421C72.8147 30.0388 73.973 29.7685 73.6255 29.3438Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7449 46.7182C54.5519 46.6024 53.7025 47.6835 54.5519 47.6449C55.0924 47.6063 55.2083 46.9885 54.7449 46.7182Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0693 40.1933C49.0693 40.1161 48.799 40.0775 48.7218 40.0775C48.5673 40.1161 48.4515 40.2319 48.3357 40.3478C48.0654 40.618 47.6021 41.0427 48.0268 41.4288C48.7604 42.1624 49.0307 40.6952 49.0693 40.1933Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3705 39.8844C67.2933 39.8844 66.9458 40.3478 66.9844 40.5022C67.0616 40.8111 67.6022 40.9655 67.7566 40.7339C68.1041 40.2705 67.7952 39.8844 67.3705 39.8844Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5056 22.896C72.1581 23.5138 73.162 23.9385 73.3164 23.6296C73.3936 23.5138 73.5867 23.0118 73.4709 22.896C73.2006 22.5485 72.7759 22.3941 72.5056 22.896Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5018 49.6912C61.9652 49.9615 62.776 49.3437 62.2354 48.9962C61.8107 48.7259 61.5018 49.6912 61.5018 49.6912Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4825 34.4789C56.8686 34.7105 57.8339 33.475 56.7914 33.4364C55.942 33.4364 55.749 34.0928 56.4825 34.4789Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5674 25.7146C58.9921 25.6374 59.4555 24.1316 58.4902 24.6335C58.2199 24.7879 58.1427 24.8265 58.1813 25.1354C58.2199 25.2899 58.3744 25.7532 58.5674 25.7146Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0231 46.2165C66.9845 46.2551 67.8725 46.6412 67.9497 46.4867C68.2972 46.062 67.2933 45.6759 67.0231 46.2165Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1233 41.0812C63.3936 40.6179 64.5133 41.2356 64.0113 41.9692C63.5094 42.6642 62.853 41.5445 63.1233 41.0812Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2548 31.5061C67.525 31.0428 68.6447 31.6606 68.1428 32.3941C67.6409 33.0891 66.9845 31.9694 67.2548 31.5061Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1388 30.8881C57.4091 30.4248 58.5288 31.0426 58.0269 31.7762C57.5635 32.5097 56.9072 31.3514 57.1388 30.8881Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.104 25.5988C68.0268 25.3671 68.1426 25.0583 68.3357 24.9424C68.4129 24.9038 68.5673 24.8266 68.6446 24.8266C68.7604 24.8266 68.7218 24.8266 68.7604 24.9424C68.799 25.0969 68.8762 25.4443 68.8376 25.5988C68.7604 25.8304 68.1812 25.7918 68.104 25.5988Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9189 36.1006C69.7258 35.9848 69.7258 35.4443 69.7644 35.2898C69.8417 35.0195 70.0347 34.9037 70.3436 34.9809C70.8841 35.1354 70.305 36.2937 69.9189 36.1006Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9922 32.896C59.2625 32.4327 60.3822 33.0505 59.8803 33.784C59.4169 34.479 58.7606 33.3593 58.9922 32.896Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3514 37.0657C52.2355 36.9885 51.8108 36.9499 51.7722 36.7954C51.6564 36.5638 52.0811 36.3707 51.888 36.1005C51.7336 35.8688 52.0039 35.8302 52.0425 35.5213C52.0811 35.2897 52.6602 35.6371 52.6988 35.753C52.8147 36.0232 52.7375 36.2935 52.6602 36.5252C52.6602 36.6024 52.4672 37.1815 52.3514 37.0657Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.61 45.0193C49.5328 45.1738 49.803 45.2896 49.8416 45.3668C49.9189 45.4827 49.8416 45.6757 49.803 45.8301C49.6486 46.2162 49.3397 46.1004 49.2239 45.7529C49.1466 45.4827 49.0308 45.0193 49.1853 44.7877C49.4169 44.4402 49.8416 44.5946 49.61 45.0193Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4786 24.3631C65.633 24.4403 65.7488 24.5561 65.8647 24.5175C66.0191 24.4403 66.1735 24.5561 66.328 24.5947C66.7141 24.7878 66.5596 25.0967 66.2122 25.1739C65.9419 25.2125 65.4786 25.2897 65.2469 25.1353C64.8994 24.9036 65.0925 24.0928 65.4786 24.3631Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2701 33.8227C50.8454 33.5911 50.9226 32.4714 51.6176 32.7802C52.0423 32.9347 51.7721 34.093 51.2701 33.8227Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8068 28.1854C71.077 27.7221 72.1967 28.3399 71.6948 29.0735C71.1929 29.7684 70.5365 28.6488 70.8068 28.1854Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9921 36.6411C58.9149 36.5253 58.9535 36.2164 59.0307 36.1778C59.1079 36.1392 59.5326 36.1392 59.6099 36.2164C59.6871 36.2936 59.6485 36.6797 59.5713 36.7569C59.5326 36.7569 59.0307 36.7183 58.9921 36.6411Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4285 31.699C62.3513 31.5059 62.3513 31.1198 62.5058 31.0426C62.6216 30.9654 63.2393 30.9654 63.3166 31.0812C63.4324 31.197 63.3552 31.7376 63.278 31.8148C63.1621 31.892 62.5058 31.8534 62.4285 31.699Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5481 33.8997C53.3936 33.8225 53.162 33.475 53.1233 33.3205C53.0847 33.1661 53.355 32.7028 53.5481 32.7028C53.7025 32.7414 54.0114 32.78 54.0886 32.9344C54.1272 33.1275 53.8183 34.0155 53.5481 33.8997Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3165 52.0465C43.8184 52.2782 44.0501 53.2434 43.3551 52.9731C42.8918 52.8187 42.969 51.9307 43.3165 52.0465Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2625 27.7223C59.2625 27.7995 58.6833 27.4906 58.6447 27.4906C58.4131 27.3748 57.8725 27.452 57.9111 27.7995C57.9884 28.1856 59.3011 28.1856 59.2625 27.7223Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.301 30.7337C59.3396 30.7337 59.3396 30.8495 59.3396 30.8495C59.3782 30.8882 59.4554 30.8495 59.494 30.8495C59.6871 30.8495 59.7257 30.8109 59.8029 30.6565C59.8415 30.5793 60.0346 30.2704 60.0346 30.1932C60.0346 30.1546 59.494 30.2704 59.4554 30.2704C59.3396 30.309 59.3396 30.309 59.301 30.4248C59.2624 30.5021 59.2624 30.7337 59.301 30.7337Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2394 29.6913C62.4286 29.8071 63.3552 31.004 63.8185 30.811C64.0116 30.7338 64.1274 30.1546 64.0502 29.9616C63.973 29.7299 63.5097 29.6527 63.2394 29.6913Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9265 26.2552C61.9651 26.371 61.8107 26.7957 61.7334 26.8729C61.5404 27.1046 61.2701 26.9115 61.1543 26.7571C61.0385 26.6027 60.9226 26.2938 61.1929 26.1394C61.386 26.0621 61.8493 26.0235 61.9265 26.2552Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1697 30.5023C55.2469 31.0814 54.4361 31.7764 54.1272 30.9656C53.8183 30.1934 55.0925 29.8459 55.1697 30.5023Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4245 24.4789C61.5017 24.5561 61.5789 25.2125 61.5403 25.2897C61.4245 25.4828 61.077 25.3283 60.8839 25.2511C60.4978 25.0967 60.5364 24.8264 60.8453 24.5947C60.9611 24.4789 61.27 24.3631 61.4245 24.4789Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0694 26.757C78.6833 26.564 78.4903 26.0234 79.108 26.1779C79.7258 26.3323 79.5327 27.0273 79.0694 26.757Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3281 42.7028C66.3281 42.7801 66.4825 42.2395 66.4825 42.2395C66.2895 42.0465 65.7489 41.9307 65.6331 42.2781C65.5559 42.7415 66.2509 43.2434 66.3281 42.7028Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7644 32.0853C59.8803 31.5061 59.3397 31.815 59.1467 31.9695C58.9922 32.1239 58.5675 32.51 58.5289 32.7416C58.4517 33.1277 58.9536 33.1664 59.2239 33.0505C59.4942 32.8961 59.6872 32.3942 59.7644 32.0853Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0113 46.757C44.436 46.8342 44.2816 47.452 44.6677 47.0272C44.8221 46.8342 45.0152 46.2937 44.8607 46.0234C44.5133 45.367 43.2005 46.5639 44.0113 46.757Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8415 26.1008C69.4554 25.8305 69.0693 26.1394 68.9148 26.3711C68.7218 26.7185 68.6832 26.9502 69.0693 27.2591C69.8801 27.9154 70.3434 26.4483 69.8415 26.1008Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.274 34.9424C62.6215 34.7493 62.6987 34.9424 62.6987 34.4791C62.6987 34.093 62.5829 34.0157 62.2354 34.1316C61.7335 34.3246 61.5018 35.3671 62.274 34.9424Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7757 33.2822C52.7371 33.0506 51.9649 32.8189 51.7333 32.7803C51.3472 32.7031 51.1927 32.9348 51.3086 33.3209C51.4244 33.8228 52.853 34.0158 52.7757 33.2822Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7566 38.7648C57.5249 38.6104 57.5636 38.6104 57.2547 38.6876C56.9458 38.7648 56.9844 38.8806 57.1388 39.1509C57.2547 39.3439 57.6022 39.4984 57.8724 39.3826C58.0655 39.2667 57.911 38.842 57.7566 38.7648Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0809 38.1471C52.0037 37.8768 50.6523 37.6451 50.9226 38.3401C51.0384 38.6104 51.2315 38.7262 51.4631 38.7262C51.6176 38.7262 52.1581 38.3787 52.0809 38.1471Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3627 42.1239C46.019 42.2783 46.8298 41.4289 46.0576 41.1586C45.4785 40.9656 44.8607 42.0081 45.3627 42.1239Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5209 42.5484C56.5595 42.4326 56.0962 42.0851 55.9804 42.1237C55.8646 42.1623 55.4785 42.4712 55.4785 42.6256C55.4785 42.8187 55.9418 43.1276 56.1348 43.0889C56.4437 43.0503 56.4823 42.8187 56.5209 42.5484Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3936 41.2743C53.6253 40.9654 53.2778 40.1932 52.8531 40.1546C52.5828 40.1546 52.2353 41.004 52.3125 41.2357C52.467 41.5445 53.0075 41.8148 53.3936 41.2743Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8492 38.9577C61.9264 38.9577 62.0422 38.4172 61.8878 38.3786C61.3858 38.1469 61.27 38.8419 61.8492 38.9577Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3782 47.2588C49.4168 46.8341 48.9535 46.3708 48.606 46.6411C48.1427 46.9499 48.2585 47.3746 48.5288 47.7607C48.8377 48.1855 49.3396 47.7221 49.3782 47.2588Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1927 40.618C70.6908 40.5022 70.9611 39.228 71.7719 39.4983C72.6213 39.7686 71.6947 40.7338 71.1927 40.618Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4283 51.4288C42.3897 51.6218 42.2353 51.7763 42.0809 51.8921C41.7334 52.0851 41.3087 52.0465 41.3087 51.506C41.3087 51.1971 41.7334 51.2357 41.9264 51.1585C42.3125 51.0427 42.5442 51.0041 42.4283 51.4288Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4862 37.6837C47.4476 37.8768 47.2932 38.0312 47.1387 38.147C46.7912 38.3401 46.3665 38.3015 46.3665 37.7609C46.3665 37.4521 46.7912 37.4907 46.9843 37.4135C47.3318 37.2976 47.5634 37.259 47.4862 37.6837Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8299 28.9193C56.9843 28.8035 57.409 28.8421 57.4862 28.7649C57.6021 28.649 57.8723 28.649 58.0268 28.649C58.5287 28.6876 58.4901 29.1123 58.1426 29.344C57.8723 29.4984 57.409 29.8073 57.0615 29.7301C56.5982 29.5757 56.4438 29.1896 56.8299 28.9193Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0576 34.6335C56.1735 34.4791 56.0576 34.0543 56.0576 34.0543C55.8646 33.8613 55.324 33.7455 55.2082 34.093C55.0924 34.5563 55.8646 34.9424 56.0576 34.6335Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4785 36.9886C55.5171 36.8728 55.7487 36.4095 55.9418 36.4867C56.1734 36.5639 56.0962 36.9886 56.019 37.1817C55.9804 37.3361 55.7873 37.7995 55.5943 37.7608C55.4785 37.6836 55.4785 37.1045 55.4785 36.9886Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3086 28.3402C61.5403 28.0699 61.965 28.0313 62.2353 28.263C62.6214 28.5719 62.3897 28.8807 62.0422 29.0738C61.8106 29.1896 61.4245 29.3054 61.1542 29.1124C60.8839 28.8421 61.1542 28.5332 61.3086 28.3402Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2044 21.5447C74.2816 21.0042 75.131 20.5023 75.0924 21.2359C75.0152 21.7378 74.1658 21.8922 74.2044 21.5447Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1735 23.2821C66.9843 23.4752 65.9418 24.5949 65.4785 24.3632C65.2855 24.286 65.2082 23.6682 65.3241 23.5138C65.4399 23.2821 65.9032 23.2435 66.1735 23.2821Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.826 32.4327C65.8646 31.9307 66.521 32.3941 66.7526 32.3941C66.8299 32.3941 67.0229 32.3168 67.1001 32.3554C67.1773 32.3941 67.1001 32.7802 67.1001 32.8574C66.9843 33.089 66.521 33.2049 66.2507 33.1663C66.0963 33.1663 66.0963 33.1663 66.019 33.0118C65.8646 32.896 65.7874 32.5871 65.826 32.4327Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5557 47.7609C55.4785 48.1083 54.8607 48.34 54.8607 47.7995C54.8221 47.3361 55.6329 47.3748 55.5557 47.7609Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5133 36.4865C54.8608 36.5637 55.2855 35.637 54.6678 35.637C54.3975 35.5984 54.2044 36.4092 54.5133 36.4865Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2934 31.8149C57.4478 31.1199 56.3667 31.0041 56.3281 31.3516C56.2895 31.4674 56.2509 32.0466 56.3667 32.0852C56.6756 32.3168 57.1389 32.3554 57.2934 31.8149Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1003 36.8341C56.7528 36.7569 56.4439 37.6449 56.7142 37.7222C56.9458 37.7994 57.3319 37.7608 57.4478 37.5291C57.5636 37.2588 57.3705 36.9114 57.1003 36.8341Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7527 38.4943C46.3666 38.1468 45.6716 39.6912 46.328 39.7298C46.8299 39.7684 47.0616 38.7645 46.7527 38.4943Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6177 26.1005C61.6177 25.6758 62.274 25.7144 61.7721 25.4055C61.5404 25.2897 60.9999 25.2125 60.7682 25.4055C60.1891 25.9075 61.579 26.9499 61.6177 26.1005Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3163 43.1661C43.3163 43.5136 43.6252 43.5908 43.8182 43.668C44.0885 43.7838 44.2429 43.7452 44.436 43.4363C44.8221 42.78 43.3163 43.1275 43.3163 43.1661Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5827 49.4981C42.4283 49.305 42.5441 49.2278 42.2739 49.305C42.0422 49.3436 42.0422 49.4209 42.1194 49.6139C42.2739 49.8842 42.8916 49.8842 42.5827 49.4981Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7179 53.0502C57.5635 52.8958 57.1774 53.0502 57.1002 53.1274C56.7141 53.4749 57.0229 53.7066 57.3704 53.668C57.5249 53.668 57.7951 53.668 57.8724 53.5135C58.0654 53.2046 57.8338 53.166 57.7179 53.0502Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4399 42.4326C55.4399 41.8921 54.1657 41.8535 54.2044 42.7415C54.2816 43.5909 55.4399 42.9345 55.4399 42.4326Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3473 34.3631C51.2315 34.3631 50.9612 34.865 51.0384 34.9809C51.1157 35.0967 51.4631 35.4056 51.6176 35.367C51.8106 35.3284 52.0037 34.8264 51.9651 34.6334C51.8492 34.3631 51.579 34.3631 51.3473 34.3631Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.664 32.973C53.5868 32.9344 53.1234 32.8958 53.0462 32.8958C52.8145 32.973 52.8146 33.3977 53.0076 33.5522C53.1234 33.668 53.5868 33.6294 53.7412 33.5522C53.9342 33.4364 53.8956 33.0889 53.664 32.973Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6948 57.4132C51.6176 57.3746 51.2701 57.336 51.1929 57.3746C50.9998 57.4518 50.9998 57.7607 51.1543 57.8765C51.2701 57.9537 51.6176 57.9537 51.7334 57.8765C51.8878 57.7607 51.8492 57.4904 51.6948 57.4132Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0384 39.1505C51.0384 39.1119 50.8839 38.7644 50.6909 38.7644C50.4592 38.803 50.1889 39.1891 50.1503 39.3049C50.0731 39.6138 50.5364 39.7683 50.8453 39.6138C50.9611 39.5366 51.0384 39.3435 51.0384 39.1505Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3511 59.6138C42.3511 59.5366 41.4245 59.6138 41.3859 59.7683C41.3086 60.3088 42.3511 60.2316 42.3511 59.6138Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.104 46.5637C47.911 46.9112 48.7218 47.2201 48.8376 46.6795C48.9148 46.4093 48.9921 46.2934 48.6832 46.332C48.5674 46.332 48.1813 46.4093 48.104 46.5637Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3357 46.6025C58.3357 47.0272 57.3319 46.9886 57.4091 46.2936C57.5249 45.6372 58.3743 46.2164 58.3357 46.6025Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4825 26.8341C66.6756 26.8341 66.8686 26.95 67.0231 27.1044C67.2933 27.4133 67.3319 27.838 66.7914 27.9538C66.4825 28.031 66.4439 27.6063 66.3281 27.4133C66.135 27.0272 66.0964 26.7955 66.4825 26.8341Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4632 52.664C51.386 52.7798 51.1544 52.7798 51.0385 52.7798C50.6138 52.7798 50.6138 52.4324 50.8841 52.2007C51.1157 52.0463 51.1544 51.969 51.4246 52.0076C51.8107 52.1235 51.5018 52.5868 51.4632 52.664Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2817 46.4865C44.3203 46.3707 44.6292 46.0232 44.745 46.0232C44.9767 46.0232 45.5172 46.1004 45.5558 46.3321C45.5944 46.7568 45.3242 47.4904 44.9767 47.2973C44.7836 47.2201 44.2431 46.6795 44.2817 46.4865Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8067 43.668C50.7294 43.5908 50.6522 43.1274 50.7294 43.0502C50.8839 42.8958 51.27 42.4711 51.463 42.5869C51.8105 42.8186 52.2738 43.4749 51.8877 43.6294C51.7333 43.7066 50.9611 43.8224 50.8067 43.668Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7142 34.0542C56.7142 33.6681 57.1389 33.7067 57.2934 33.9383C57.4092 34.0928 57.7181 34.4403 57.6795 34.6333C57.6409 34.865 57.2162 34.9036 57.0231 34.8264C56.7914 34.7491 56.6756 34.3244 56.7142 34.0542Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8802 40.5019C59.6099 40.5405 59.6099 39.9613 59.6099 39.7683C59.6099 39.498 59.8416 39.305 60.1119 39.4594C60.2663 39.5366 60.4207 39.9227 60.4207 40.1158C60.4593 40.3474 60.1505 40.4633 59.8802 40.5019Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5519 46.1003C64.2817 46.1389 64.2817 45.5598 64.2817 45.3667C64.2817 45.0965 64.5133 44.9034 64.7836 45.0578C64.938 45.1351 65.0925 45.5212 65.0925 45.7142C65.0925 45.9459 64.8222 46.1003 64.5519 46.1003Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1581 37.6834C52.1581 37.3359 53.162 37.4518 53.2778 37.722C53.3937 38.1854 52.1195 38.6487 52.1581 37.6834Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9072 51.7374C47.1774 51.8919 47.1388 52.7027 46.7913 52.5482C46.6369 52.471 46.6755 51.583 46.9072 51.7374Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4901 41.6604C48.7218 41.5831 49.1079 42.2009 49.0306 42.3553C49.0306 42.3939 48.5287 42.78 48.5673 42.8187C48.4901 42.78 48.104 42.3553 48.104 42.2781C48.1426 42.0078 48.2198 41.7762 48.4901 41.6604Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0885 47.8764C54.5132 47.8764 55.131 48.3398 54.5132 48.4942C53.8954 48.61 53.5866 47.8378 54.0885 47.8764Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5479 31.6989C63.8954 31.6989 64.2429 32.2781 63.741 32.3939C63.2391 32.4711 63.1619 31.6603 63.5479 31.6989Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3821 30.9268C70.7296 30.9268 71.0771 31.5059 70.5751 31.6217C70.0732 31.7376 69.996 30.9268 70.3821 30.9268Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9959 29.9615C60.575 30.0001 61.1542 30.5793 60.3434 30.7723C59.9573 30.8496 59.4553 30.6565 59.4167 30.3476C59.3781 30.0387 59.687 29.9615 59.9959 29.9615Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5868 39.8074C53.5868 39.9618 53.9343 40.3479 53.8957 40.4251C53.9343 40.3093 54.1659 40.2707 54.2432 40.1549C54.3204 40.0776 54.359 39.9232 54.359 39.8074C54.3976 39.6143 54.3976 39.6143 54.1659 39.5757C53.9729 39.5757 53.5868 39.5371 53.5868 39.8074Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6987 50.7726C42.6987 50.5409 42.0423 50.5023 41.8493 50.5409C41.7334 50.6182 41.1157 50.6568 41.1157 51.0429C41.1157 51.1201 41.3859 51.5062 41.5404 51.5448C41.6948 51.5448 42.3898 51.3131 42.5442 51.1973C42.6987 51.1587 42.6987 50.927 42.6987 50.7726Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6099 45.483C49.6099 45.7147 50.0346 46.2166 50.3048 46.0621C50.4979 45.9463 50.3435 45.5216 50.3048 45.3286C50.2662 45.0969 50.2662 44.8266 49.9187 44.788C49.6871 44.7494 49.6485 45.2513 49.6099 45.483Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2122 45.0967C56.0577 45.1353 55.7489 45.5214 55.9033 45.6758C56.0191 45.7917 56.328 45.5986 56.4438 45.56C56.5983 45.4828 56.7913 45.4442 56.7527 45.2125C56.7141 44.9809 56.3666 45.0581 56.2122 45.0967Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.324 61.2358C45.4398 60.8883 44.5518 60.3864 44.5132 60.9655C44.4746 61.2744 45.2082 61.5447 45.324 61.2358Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9418 58.7262C45.826 59.0736 46.6754 59.4598 46.7912 59.1895C46.8684 58.9578 46.8684 58.5717 46.6754 58.4559C46.4051 58.2628 46.0576 58.4559 45.9418 58.7262Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9379 50.5795C44.8221 50.927 45.6715 51.3131 45.7874 51.0429C45.8646 50.8112 45.8646 50.4251 45.6715 50.3093C45.4013 50.1548 45.0538 50.3093 44.9379 50.5795Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3857 35.2899C51.6946 35.4058 51.8877 35.1355 52.0035 34.9424C52.1966 34.7108 52.1966 34.5563 51.9649 34.2861C51.463 33.7455 51.3471 35.2899 51.3857 35.2899Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1774 37.9155C56.9843 37.9927 56.9071 37.8769 56.9071 38.1471C56.8685 38.3788 56.9457 38.4174 57.1774 38.3788C57.4477 38.3402 57.6407 37.7224 57.1774 37.9155Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3551 43.8226C53.4709 43.8612 53.9729 43.4365 54.0115 43.3593C54.0501 43.089 53.7798 42.5099 53.3937 42.6643C53.0462 42.7416 53.0076 43.7068 53.3551 43.8226Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6368 39.3053C46.7526 39.6914 48.3356 39.9231 47.7179 39.0736C47.5248 38.8034 47.4862 38.7648 47.1773 38.842C47.0229 38.8806 46.5596 39.1123 46.6368 39.3053Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7951 43.591C47.8337 43.8612 49.1464 44.2473 48.992 43.5524C48.9148 43.2821 48.7603 43.1276 48.49 43.089C48.3356 43.0504 47.7564 43.3593 47.7951 43.591Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0962 45.9076C45.9032 46.0234 45.9418 46.4095 45.9804 46.5254C46.212 46.9887 46.5209 46.757 46.5981 46.4095C46.6368 46.2551 46.6368 45.5601 46.5209 45.4057C46.2893 45.1354 46.2893 45.8304 46.0962 45.9076Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1696 24.595C64.9766 24.7108 65.0152 25.0969 65.0538 25.2127C65.2855 25.6761 65.5943 25.4444 65.6716 25.0969C65.7102 24.9425 65.7874 24.7108 65.6716 24.595C65.4399 24.2861 65.3241 24.5178 65.1696 24.595Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4864 31.6605C67.4478 31.6991 67.2933 32.0466 67.2933 32.1238C67.2933 32.3169 67.6022 32.3941 67.7953 32.3169C67.9111 32.2396 67.9883 31.8921 67.9497 31.7763C67.8725 31.5833 67.6408 31.506 67.4864 31.6605Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9341 41.4676C43.4321 41.5448 43.6638 42.3556 43.8182 42.4328C44.0499 42.5873 44.3974 42.3942 44.436 42.0854C44.4746 41.8151 44.243 41.429 43.9341 41.4676Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7528 41.1972C66.7142 41.1586 66.4825 42.0852 66.637 42.1624C67.1003 42.4327 67.332 41.3902 66.7528 41.1972Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6909 41.3516C61.1928 41.5446 60.9997 40.5407 60.6909 40.5021C60.575 40.5021 60.3048 40.7724 60.3048 40.9268C60.2661 41.0813 60.5364 41.2743 60.6909 41.3516Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0577 31.7379C56.328 32.0081 56.8685 31.3518 56.4052 31.0429C56.1735 30.8884 56.0577 30.7726 56.0191 31.0815C56.0191 31.2745 55.9419 31.6606 56.0577 31.7379Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8918 30.4252C62.969 30.541 62.9304 30.734 62.8918 30.8885C62.7373 31.3132 62.4284 31.1974 62.3126 30.8499C62.2354 30.5796 62.1582 30.541 62.3126 30.2707C62.5057 29.9232 62.8532 30.3479 62.8918 30.4252Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4012 61.7762C55.517 61.4673 56.3279 61.3514 56.212 61.8534C56.1348 62.1236 55.2854 62.1236 55.4012 61.7762Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0346 54.5947C50.1505 54.5175 50.4207 54.4789 50.498 54.5561C50.5366 54.6333 50.6138 55.058 50.5752 55.1353C50.498 55.2125 50.1119 55.2511 50.0346 55.1739C49.996 55.1353 49.9574 54.6719 50.0346 54.5947Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3049 40.4636C50.4207 40.5794 50.7296 40.8497 50.6138 40.9269C50.5365 41.0042 50.2663 41.5447 49.9574 41.4289C49.5713 41.2744 49.4169 40.7339 49.4555 40.6567C49.5327 40.5794 50.2277 40.3864 50.3049 40.4636Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2083 53.6682C45.7103 53.8613 45.2855 55.0582 44.4747 54.7107C43.6639 54.3246 44.7064 53.5138 45.2083 53.6682Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4169 37.9155C49.2624 38.0313 48.9535 38.0699 48.7991 37.9927C48.6447 37.8769 48.7605 37.2977 48.8763 37.2205C48.9535 37.1433 49.3783 37.0661 49.4555 37.1433C49.5713 37.2205 49.4941 37.9541 49.4169 37.9155Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.857 49.035C54.1659 49.1508 53.9342 49.4597 53.6639 49.3439C53.5867 49.3053 53.4709 49.1894 53.5095 49.0736C53.5481 48.9964 53.7412 48.9964 53.857 49.035Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3008 49.1894C49.1464 49.6913 47.8336 50.3091 47.9881 49.5755C48.1039 49.1122 49.378 48.8419 49.3008 49.1894Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6367 52.8187C56.5209 53.2048 55.5557 53.6295 55.6715 53.0889C55.7487 52.7414 56.714 52.5484 56.6367 52.8187Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6253 47.5679C43.8183 47.0273 44.6291 47.5679 44.7064 47.9154C44.9766 48.8034 43.3164 48.3787 43.6253 47.5679Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9225 46.6413C61.2314 46.7571 60.768 47.1046 60.6136 47.0274C60.5364 46.9888 60.5364 46.7571 60.575 46.7185C60.6522 46.6027 60.8453 46.6027 60.9225 46.6413Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2546 42.0852C47.1773 42.201 46.4824 42.3941 46.3665 42.3555C46.1349 42.2783 46.2507 41.8535 46.2893 41.6219C46.4051 41.1972 46.714 41.12 47.0229 41.4674C47.1387 41.5447 47.3318 41.8922 47.2546 42.0852Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8221 35.4056C54.7063 35.367 54.4747 34.9423 54.5133 34.8265C54.5905 34.6335 54.8221 34.0929 55.0538 34.1701C55.4785 34.286 56.0963 34.7493 55.7874 35.0196C55.6716 35.1354 55.0152 35.4829 54.8221 35.4056Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6522 34.479C60.8839 34.2474 61.656 34.5563 61.3858 34.8265C61.2699 34.981 60.4205 34.6721 60.6522 34.479Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.108 26.487C59.2624 26.0623 59.8802 25.6376 59.803 26.2553C59.7643 26.8731 58.9535 26.9503 59.108 26.487Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8531 51.7377C43.5094 51.4674 42.9689 50.5021 42.66 50.6566C42.5442 50.6952 42.0809 51.0041 42.0809 51.1199C42.1195 51.5446 42.3511 51.9693 42.8531 51.7377Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3127 32.7414C62.3513 32.78 62.081 32.3167 62.081 32.3167C61.8107 32.3167 61.3474 32.6256 61.5405 32.9344C61.7721 33.3591 62.5829 33.1661 62.3127 32.7414Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0346 51.8147C50.3821 51.583 50.7296 52.0849 50.6523 51.5058C50.6137 51.2355 50.3435 50.7722 50.0732 50.695C49.3396 50.5405 49.3396 52.3166 50.0346 51.8147Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5481 36.3323C53.2779 36.4095 53.2779 36.3709 53.162 36.6412C53.0076 36.9114 53.1234 36.9886 53.4323 37.0273C53.6254 37.0659 54.0115 36.9114 54.0887 36.6412C54.1659 36.4481 53.7026 36.2937 53.5481 36.3323Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2624 40.0774C48.9921 39.9616 47.911 40.811 48.606 41.0813C48.8763 41.1971 49.1079 41.1199 49.2624 40.9655C49.3782 40.7724 49.4554 40.1546 49.2624 40.0774Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5634 47.6835C48.104 47.2974 48.0653 46.1391 47.3318 46.5252C46.7912 46.7954 47.1387 47.9537 47.5634 47.6835Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4787 39.8071C55.4015 39.7299 54.8609 39.8071 54.7837 39.9229C54.7451 40.0387 54.7065 40.5407 54.8223 40.6179C54.9768 40.7337 55.5173 40.6179 55.5945 40.4635C55.7876 40.2318 55.6331 40.0001 55.4787 39.8071Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5095 46.3707C43.5095 46.2935 43.2392 45.8688 43.162 45.8301C42.969 45.6757 42.6215 45.946 42.6215 46.1776C42.6215 46.3321 42.8917 46.6796 43.0462 46.7568C43.2778 46.834 43.5481 46.6409 43.5095 46.3707Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3897 41.2356C52.3125 40.8881 51.5017 40.5792 51.2314 40.8881C51.0384 41.0811 51.4245 41.9305 51.6561 42.0078C51.965 42.085 52.5442 41.8533 52.3897 41.2356Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4825 33.4751C56.5211 33.4364 56.2509 32.9731 56.0964 33.0503C55.5945 33.2434 55.9806 33.8225 56.4825 33.4751Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0499 48.2627C53.7796 47.9538 53.1232 47.9538 53.046 48.4171C52.9688 48.9577 53.3549 49.1893 53.8182 49.228C54.3588 49.2666 54.3588 48.6102 54.0499 48.2627Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0885 27.7608C63.6638 28.0697 62.8916 26.9886 63.6638 26.5639C64.436 26.1392 64.5132 27.452 64.0885 27.7608Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3898 56.1391C52.5056 56.2935 52.5443 56.5252 52.5056 56.7182C52.4284 57.1043 52.1195 57.3746 51.6948 57.0271C51.4632 56.8341 51.7721 56.5252 51.8493 56.3321C52.0037 55.9846 52.1195 55.7916 52.3898 56.1391Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7487 43.0888C45.8645 43.2433 45.9031 43.4749 45.8645 43.668C45.7873 44.0541 45.4784 44.3244 45.0537 43.9769C44.8221 43.7838 45.1309 43.4749 45.2082 43.2819C45.3626 42.9344 45.517 42.7414 45.7487 43.0888Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.691 36.7569C50.6138 36.6411 50.4593 36.1778 50.6524 36.062C50.884 35.9461 51.1157 36.2936 51.2315 36.4481C51.3087 36.5639 51.5404 37.0272 51.3473 37.143C51.1929 37.2589 50.7682 36.8728 50.691 36.7569Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8183 47.7221C43.9341 47.6835 44.3974 47.7221 44.4747 47.8379C44.5905 48.031 44.8608 48.5329 44.7063 48.6488C44.3974 48.919 43.6252 49.1507 43.5866 48.7646C43.5094 48.6101 43.6252 47.838 43.8183 47.7221Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7141 56.7181C46.9071 57.027 46.6755 57.6062 46.2894 57.2587C45.9033 56.9498 46.4824 56.3707 46.7141 56.7181Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3859 61.7375C51.5789 62.0464 51.3473 62.6255 50.9612 62.278C50.5751 61.9692 51.1542 61.4286 51.3859 61.7375Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6447 44.0541C58.8377 44.3629 58.6061 44.9421 58.22 44.5946C57.8339 44.2857 58.413 43.7452 58.6447 44.0541Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9804 52.8187C46.2892 53.282 46.1734 54.1315 45.5557 53.5909C45.2468 53.3206 45.1309 52.8187 45.324 52.5871C45.517 52.3554 45.7873 52.5485 45.9804 52.8187Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8725 51.6215C57.8725 51.6987 57.9111 51.1582 57.8725 51.1582C57.6408 51.0038 57.0617 51.0424 57.1003 51.4285C57.1003 51.8918 57.9111 52.1621 57.8725 51.6215Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6059 43.2046C48.5673 42.6255 48.104 43.0502 47.9882 43.2819C47.8723 43.4749 47.5635 43.9382 47.6021 44.2085C47.6407 44.5946 48.104 44.5174 48.3357 44.2857C48.5673 44.0541 48.6059 43.5135 48.6059 43.2046Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6756 34.672C56.2509 34.5175 55.942 34.9036 55.8648 35.2125C55.749 35.5986 55.7876 35.8303 56.2509 36.0233C57.2162 36.448 57.2162 34.9036 56.6756 34.672Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8108 45.2897C52.081 45.0195 52.2355 45.1739 52.081 44.7492C51.9652 44.4017 51.8107 44.3631 51.5405 44.5561C51.1158 44.8264 51.193 45.9075 51.8108 45.2897Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5289 50.1931C48.2586 50.1159 48.2972 50.1159 48.0269 50.2704C47.7567 50.4248 47.8339 50.5406 48.0269 50.7337C48.1814 50.8881 48.5675 50.9653 48.7991 50.7337C48.9536 50.5792 48.6833 50.2318 48.5289 50.1931Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8917 51.1583C42.7373 50.9266 41.386 51.081 41.8107 51.6602C41.9651 51.8918 42.1968 51.9691 42.4284 51.8918C42.6215 51.8532 43.0076 51.3513 42.8917 51.1583Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3745 54.17C48.3745 54.0542 47.834 53.8611 47.7568 53.8998C47.6409 53.977 47.3706 54.3631 47.4093 54.5175C47.4865 54.7106 47.9884 54.865 48.1815 54.7878C48.4131 54.6719 48.4131 54.4017 48.3745 54.17Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0153 53.7839C45.1312 53.4364 44.5906 52.78 44.2045 52.8572C43.9342 52.9345 43.8184 53.8611 43.9729 54.0155C44.1659 54.2858 44.7837 54.4016 45.0153 53.7839Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5057 49.2277C52.583 49.2277 52.5444 48.6486 52.3899 48.6486C51.8494 48.6099 51.888 49.2663 52.5057 49.2277Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7759 60.6563C42.6987 60.2316 42.1195 59.9227 41.8493 60.2702C41.5018 60.6949 41.6948 61.081 42.0809 61.3513C42.5056 61.6987 42.8531 61.1196 42.7759 60.6563Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9651 48.2626C61.4245 48.3012 61.3473 46.9885 62.2353 47.0271C63.0847 47.0657 62.467 48.224 61.9651 48.2626Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7489 46.7183C45.7875 46.5253 45.5944 46.1778 45.5558 46.1778C45.3242 46.0233 44.745 46.0619 44.7836 46.448C44.8222 46.8727 45.6717 47.0272 45.7489 46.7183Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8648 49.0735C45.8648 48.9576 45.9806 48.4557 46.1737 48.4557C46.4053 48.4557 46.444 48.8804 46.444 49.0735C46.444 49.2279 46.4053 49.7298 46.2123 49.7298C46.0192 49.7684 45.8648 49.2279 45.8648 49.0735Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0694 39.1507C49.2238 38.8032 49.6099 38.6874 49.9574 38.8418C50.3821 39.0348 50.2663 39.4209 49.996 39.6526C49.803 39.8456 49.4555 40.0387 49.1852 39.9229C48.7991 39.807 48.9535 39.4209 49.0694 39.1507Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5712 29.1121C59.4939 28.5715 60.1889 27.8766 60.3434 28.5715C60.4592 29.0735 59.6484 29.4596 59.5712 29.1121Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3512 33.0117C53.2006 32.9731 52.5056 34.3244 52.0037 34.2472C51.8106 34.2086 51.579 33.668 51.6176 33.475C51.6562 33.1661 52.1195 33.0117 52.3512 33.0117Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5134 41.8919C54.3976 41.3899 55.1698 41.6602 55.4014 41.583C55.4787 41.5444 55.6331 41.4285 55.7103 41.4285C55.7875 41.4671 55.8261 41.8532 55.8261 41.8919C55.7875 42.1621 55.3628 42.3938 55.0926 42.4324C54.9381 42.471 54.9767 42.471 54.8223 42.3552C54.7065 42.3166 54.552 42.0463 54.5134 41.8919Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8763 59.4595C48.9149 59.807 48.3744 60.1931 48.2199 59.6912C48.0655 59.2278 48.8377 59.0348 48.8763 59.4595Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5984 49.9616C56.5984 50.0388 56.5211 49.4982 56.5211 49.4982C56.2509 49.421 55.7103 49.5755 55.7876 49.9229C55.9034 50.3863 56.7142 50.4635 56.5984 49.9616Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7874 43.6682C45.633 43.0891 45.2855 43.6296 45.2083 43.8613C45.131 44.0543 44.938 44.5949 45.0152 44.8265C45.131 45.174 45.5557 45.0196 45.7488 44.7493C45.9419 44.479 45.8646 43.9771 45.7874 43.6682Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9264 33.6297C51.4631 33.5524 51.2701 34.0158 51.2314 34.3246C51.1928 34.7107 51.3087 34.9424 51.772 35.0196C52.8145 35.2513 52.5056 33.7069 51.9264 33.6297Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3782 45.0195C49.5713 44.7107 49.7643 44.8265 49.5327 44.4404C49.3396 44.0929 49.1852 44.0929 48.9535 44.3632C48.5674 44.7107 48.8763 45.7531 49.3782 45.0195Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.139 50.5022C46.8687 50.5022 46.8687 50.4636 46.6757 50.6567C46.444 50.8497 46.5212 50.9655 46.7915 51.12C46.9846 51.2358 47.3707 51.2358 47.5637 50.9655C47.6795 50.8111 47.2934 50.5022 47.139 50.5022Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8493 52.6256C41.6563 52.4326 40.3435 52.8573 40.9227 53.3592C41.1157 53.5523 41.386 53.5523 41.579 53.4364C41.7335 53.3206 42.0037 52.7801 41.8493 52.6256Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.834 54.4019C47.7954 54.2861 47.2162 54.2089 47.1776 54.2861C47.1004 54.3633 46.9073 54.8266 46.9846 54.9424C47.1004 55.1355 47.6409 55.1355 47.7954 55.0583C47.9884 54.9038 47.9112 54.6722 47.834 54.4019Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4362 54.7492C44.4748 54.4017 43.8184 53.8226 43.4323 54.0156C43.2006 54.1314 43.2779 55.0581 43.4709 55.2125C43.7412 55.4056 44.3589 55.4056 44.4362 54.7492Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8455 48.7647C50.9227 48.7647 50.7682 48.1856 50.6138 48.2242C50.0733 48.2628 50.2663 48.9191 50.8455 48.7647Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7026 61.9308C43.5481 61.5447 42.9304 61.3516 42.7373 61.7377C42.467 62.2011 42.7759 62.5486 43.2006 62.7416C43.6639 62.9733 43.8956 62.3555 43.7026 61.9308Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8803 45.8305C59.3784 45.9849 59.0309 44.7108 59.8803 44.5563C60.7683 44.4405 60.3822 45.7146 59.8803 45.8305Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7026 47.645C43.7026 47.452 43.4323 47.1431 43.4323 47.1431C43.162 47.0659 42.6215 47.2203 42.6987 47.5678C42.8145 48.0311 43.7026 47.9925 43.7026 47.645Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3202 49.9616C44.2816 49.8458 44.2816 49.3439 44.5133 49.3053C44.7449 49.2667 44.8608 49.6914 44.8994 49.8844C44.938 50.0389 44.9766 50.5408 44.7835 50.5794C44.5905 50.618 44.3588 50.1161 44.3202 49.9616Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4015 39.6142C45.4788 39.2667 45.8262 39.035 46.1737 39.1123C46.6371 39.2281 46.5984 39.6142 46.3668 39.9231C46.2123 40.1547 45.9421 40.425 45.6332 40.3478C45.2471 40.2706 45.3629 39.8845 45.4015 39.6142Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3088 41.12C51.1158 40.6566 51.888 40.7725 52.1196 40.6566C52.1968 40.618 52.3127 40.4636 52.3899 40.4636C52.4671 40.4636 52.5829 40.8497 52.6216 40.9269C52.6216 41.1972 52.2741 41.5061 52.0038 41.6219C51.8494 41.6991 51.888 41.6991 51.7335 41.6219C51.5405 41.5061 51.386 41.2744 51.3088 41.12Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.417 59.4596C49.4943 59.8071 49.0695 60.2704 48.7993 59.8457C48.5676 59.421 49.3012 59.0735 49.417 59.4596Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1814 38.2242C48.1042 38.34 48.0656 38.9192 48.1042 39.035C48.1814 39.2281 48.4517 39.3825 48.6447 39.3439C48.722 39.3053 49.1081 39.1895 49.1467 39.1122C49.2625 38.9964 49.2239 38.9578 49.1081 38.842C49.0308 38.7261 48.3359 38.0312 48.1814 38.2242Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6988 46.5252C42.5444 46.7955 42.1583 46.9113 42.2355 47.336C42.2741 47.6063 42.583 47.7994 42.8533 47.7221C43.0849 47.6835 43.3938 47.4133 43.4324 47.1816C43.4324 46.9499 42.8146 46.255 42.6988 46.5252Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3629 43.8611C45.8263 44.1314 46.4826 42.9731 45.6718 42.6256C44.861 42.3167 44.9382 43.6295 45.3629 43.8611Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8841 42.4713C50.7682 42.6643 51.8493 43.5137 51.8107 42.6643C51.7721 42.1238 51.1543 42.008 50.8841 42.4713Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3204 48.1082C44.2432 48.1082 44.166 48.3784 44.2046 48.4557C44.2432 48.6101 44.359 48.7259 44.4749 48.8418C44.7451 49.112 45.1312 49.5753 45.556 49.1892C46.2896 48.417 44.8224 48.1468 44.3204 48.1082Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8956 35.7145C54.1658 35.2511 53.5481 34.4403 53.2006 34.9809C52.9303 35.4056 53.8956 35.7145 53.8956 35.7145Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5442 71.9305C42.5056 71.9691 42.8145 71.5444 42.8145 71.5444C42.6987 71.2741 42.1967 71.0039 42.0037 71.3513C41.772 71.7374 42.274 72.3938 42.5442 71.9305Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6911 57.0272C50.4208 56.6411 49.9575 56.8341 49.7258 57.0272C49.4169 57.2974 49.3397 57.4905 49.61 57.9152C50.1891 58.8032 51.0386 57.5291 50.6911 57.0272Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.884 63.3205C41.2701 63.2433 41.3088 63.4364 41.4246 63.0116C41.5404 62.6641 41.4246 62.5483 41.0771 62.5483C40.5366 62.5869 40.0346 63.5136 40.884 63.3205Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7952 71.3128C47.3319 71.0425 47.9496 69.9228 48.6832 70.4248C49.3782 70.9267 48.2585 71.583 47.7952 71.3128Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1466 47.5678C49.301 47.6451 49.4169 47.3748 49.4941 47.3362C49.6099 47.259 49.803 47.3362 49.9574 47.3748C50.3435 47.5292 50.2277 47.8381 49.8802 47.9539C49.6099 48.0312 49.1466 48.147 48.9149 47.9926C48.5674 47.7995 48.7219 47.3362 49.1466 47.5678Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0116 52.8185C44.2046 52.9343 43.9343 53.1274 43.8571 53.1274C43.7799 53.166 43.5096 53.2432 43.471 53.2432C43.2007 53.3204 42.6988 53.0116 42.6602 52.7413C42.6216 52.3552 42.8919 51.7374 43.3552 51.9691C43.5096 52.0463 43.7027 52.278 43.8185 52.4324C43.8957 52.5869 43.8571 52.7027 44.0116 52.8185Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.888 56.7182C42.1969 56.5252 42.583 56.6024 42.776 56.9113C43.0463 57.336 42.7374 57.5676 42.3513 57.6062C42.0811 57.6448 41.695 57.6448 41.5019 57.3746C41.3089 57.0657 41.6564 56.8726 41.888 56.7182Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1735 53.9382C56.4052 53.4363 57.3704 53.2046 57.1002 53.8996C56.9071 54.3629 56.0191 54.2471 56.1735 53.9382Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9495 53.2818C48.6831 53.7065 47.3704 54.4401 46.9843 54.1312C46.8298 54.0154 46.9457 53.3977 47.0615 53.2818C47.2932 53.0502 47.7565 53.166 47.9495 53.2818Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9767 61.9306C45.1312 61.4673 45.6717 62.0851 45.9034 62.1623C45.9806 62.2009 46.1736 62.1623 46.2122 62.2009C46.2509 62.2781 46.0964 62.6256 46.0578 62.6642C45.8648 62.8573 45.4014 62.8187 45.1312 62.7415C44.9767 62.6642 44.9767 62.7028 44.9381 62.5484C44.8995 62.394 44.9381 62.0851 44.9767 61.9306Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.521 69.3052C46.5983 69.1507 46.4052 68.533 46.4824 68.4557C46.3666 68.533 46.0963 68.4944 45.9419 68.5716C45.8261 68.6488 45.7102 68.7646 45.633 68.8804C45.4786 69.1121 45.5172 69.1121 45.7488 69.2665C45.9419 69.421 46.3666 69.6526 46.521 69.3052Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.081 69.1895C41.9651 69.1509 41.4246 69.3439 41.3088 69.4598C41.1543 69.6142 41.1157 69.9231 41.2315 70.0775C41.2701 70.1547 41.579 70.425 41.6176 70.4636C41.7721 70.5022 41.7721 70.4636 41.8493 70.3092C41.9265 70.1547 42.3126 69.2667 42.081 69.1895Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9649 59.8845C41.9263 60.2706 42.7757 60.8111 43.0846 60.4636C43.3163 60.232 42.9688 59.6914 42.8529 59.4211C42.7757 59.2281 42.4282 59.1895 42.1194 59.2281C41.8491 59.3053 42.0035 59.6142 41.9649 59.8845Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4245 53.0505C41.6562 53.0119 42.0423 52.4714 41.8106 52.2397C41.6562 52.0853 41.2701 52.3169 41.077 52.3942C40.8454 52.4714 40.6137 52.5486 40.6523 52.8575C40.6909 53.1664 41.1542 53.0891 41.4245 53.0505Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0347 50.0388C49.7258 49.8457 49.3011 50.116 49.3783 50.3862C49.5327 51.004 50.498 50.3476 50.0347 50.0388Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2584 62.201C48.1812 62.2396 48.0268 62.7802 48.1426 62.896C48.3357 63.1277 48.8762 63.0891 48.9534 62.8188C49.1078 62.2396 48.6445 62.008 48.2584 62.201Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6058 39.5369C48.2197 39.4983 47.9494 40.4635 48.5672 40.3863C48.8375 40.3863 48.9533 39.5755 48.6058 39.5369Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.521 44.5176C46.4438 45.2125 47.5249 45.2125 47.5635 44.865C47.5635 44.7492 47.5635 44.1701 47.4477 44.1315C47.0616 43.9384 46.5596 43.977 46.521 44.5176Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.019 39.537C46.4051 39.5756 46.5596 38.649 46.2893 38.6104C46.019 38.5717 45.6715 38.649 45.5943 38.9192C45.4785 39.1895 45.7488 39.4984 46.019 39.537Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5984 73.475C47.1003 73.5522 47.6409 72.6642 47.0231 72.5483C46.4825 72.5097 46.5984 73.475 46.5984 73.475Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3435 68.1469C50.3435 68.2241 51.2702 68.2241 51.3088 68.031C51.4632 67.5291 50.4207 67.5677 50.3435 68.1469Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7837 64.9036C44.8609 64.363 46.135 64.5175 45.942 65.3669C45.7489 66.2549 44.7451 65.4441 44.7837 64.9036Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9379 54.4789C45.0152 53.9384 46.2893 54.0928 46.0962 54.9423C45.9418 55.7917 44.8993 55.0195 44.9379 54.4789Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4708 48.7263C43.3164 48.5719 43.3164 48.2244 43.4322 48.0313C43.4708 47.9541 43.6253 47.7996 43.7025 47.7996C43.8183 47.761 43.7797 47.7996 43.8569 47.8769C43.9728 47.9927 44.1658 48.3016 44.1658 48.456C44.1658 48.6491 43.6253 48.8421 43.4708 48.7263Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.185 57.7223C48.992 57.6837 48.7603 57.1818 48.7217 57.0273C48.6831 56.7571 48.8375 56.564 49.1078 56.5254C49.6869 56.4482 49.6097 57.7609 49.185 57.7223Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9458 50.0773C47.023 49.5368 48.2972 49.6912 48.1041 50.5407C47.9497 51.3901 46.9072 50.5793 46.9458 50.0773Z",
    fill: "#98D891"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0885 45.5987C53.6638 45.5601 53.2777 45.1354 53.8955 45.0582C54.5133 44.9423 54.5905 45.6373 54.0885 45.5987Z",
    fill: "#98D891"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7951 96.7567C67.4862 96.9883 66.6754 96.6022 67.1001 96.1775C67.2932 95.9845 68.104 96.4864 67.7951 96.7567Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7448 99.4592C84.7062 100.038 83.239 99.9225 83.432 98.9572C83.5865 97.992 84.7834 98.88 84.7448 99.4592Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0074 98.7256C62.4283 98.7256 61.7333 97.8376 62.5441 97.799C63.1233 97.7604 63.4321 98.7256 63.0074 98.7256Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5324 97.0653C79.2621 97.3742 79.9957 98.2236 80.3046 97.6445C80.459 97.3356 79.764 96.7565 79.5324 97.0653Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9109 99.4591C78.1811 99.1502 77.4089 98.4166 77.2159 98.6483C77.0228 98.88 76.8684 99.2661 77.0614 99.4977C77.2545 99.7294 77.7178 99.6908 77.9109 99.4591Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1077 92.548C68.8761 92.8183 67.9881 92.6252 68.2969 92.1619C68.49 91.8917 69.378 92.2391 69.1077 92.548Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6057 95.6754C88.2968 96.0615 87.6791 96.1774 87.9879 95.4824C88.2968 94.8646 88.9918 95.2507 88.6057 95.6754Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8762 97.4902C68.7218 97.606 68.5287 98.301 68.4129 98.3396C68.5673 98.301 68.8376 98.5326 68.992 98.5326C69.1465 98.5326 69.3395 98.494 69.494 98.4168C69.7642 98.301 69.7256 98.301 69.6098 97.9921C69.494 97.7604 69.2623 97.2585 68.8762 97.4902Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3975 99.9226C74.3975 99.8454 74.2816 99.382 74.243 99.3434C74.1272 99.2276 74.0886 99.2662 73.9341 99.3434C73.8183 99.4207 72.8917 100.038 73.0847 100.27",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2586 97.9919C78.4517 98.1464 79.5714 97.1039 78.6447 96.9881C78.027 96.9109 77.7953 97.6058 78.2586 97.9919Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2701 93.4747C70.8068 93.1272 69.8029 93.6292 70.3434 94.0925C70.7682 94.4786 71.2701 93.4747 71.2701 93.4747Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5133 96.3705C64.5519 96.3319 63.6639 95.7527 63.5095 95.9072C63.0848 96.2933 64.0886 96.911 64.5133 96.3705Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4321 100.347C83.3935 100.193 83.4708 99.9998 83.548 99.8454C83.8182 99.4207 84.1271 99.6137 84.1657 100.038",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9263 94.0539C91.4244 93.745 91.3086 92.5867 92.0422 93.0114C92.5055 93.3203 92.2738 94.2855 91.9263 94.0539Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5596 91.9303C86.3666 91.969 85.9419 92.5481 85.7874 92.5095C85.9419 92.5481 86.0963 92.857 86.2507 92.9342C86.3666 93.0114 86.5982 93.0114 86.7527 93.0114C87.0616 93.0114 87.0229 93.0114 87.0229 92.6639C87.0229 92.3937 86.9843 91.8917 86.5596 91.9303Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.2624 96.1389C89.301 96.2547 89.8415 96.6408 89.996 96.6794C90.2276 96.7566 90.5365 96.5636 90.6137 96.3705C90.6523 96.2933 90.7295 95.83 90.6909 95.7528C90.6523 95.5983 90.5751 95.5983 90.3821 95.6369C90.2662 95.6369 89.1851 95.8686 89.2624 96.1389Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5288 99.1505C87.718 99.5752 89.1465 100.502 89.6099 100.116C89.7643 99.9613 89.6871 99.3049 89.5326 99.1505C89.301 98.9188 88.799 98.996 88.5288 99.1505Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9378 96.1776C95.0536 96.4093 96.5208 95.9074 95.71 95.4054C95.1694 95.0966 94.6675 95.6371 94.9378 96.1776Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8375 94.8647C78.9147 94.9033 79.5325 94.6717 79.5711 94.5172C79.6869 94.1698 79.2622 93.7064 78.9919 93.8223C78.3742 94.0539 78.4128 94.5945 78.8375 94.8647Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3819 89.2277C90.1116 88.7257 88.9533 88.7643 89.2622 89.4207C89.5325 89.9613 90.3819 89.2277 90.3819 89.2277Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.046 89.1119C83.1232 89.0733 82.5055 88.2239 82.351 88.2625C81.7719 88.4556 82.4282 89.4594 83.046 89.1119Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5866 96.3321C83.0461 96.6024 82.3511 95.3282 83.2778 94.9421C84.1658 94.5947 84.0886 96.0618 83.5866 96.3321Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0885 96.8726C74.2043 97.0657 73.8569 97.6062 73.7024 97.7607C73.4708 97.9537 73.2005 97.9537 72.9688 97.722C72.5827 97.1815 73.8569 96.4479 74.0885 96.8726Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.2239 91.3513C79.0309 91.4672 78.8764 92.1621 78.722 92.1621C78.8764 92.1235 79.1467 92.3552 79.3011 92.3938C79.4556 92.3938 79.6486 92.3552 79.8031 92.278C80.0734 92.1621 80.0734 92.1621 79.9189 91.8533C79.8031 91.6216 79.61 91.1583 79.2239 91.3513Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3164 94.2085C83.3937 94.3243 84.05 94.4787 84.2045 94.4401C84.4361 94.4015 84.6678 94.1312 84.6678 93.9382C84.6678 93.861 84.5906 93.3976 84.5133 93.359C84.3975 93.2046 84.3589 93.2432 84.2045 93.359C84.05 93.3976 83.1234 94.0154 83.3164 94.2085Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.7797 97.2972C83.162 98.0308 84.8608 98.3011 85.1311 97.7992C85.2469 97.6061 84.8994 97.027 84.7064 96.9111C84.3975 96.7953 83.9728 97.0656 83.7797 97.2972Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9922 98.4941C89.3783 98.0308 88.2586 97.1042 87.718 97.915C87.1775 98.7258 88.6447 98.9574 88.9922 98.4941Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5674 92.1234C88.7605 92.3164 89.9188 91.274 88.9921 91.1581C88.3743 91.0423 88.1427 91.7373 88.5674 92.1234Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2006 96.9881C73.3165 96.9881 73.7798 96.5634 73.7412 96.409C73.7026 96.0615 73.162 95.7912 72.9304 95.9843C72.4284 96.409 72.6987 96.9109 73.2006 96.9881Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7334 87.413C81.27 87.0269 80.2662 87.5288 80.7681 88.0308C81.1928 88.4169 81.7334 87.413 81.7334 87.413Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.668 95.328C104.204 95.5596 104.282 96.1002 104.475 96.409C104.706 96.7951 104.938 96.911 105.44 96.7179C106.521 96.2546 105.247 95.0191 104.668 95.328Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8995 90.0771C74.9381 90.0385 74.0501 89.4594 73.9343 89.5752C73.471 89.9613 74.4748 90.6177 74.8995 90.0771Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1427 96.5636C77.7566 97.0269 76.6369 96.1002 77.3319 95.4053C78.0269 94.7489 78.4902 96.1389 78.1427 96.5636Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8957 95.0965C94.0115 94.942 93.7412 94.7876 93.7026 94.6718C93.664 94.5173 93.7798 94.3243 93.857 94.1698C94.1273 93.7451 94.4362 93.9768 94.4748 94.3629C94.5134 94.6718 94.552 95.2123 94.3204 95.444C93.9729 95.7915 93.5482 95.4826 93.8957 95.0965Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.351 88.6486C101.849 88.3011 101.811 87.1815 102.506 87.6448C102.969 87.915 102.699 88.8803 102.351 88.6486Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.077 98.6485C91.2314 99.0346 92.2353 98.6871 92.1194 98.3782C92.0036 98.108 91.7333 97.7991 91.4631 97.8377C91.1156 97.9149 90.9611 98.3396 91.077 98.6485Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.247 87.0655C105.208 87.2971 105.633 87.5288 105.749 87.5288C106.328 87.606 106.289 87.1813 106.058 86.911C105.942 86.7952 105.787 86.5635 105.594 86.5635C105.131 86.6408 105.247 86.8724 105.247 87.0655Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2159 96.3321C96.714 96.6795 97.5634 97.8764 98.297 97.2201C99.0692 96.5637 97.7178 95.9846 97.2159 96.3321Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.9922 90.888C99.3783 90.6178 100.035 91.5444 99.3396 91.9305C98.7219 92.278 98.6447 91.1583 98.9922 90.888Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7102 96.9497C75.5944 96.7566 75.5558 96.525 75.5944 96.2933C75.6716 95.8686 76.0191 95.5211 76.521 95.9458C76.7913 96.1775 76.4438 96.4863 76.328 96.7566C76.1735 97.1427 75.9805 97.3358 75.7102 96.9497Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7217 99.5752C88.9534 99.4594 89.3009 99.8069 89.3395 100.039L88.7217 99.5752Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4671 93.6291C92.6987 93.8608 92.1582 94.2469 92.0037 94.3627C91.7721 94.5558 91.4246 94.4785 91.386 94.1311C91.3474 93.938 91.579 93.5133 91.7335 93.3975C91.9651 93.243 92.274 93.3975 92.4671 93.6291Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.3587 85.637C94.5904 85.8686 94.0499 86.2547 93.8954 86.3706C93.6638 86.5636 93.3163 86.4864 93.2776 86.1389C93.239 85.9459 93.4707 85.5211 93.6251 85.4053C93.8182 85.2509 94.1657 85.4053 94.3587 85.637Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.046 93.8609C102.776 93.4748 102.737 92.5868 103.316 93.0501C103.818 93.5134 103.355 94.3242 103.046 93.8609Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0809 96.2933C81.8493 95.9844 82.1195 95.2894 82.5828 95.6755C83.0076 96.023 82.3126 96.6794 82.0809 96.2933Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7912 90.6563C76.5595 90.3474 76.8298 89.6524 77.2931 90.0385C77.7178 90.4246 77.0228 91.0424 76.7912 90.6563Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6484 96.0616C99.8028 95.9844 100.034 95.4825 100.15 95.4825C100.034 95.4825 99.8414 95.2508 99.7256 95.2508C99.6098 95.2122 99.4553 95.2508 99.3009 95.2894C99.0692 95.3667 99.0692 95.3667 99.1465 95.5983C99.1851 95.7914 99.3009 96.2161 99.6484 96.0616Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.857 90.9651C103.973 91.1196 104.513 91.2354 104.59 91.0037C104.667 90.8107 104.32 90.6176 104.243 90.5018C104.088 90.3474 103.973 90.1929 103.741 90.3474C103.509 90.4632 103.741 90.8107 103.857 90.9651Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3627 99.9227C95.0538 99.8455 94.8607 99.8841 94.7063 100.232L95.3627 99.9227Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0576 93.2433C96.2506 93.4363 96.1348 93.5135 96.4437 93.4363C96.6753 93.3591 96.7139 93.2819 96.5595 93.0502C96.3278 92.7799 95.6329 92.8572 96.0576 93.2433Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.857 94.4787C103.857 94.3629 103.2 94.0154 103.085 94.054C102.776 94.1312 102.312 94.6718 102.621 95.0192C102.892 95.2895 103.857 94.8648 103.857 94.4787Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6831 91.1197C78.8761 91.2741 79.2622 91.0425 79.3395 90.9267C79.7256 90.4633 79.3395 90.2703 78.9534 90.3475C78.7989 90.3861 78.49 90.4247 78.4128 90.5792C78.2584 91.0039 78.5286 91.0039 78.6831 91.1197Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.8992 85.521C84.9764 85.5596 85.4011 85.5596 85.4783 85.521C85.6714 85.4438 85.6328 85.0577 85.4397 84.9419C85.3239 84.8646 84.9378 84.9419 84.822 85.0191C84.6289 85.1349 84.6675 85.4438 84.8992 85.521Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.015 81.8918C95.015 81.969 96.0574 81.776 96.0574 81.583C96.1347 80.9652 94.9764 81.1968 95.015 81.8918Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9494 88.0694C97.9108 87.4516 96.9841 88.108 97.1 88.4555C97.1386 88.6099 97.5633 88.7257 97.7177 88.6485C97.8722 88.6099 97.9494 88.2624 97.9494 88.0694Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2274 97.2199C90.3819 96.8338 89.4552 96.5635 89.378 97.1813C89.3394 97.4902 89.2622 97.6446 89.5711 97.5288C89.7255 97.4902 90.1502 97.3743 90.2274 97.2199Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.7602 98.4168C78.7216 97.9535 79.8413 97.8763 79.8413 98.6099C79.8027 99.3821 78.7988 98.8802 78.7602 98.4168Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.71 90.772C85.7872 90.6176 86.0188 90.579 86.1733 90.579C86.6752 90.5404 86.7138 90.9265 86.4049 91.1967C86.1733 91.3898 86.1347 91.5056 85.8258 91.467C85.3625 91.4284 85.6714 90.8878 85.71 90.772Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.617 86.9884C112.042 86.9112 112.969 87.722 112.351 87.8378C111.926 87.9536 111.309 87.027 111.617 86.9884Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.278 85.4054C103.239 85.0579 103.818 85.3282 103.818 85.5598C103.818 85.637 103.587 85.7529 103.509 85.7143C103.355 85.7143 103.316 85.5212 103.278 85.4054Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5132 96.8337C94.5132 96.9882 94.2043 97.3743 94.0499 97.4129C93.8182 97.4515 93.1618 97.4129 93.1232 97.1812C93.046 96.7179 93.2391 95.8685 93.6638 96.0229C93.8568 96.0615 94.5132 96.6021 94.5132 96.8337Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3085 100.27C71.2699 99.9997 71.5788 99.8067 71.8491 99.7295L71.3085 100.27Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9225 91.2741C90.575 91.1197 90.5364 90.1931 90.9611 90.3475C91.1541 90.3861 91.2314 91.39 90.9225 91.2741Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3936 96.4864C82.8916 96.525 82.158 96.1003 82.853 95.8687C83.5094 95.637 83.9341 96.4478 83.3936 96.4864Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.251 95.1353C106.173 94.7106 105.054 94.7106 105.285 95.3283C105.401 95.6372 106.328 95.5214 106.251 95.1353Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.266 94.247C99.4939 94.3628 99.8028 95.5597 100.189 95.4825C100.343 95.4439 100.922 95.2894 100.961 95.135C101.038 94.6717 100.845 94.1697 100.266 94.247Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.556 92.3165C105.633 92.7412 106.675 92.6254 106.637 92.3551C106.598 92.0849 106.405 91.6988 106.135 91.6602C105.787 91.6216 105.517 92.0077 105.556 92.3165Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4671 92.1236C92.0037 92.278 91.7721 91.6217 91.6949 92.278C91.6563 92.5869 91.8493 93.166 92.1196 93.3205C92.8532 93.7452 93.3551 91.8147 92.4671 92.1236Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.973 97.3359C93.278 97.6062 93.0077 98.8803 93.8957 98.6487C94.5521 98.5329 94.5135 97.1429 93.973 97.3359Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0617 94.9036C87.2547 95.3283 87.9883 95.4827 88.1814 95.0194C88.413 94.4789 88.0655 94.0928 87.6022 93.8997C87.0231 93.7067 86.83 94.4403 87.0617 94.9036Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.1157 86.7568C91.0385 86.5638 91.0771 86.2935 91.193 86.1005C91.386 85.7144 91.8107 85.4827 92.1582 85.9846C92.3513 86.2549 91.9265 86.4866 91.7721 86.7182C91.5018 87.0271 91.2702 87.2202 91.1157 86.7568Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.814 93.8995C102.39 94.054 102.313 93.6293 102.428 93.3204C102.506 93.1273 102.737 92.664 103.008 92.6254C103.278 92.5868 103.509 92.9729 103.509 93.2045C103.471 93.5134 103.085 93.8223 102.814 93.8995Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.181 87.8377C108.336 88.108 107.756 88.3397 107.525 88.4555C107.255 88.5713 106.946 88.4169 106.984 88.0694C106.984 87.8764 107.332 87.5289 107.525 87.4517C107.795 87.3358 108.065 87.5675 108.181 87.8377Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.042 80.5792C112.197 80.8495 111.617 81.0811 111.386 81.197C111.115 81.3128 110.807 81.1584 110.845 80.8109C110.845 80.6178 111.193 80.2703 111.386 80.1931C111.656 80.1159 111.926 80.3476 112.042 80.5792Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4478 87.7608C97.2934 87.3747 97.7567 86.7955 98.1042 87.2974C98.413 87.7222 97.6022 88.1855 97.4478 87.7608Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7798 80.9652C93.6254 80.5791 94.0887 80 94.4362 80.5019C94.7451 80.9266 93.9343 81.3899 93.7798 80.9652Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.884 98.1466C80.7296 97.7605 81.1929 97.1814 81.5404 97.6833C81.8493 98.1466 81.0385 98.6099 80.884 98.1466Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1389 92.2007C96.9072 91.5829 97.2933 90.6949 97.8339 91.5057C98.1041 91.8918 98.0655 92.4709 97.7953 92.664C97.4864 92.857 97.2933 92.5481 97.1389 92.2007Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.2236 92.2777C99.5324 91.9688 98.6444 91.3897 98.4127 91.351C97.795 91.1966 97.988 91.6985 98.0266 92.1232C98.0266 92.3549 97.9494 92.8954 98.2583 92.9727C98.5286 93.0499 99.0305 92.4707 99.2236 92.2777Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.038 95.0189C101.347 94.7101 100.459 94.1309 100.228 94.0923C99.6098 93.9379 99.8029 94.4398 99.8415 94.8645C99.8415 95.0962 99.7643 95.6367 100.073 95.7139C100.343 95.7911 100.884 95.212 101.038 95.0189Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4979 83.8609C90.3434 84.0153 90.382 84.7103 90.2276 84.7875C90.382 84.7103 90.6909 84.8647 90.8453 84.8647C90.9998 84.8261 91.1542 84.7103 91.3087 84.6331C91.5403 84.44 91.5403 84.44 91.3087 84.2084C91.1156 83.9767 90.7681 83.552 90.4979 83.8609Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1695 85.5598C95.2854 85.637 95.9417 85.5984 96.0576 85.5598C96.2892 85.444 96.4437 85.1351 96.3664 84.942C96.3278 84.8648 96.1348 84.4401 96.0576 84.4015C95.9031 84.2857 95.9031 84.3629 95.7487 84.4787C95.6715 84.5559 94.9379 85.4053 95.1695 85.5598Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0421 95.5595C92.2351 95.1734 91.5015 94.2854 91.0382 94.5557C90.7293 94.7487 90.9224 95.4437 90.9224 95.7526C90.9224 95.9843 91.3085 96.1387 91.656 96.2159C92.0035 96.2545 91.9262 95.8298 92.0421 95.5595Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4437 88.3781C96.0576 89.2276 97.7564 89.0345 97.8723 88.494C97.9109 88.2623 97.4475 87.799 97.2159 87.7604C96.907 87.7218 96.5595 88.1465 96.4437 88.3781Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.015 90.9265C105.324 91.0809 105.517 91.5056 105.942 91.3898C106.251 91.3126 106.405 90.9651 106.289 90.6562C106.212 90.4245 105.903 90.077 105.633 90.0384C105.401 90.0384 104.706 90.8106 105.015 90.9265Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.81 88.185C102.042 87.6445 100.729 87.0268 100.42 87.9534C100.073 88.88 101.54 88.7256 101.81 88.185Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7254 82.1234C99.9571 82.2392 100.807 80.9651 99.8799 81.0809C99.2235 81.1581 99.1463 81.8917 99.7254 82.1234Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.637 88.9574C106.637 89.0732 106.984 89.0732 107.062 89.0732C107.255 89.0346 107.37 88.8802 107.486 88.7257C107.757 88.4168 108.22 87.9149 107.757 87.4902C106.83 86.718 106.637 88.4168 106.637 88.9574Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1347 90.8879C86.2506 90.8879 86.5594 90.3088 86.5208 90.1929C86.405 89.8454 85.7872 89.7296 85.6328 89.9999C85.2467 90.5404 85.6328 90.9651 86.1347 90.8879Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.8492 79.382C91.3086 79.1504 90.4592 79.884 91.077 80.2315C91.6175 80.5017 91.8492 79.382 91.8492 79.382Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7988 95.9844C98.3354 95.7914 97.3702 97.2586 98.5671 97.1813C99.5323 97.1427 99.6868 96.4091 98.7988 95.9844Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9804 83.7838C86.019 83.7065 85.0151 83.3976 84.8993 83.5521C84.5518 84.054 85.7101 84.4015 85.9804 83.7838Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8065 89.189C90.5749 89.7295 89.2235 89.1504 89.7255 88.301C90.1888 87.4516 91.0382 88.6485 90.8065 89.189Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9031 99.3819C86.405 98.5325 87.2158 99.768 86.9842 100.27L85.9031 99.3819Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5866 95.3666C83.7796 95.4438 83.8568 96.1002 83.8182 96.2932C83.741 96.6021 83.548 96.7566 83.2005 96.6793C82.5827 96.5635 83.1619 95.1736 83.5866 95.3666Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.1348 97.9922C95.9032 98.5327 94.5518 97.9536 95.0538 97.1042C95.5557 96.2548 96.3665 97.4517 96.1348 97.9922Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.239 92.7412C103.394 92.8184 103.857 92.857 103.896 92.9728C104.011 93.2431 103.587 93.4747 103.818 93.7836C104.011 94.0539 103.741 94.0925 103.702 94.44C103.664 94.6716 103.007 94.3628 102.93 94.2469C102.776 93.9767 102.814 93.6678 102.892 93.3589C102.93 93.3203 103.085 92.6253 103.239 92.7412Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.594 83.5906C105.671 83.4362 105.363 83.3203 105.285 83.2045C105.208 83.0501 105.247 82.857 105.285 82.7026C105.44 82.2392 105.787 82.3551 105.942 82.7412C106.058 83.0114 106.251 83.5134 106.096 83.8222C105.865 84.247 105.363 84.0925 105.594 83.5906Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7873 93.8221C95.8645 93.9765 95.9031 94.2854 95.7873 94.3626C95.7101 94.4012 95.2081 94.4399 95.1309 94.4012C95.0537 94.324 95.0537 93.8607 95.1309 93.8221C95.2081 93.7063 95.7487 93.7063 95.7873 93.8221Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4244 99.6135C91.5403 99.4977 92.2739 99.4977 92.3511 99.6521L91.4244 99.6135Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.042 75.135C111.463 74.9419 111.116 73.8609 111.926 74.0925C112.467 74.2856 112.428 75.2894 112.042 75.135Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.119 84.4013C112.505 83.5519 113.509 84.9418 113.162 85.4052C113.046 85.5596 112.351 85.521 112.196 85.4052C111.926 85.1735 112.003 84.633 112.119 84.4013Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.826 90.5403C105.555 90.2314 104.59 90.8492 105.131 91.2353C105.401 91.4283 106.096 90.8106 105.826 90.5403Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.343 93.0885C99.7641 93.629 100.652 94.4398 100.961 94.1696C101.077 94.0537 101.463 93.5904 101.424 93.4746C101.231 93.0113 100.807 92.7024 100.343 93.0885Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.702 88.5711C103.973 88.88 104.822 88.2237 104.59 87.992C104.397 87.7603 104.05 87.5673 103.78 87.7217C103.509 87.8762 103.471 88.3395 103.702 88.5711Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6597 95.6367C92.3508 96.0228 91.8103 95.5981 92.1191 96.1773C92.2736 96.4475 92.7369 96.8722 93.0458 96.8336C93.8566 96.7564 93.2388 94.8645 92.6597 95.6367Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.471 73.1272C113.509 73.3589 113.973 73.4361 114.088 73.4361C114.668 73.3203 114.513 72.9342 114.166 72.7411C114.011 72.6639 113.78 72.4709 113.625 72.5481C113.2 72.7411 113.432 72.9342 113.471 73.1272Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.799 84.4398C108.451 84.9031 109.61 85.7911 110.112 84.9417C110.614 84.0923 109.146 83.9379 108.799 84.4398Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.397 94.3241C104.436 94.4013 104.861 94.7488 104.938 94.7874C105.208 94.8646 105.478 94.4785 105.401 94.2083C105.363 94.0152 104.938 93.7835 104.745 93.7449C104.475 93.7449 104.243 94.0538 104.397 94.3241Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6907 100.386C90.5749 99.8066 90.1116 99.6907 89.571 99.8066L90.6907 100.386Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.76 78.687C109.03 78.3009 109.957 78.9959 109.416 79.5365C108.915 80.1156 108.49 79.0732 108.76 78.687Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6058 91.8529C88.4127 91.7371 88.3355 91.5054 88.2969 91.2738C88.2583 90.8491 88.4899 90.4244 89.0691 90.656C89.378 90.7718 89.1463 91.1965 89.1463 91.4668C89.0691 91.8915 88.9919 92.1618 88.6058 91.8529Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.895 86.216C113.934 86.3705 113.702 86.8338 113.548 86.8724C113.316 86.9496 112.698 87.0655 112.583 86.8338C112.39 86.3705 112.39 85.5211 112.892 85.5983C113.046 85.5983 113.857 85.9844 113.895 86.216Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.312 91.3897C102.042 91.7372 101.733 91.4283 101.656 91.1194C101.617 90.9264 101.579 90.3859 101.733 90.2314C101.926 90.0384 102.351 90.27 102.467 90.4631C102.621 90.6947 102.467 91.1581 102.312 91.3897Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.432 83.3588C103.702 83.5133 103.355 84.0152 103.239 84.2083C103.084 84.4399 102.737 84.4785 102.583 84.2083C102.505 84.0538 102.583 83.5519 102.698 83.3975C102.814 83.1658 103.162 83.243 103.432 83.3588Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.66 75.2123C102.93 75.3667 102.583 75.8687 102.467 76.0617C102.312 76.2934 101.965 76.332 101.81 76.0617C101.733 75.9073 101.81 75.4054 101.926 75.2509C102.081 75.0193 102.428 75.0579 102.66 75.2123Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.799 90.9263C108.567 91.2352 107.718 90.5016 107.795 90.1927C107.988 89.6522 109.455 90.0383 108.799 90.9263Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.509 80.2702C113.123 79.9613 112.814 79.1505 113.509 79.4207C114.166 79.691 113.973 80.579 113.509 80.2702Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.3972 89.2276C94.0884 88.996 94.127 88.2624 94.6675 88.4941C95.208 88.6871 94.7833 89.4979 94.3972 89.2276Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.6019 85.5597C87.293 85.3281 87.3316 84.5945 87.8721 84.8262C88.4127 85.0192 87.988 85.83 87.6019 85.5597Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6366 93.0884C96.1346 92.7023 95.9416 91.7757 96.8296 92.1232C97.2543 92.2776 97.5632 92.8182 97.4474 93.127C97.2543 93.4359 96.9068 93.3201 96.6366 93.0884Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.8761 97.297C99.3009 97.297 99.3781 96.2545 99.0692 96.2545C98.7989 96.2159 98.3742 96.3704 98.297 96.6406C98.2198 96.9881 98.5287 97.297 98.8761 97.297Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.506 87.104C112.428 86.7179 112.081 86.7179 111.849 86.6793C111.54 86.6407 111.347 86.6793 111.231 87.0654C110.961 87.8762 112.506 87.1426 112.506 87.104Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.849 79.9614C112.042 80.1158 111.965 80.2316 112.235 80.1158C112.467 80 112.467 79.9228 112.312 79.7297C112.081 79.4594 111.386 79.6139 111.849 79.9614Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.3587 79.6139C94.5517 79.7297 94.9378 79.4594 95.0151 79.3822C95.3239 78.8803 94.9378 78.7259 94.5903 78.8417C94.4359 78.8803 94.127 78.9575 94.0884 79.112C93.934 79.5367 94.2042 79.4981 94.3587 79.6139Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3395 90.772C99.4553 91.3512 100.884 91.1195 100.614 90.1543C100.343 89.2276 99.2623 90.1929 99.3395 90.772Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9572 73.3976C100.034 73.3976 100.459 73.359 100.536 73.3204C100.729 73.2045 100.652 72.857 100.459 72.7412C100.343 72.664 99.9572 72.7798 99.8414 72.8957C99.6484 73.0501 99.7256 73.359 99.9572 73.3976Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.977 93.359C104.977 93.3976 105.247 93.7451 105.44 93.6679C105.71 93.5907 105.903 93.0501 105.903 92.9729C105.903 92.6254 105.363 92.5482 105.092 92.7799C104.938 92.8957 104.938 93.1274 104.977 93.359Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.687 68.803C109.687 68.8802 110.691 68.5713 110.691 68.3783C110.729 67.7605 109.571 68.108 109.687 68.803Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.201 74.6716C113.085 74.0539 112.235 74.7875 112.39 75.1349C112.428 75.2508 112.892 75.328 113.008 75.2894C113.201 75.1736 113.239 74.8261 113.201 74.6716Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.444 84.5172C106.559 84.0925 105.594 83.9381 105.594 84.5559C105.594 84.8647 105.556 85.0192 105.826 84.9033C105.98 84.8261 106.405 84.7103 106.444 84.5172Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1694 86.8723C95.0922 86.409 96.2119 86.216 96.2505 86.9882C96.3277 87.7217 95.2466 87.297 95.1694 86.8723Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.347 78.5713C101.424 78.4168 101.656 78.3782 101.81 78.3396C102.274 78.2624 102.351 78.6099 102.119 78.9187C101.926 79.1504 101.888 79.2276 101.54 79.2662C101.038 79.2662 101.27 78.6485 101.347 78.5713Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.258 71.467C118.181 71.1196 118.799 71.3512 118.799 71.5443C118.799 71.6215 118.567 71.7373 118.49 71.7373C118.374 71.7373 118.297 71.5442 118.258 71.467Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.691 83.7065C110.691 83.8609 110.421 84.2856 110.305 84.3242C110.073 84.3628 109.417 84.4014 109.34 84.1698C109.185 83.7065 109.301 82.8184 109.764 82.9729C109.957 83.0115 110.691 83.4748 110.691 83.7065Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.166 88.3009C104.282 88.3781 104.475 88.8415 104.397 88.9959C104.282 89.2276 103.934 89.7681 103.702 89.6523C103.239 89.4978 102.621 88.8801 103.007 88.5712C103.123 88.494 103.973 88.1851 104.166 88.3009Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8991 93.938C95.208 93.8222 95.3238 94.4399 95.4011 94.6716C95.4783 94.9418 95.2466 95.2121 94.9377 95.1349C94.7447 95.0963 94.4744 94.6716 94.4358 94.5171C94.3586 94.2469 94.6289 94.0152 94.8991 93.938Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4514 88.8802C88.7603 88.7643 88.8761 89.3821 88.9533 89.6137C89.0305 89.884 88.7989 90.1543 88.49 90.0771C88.2969 90.0385 88.0267 89.6137 87.9881 89.4593C87.9108 89.189 88.1811 88.9574 88.4514 88.8802Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.089 95.2506C104.166 95.6367 103.007 95.7526 102.853 95.4437C102.621 94.9418 103.895 94.1696 104.089 95.2506Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.559 78.5328C106.212 78.417 106.096 77.4903 106.482 77.6062C106.675 77.6448 106.868 78.61 106.559 78.5328Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.177 89.9997C106.984 90.1541 106.367 89.5364 106.405 89.382C106.405 89.3433 106.868 88.8028 106.83 88.7642C106.907 88.8028 107.448 89.1503 107.448 89.2275C107.448 89.4978 107.448 89.8067 107.177 89.9997Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.571 84.4786C99.0691 84.5558 98.2969 84.2083 98.9532 83.8994C99.6096 83.6292 100.15 84.3628 99.571 84.4786Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.695 82.7027C111.386 82.4324 110.498 83.1274 111.077 83.4749C111.386 83.6293 111.965 82.9344 111.695 82.7027Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.521 85.9072C105.98 86.4863 106.984 87.1813 107.255 86.911C107.332 86.7952 107.679 86.2933 107.641 86.1388C107.409 85.7141 106.946 85.4439 106.521 85.9072Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.339 81.0037C109.648 81.274 110.382 80.5404 110.189 80.3473C109.996 80.1543 109.61 79.9998 109.339 80.1543C109.069 80.3473 109.108 80.772 109.339 81.0037Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.2236 89.305C98.992 89.7297 98.3742 89.3822 98.7217 89.9227C98.8762 90.193 99.4167 90.5405 99.7256 90.4633C100.536 90.3088 99.687 88.4942 99.2236 89.305Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.216 64.5174C117.293 64.749 117.756 64.7876 117.872 64.749C118.413 64.5946 118.22 64.2085 117.872 64.054C117.718 63.9768 117.448 63.861 117.293 63.9382C116.907 64.1699 117.139 64.3243 117.216 64.5174Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.895 76.2935C113.586 76.7954 114.861 77.529 115.285 76.641C115.671 75.7529 114.204 75.7915 113.895 76.2935Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.741 92.3164C103.355 92.9728 104.011 94.1311 104.552 93.3589C104.938 92.8184 104.011 91.8145 103.741 92.3164Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.78 86.4863C113.896 86.5635 114.436 86.1774 114.397 86.0616C114.397 85.9072 114.166 85.4052 114.05 85.3666C113.818 85.328 113.355 85.7141 113.316 85.9072C113.278 86.1774 113.509 86.3319 113.78 86.4863Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.729 86.6409C110.768 86.7181 111.231 87.027 111.347 87.027C111.617 87.0656 111.81 86.6409 111.733 86.4092C111.656 86.2162 111.193 86.0231 111 86.0617C110.729 86.0617 110.536 86.4092 110.729 86.6409Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8684 94.9032C97.2931 95.0962 97.9495 94.7487 97.795 94.2854C97.602 93.7063 97.1387 93.6677 96.6368 93.8221C96.0962 94.0152 96.4051 94.7101 96.8684 94.9032Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.2 70.6178C113.432 70.2318 114.397 70.7723 113.973 71.39C113.509 72.0078 112.969 71.0039 113.2 70.6178Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7448 86.0616C94.5517 85.9458 94.3973 85.7527 94.3587 85.5211C94.2429 85.0964 94.4359 84.6331 95.0151 84.7875C95.3625 84.8647 95.1695 85.328 95.1695 85.5983C95.2081 86.023 95.1309 86.2933 94.7448 86.0616Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.525 90.4245C107.447 90.5403 106.945 90.6948 106.83 90.6175C106.598 90.5017 106.096 90.1156 106.173 89.884C106.366 89.4206 106.984 88.8415 107.293 89.2276C107.409 89.4206 107.679 90.2314 107.525 90.4245Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.185 77.4516C119.224 77.5674 119.069 78.0693 118.915 78.1465C118.683 78.2624 118.065 78.4554 117.95 78.2238C117.718 77.7991 117.602 76.9496 118.104 76.9496C118.297 76.9496 119.108 77.2199 119.185 77.4516Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.258 83.9768C108.027 84.3629 107.679 84.0927 107.602 83.7838C107.525 83.5907 107.409 83.0502 107.563 82.8957C107.718 82.7027 108.181 82.8571 108.297 83.0502C108.529 83.2432 108.413 83.7452 108.258 83.9768Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.452 75.8687C108.76 75.9846 108.452 76.5637 108.336 76.7568C108.22 77.0271 107.872 77.1043 107.679 76.834C107.563 76.6796 107.602 76.2162 107.679 76.0232C107.834 75.7529 108.181 75.7529 108.452 75.8687Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.753 67.8379C107.061 67.9537 106.753 68.5328 106.637 68.7259C106.521 68.9962 106.173 69.0734 105.98 68.8031C105.865 68.6487 105.903 68.1853 105.98 67.9923C106.096 67.722 106.482 67.7606 106.753 67.8379Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.706 82.7411C114.513 83.0886 113.587 82.4322 113.625 82.1233C113.741 81.5828 115.247 81.8145 114.706 82.7411Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.104 71.583C117.679 71.3513 117.293 70.5791 117.988 70.7722C118.683 70.9266 118.606 71.8533 118.104 71.583Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.189 82.7413C99.8413 82.5482 99.8027 81.8146 100.382 81.9691C100.922 82.1235 100.575 82.9729 100.189 82.7413Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0074 79.9227C92.6599 79.7296 92.6213 78.996 93.2004 79.1505C93.7409 79.3049 93.3935 80.1543 93.0074 79.9227Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.853 86.332C102.274 86.0231 102.003 85.0965 102.93 85.3281C103.393 85.444 103.741 85.9073 103.664 86.2548C103.586 86.6023 103.162 86.525 102.853 86.332Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.432 78.6486C113.085 78.4169 112.274 79.1891 112.892 79.4594C113.201 79.5752 113.741 78.8802 113.432 78.6486Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.567 82.2778C108.104 82.8955 109.146 83.5133 109.378 83.2044C109.455 83.0886 109.764 82.548 109.687 82.4322C109.417 82.0461 108.953 81.7758 108.567 82.2778Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.961 77.1427C111.309 77.413 111.965 76.6022 111.733 76.4091C111.502 76.2161 111.116 76.1003 110.884 76.2933C110.614 76.525 110.691 76.9497 110.961 77.1427Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.579 86.3317C101.386 86.7951 100.73 86.4862 101.154 86.9881C101.347 87.2198 101.888 87.5286 102.197 87.4514C103.007 87.1812 102.004 85.4437 101.579 86.3317Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.293 60.0385C117.409 60.2702 117.834 60.2316 117.949 60.193C118.49 59.9613 118.258 59.6138 117.911 59.498C117.756 59.4594 117.486 59.3435 117.332 59.4208C116.984 59.7296 117.216 59.8455 117.293 60.0385Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.054 72.0461C114.822 72.5866 116.135 73.2044 116.444 72.2778C116.791 71.3511 115.324 71.5442 115.054 72.0461Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.366 88.9189C106.058 89.6138 106.791 90.6949 107.255 89.9227C107.641 89.3436 106.598 88.4169 106.366 88.9189Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.038 87.8761C111.116 87.9533 111.579 88.185 111.656 88.2236C111.926 88.2622 112.119 87.7989 112.004 87.5672C111.926 87.3742 111.463 87.2584 111.27 87.2584C111 87.2584 110.845 87.6445 111.038 87.8761Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.814 82.6638C112.891 82.741 113.355 82.9727 113.432 83.0113C113.702 83.0499 113.895 82.5866 113.779 82.3549C113.702 82.1619 113.239 82.046 113.046 82.046C112.737 82.046 112.621 82.4321 112.814 82.6638Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7642 92.1233C100.227 92.2778 100.807 91.8531 100.652 91.4284C100.421 90.8492 99.9186 90.8492 99.4553 91.0809C98.8761 91.2739 99.2622 91.9303 99.7642 92.1233Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.857 66.4864C114.05 66.0616 115.092 66.525 114.706 67.1813C114.32 67.8377 113.664 66.8725 113.857 66.4864Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8298 83.5133C96.6367 83.4361 96.4823 83.2044 96.4051 83.0114C96.2506 82.5867 96.4051 82.1233 97.0228 82.2392C97.3703 82.3164 97.2159 82.7797 97.2545 83.0114C97.2931 83.4361 97.2545 83.7063 96.8298 83.5133Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.957 86.7179C109.88 86.8337 109.417 87.0654 109.262 86.9882C109.03 86.8723 108.49 86.5634 108.567 86.3318C108.722 85.8685 109.301 85.2121 109.61 85.5982C109.764 85.714 110.112 86.5248 109.957 86.7179Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.15 80.1928C109.957 80.5789 109.571 80.3473 109.455 80.077C109.378 79.8839 109.224 79.382 109.34 79.189C109.494 78.9573 109.957 79.1117 110.112 79.2662C110.343 79.4592 110.266 79.9612 110.15 80.1928Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.61 72.1235C109.919 72.2007 109.687 72.7799 109.571 73.0115C109.455 73.2818 109.146 73.3976 108.915 73.1274C108.799 72.9729 108.799 72.5096 108.876 72.3165C108.953 72.0849 109.34 72.0463 109.61 72.1235Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.177 64.2856C107.486 64.3628 107.254 64.9419 107.139 65.1736C107.023 65.4439 106.714 65.5597 106.482 65.2894C106.366 65.135 106.366 64.6717 106.444 64.4786C106.559 64.247 106.907 64.2084 107.177 64.2856Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.444 78.4168C116.289 78.7643 115.285 78.2237 115.324 77.8763C115.362 77.3357 116.907 77.4515 116.444 78.4168Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.837 66.9884C118.374 66.7954 117.949 66.0618 118.644 66.1776C119.339 66.2934 119.339 67.2587 118.837 66.9884Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.965 79.7295C101.617 79.575 101.501 78.8414 102.081 78.9187C102.66 79.0345 102.39 79.9225 101.965 79.7295Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5518 77.5288C94.2043 77.3744 94.0885 76.6408 94.6676 76.718C95.2468 76.8338 94.9765 77.7219 94.5518 77.5288Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.938 83.0499C104.359 82.7796 103.973 81.8916 104.938 82.046C105.401 82.1233 105.787 82.548 105.749 82.8955C105.633 83.2429 105.285 83.2043 104.938 83.0499Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.845 68.6101C120.073 68.7646 120.459 69.9228 120.845 69.8456C121 69.807 121.579 69.5754 121.579 69.4595C121.656 68.9962 121.424 68.4943 120.845 68.6101Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5557 85.8301C95.5171 85.7529 95.7102 86.332 95.7488 86.332C96.0577 86.3706 96.6368 86.139 96.4824 85.7529C96.2507 85.2509 95.3241 85.3282 95.5557 85.8301Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.892 67.1043C112.428 67.2973 112.158 66.641 112.158 67.2973C112.158 67.6062 112.351 68.1854 112.66 68.3012C113.432 68.6873 113.78 66.7182 112.892 67.1043Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.436 90.0771C104.243 90.4632 104.05 90.386 104.359 90.7721C104.629 91.1196 104.784 91.081 105.015 90.7721C105.363 90.2702 104.861 89.1891 104.436 90.0771Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.942 83.5907C106.251 83.5521 106.212 83.5907 106.444 83.3205C106.637 83.0502 106.56 82.973 106.251 82.8571C106.019 82.7799 105.594 82.8571 105.44 83.166C105.324 83.3591 105.749 83.6293 105.942 83.5907Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.324 80.9266C115.749 81.1196 117.177 80.1158 115.98 79.8841C115.633 79.8069 115.556 79.8069 115.363 80.1544C115.285 80.2702 115.092 80.8494 115.324 80.9266Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.463 80.3089C111.733 80.502 113.085 79.7684 112.39 79.3437C112.119 79.1892 111.849 79.1892 111.656 79.3823C111.463 79.4981 111.231 80.1545 111.463 80.3089Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.822 72.2008C114.127 72.5097 113.973 73.8224 114.861 73.5521C115.517 73.3205 115.363 71.9691 114.822 72.2008Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.475 79.3823C104.513 79.4981 105.17 79.4981 105.247 79.3823C105.324 79.2664 105.44 78.7259 105.363 78.6101C105.208 78.417 104.59 78.4942 104.475 78.6101C104.243 78.8417 104.359 79.112 104.475 79.3823Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.181 78.3783C108.181 78.803 109.031 79.2663 109.417 78.9961C109.648 78.803 109.417 77.7992 109.185 77.6833C108.838 77.5289 108.181 77.6447 108.181 78.3783Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.119 86.1776C102.042 86.2162 102.274 86.7953 102.467 86.7567C103.085 86.6023 102.776 85.9073 102.119 86.1776Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.757 70.2702C107.988 70.6563 108.722 70.7722 108.876 70.3088C109.069 69.7297 108.722 69.4208 108.181 69.2664C107.602 69.1119 107.486 69.8455 107.757 70.2702Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5828 91.0038C93.1234 90.7722 93.7411 92.0849 92.8145 92.3938C91.8878 92.7412 92.0809 91.2741 92.5828 91.0038Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.193 61.8533C111.116 61.6602 111.116 61.39 111.193 61.1969C111.347 60.7722 111.772 60.5406 112.158 61.0039C112.39 61.2741 111.965 61.5444 111.811 61.7375C111.579 62.1236 111.386 62.278 111.193 61.8533Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.903 77.6448C115.826 77.4517 115.826 77.1815 115.903 76.9884C116.058 76.5637 116.482 76.332 116.868 76.7954C117.1 77.0656 116.675 77.3359 116.521 77.529C116.328 77.8764 116.096 78.0695 115.903 77.6448Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.266 86.1389C110.305 86.3319 110.652 86.6408 110.691 86.6408C111 86.6794 111.579 86.4478 111.424 86.0617C111.154 85.5598 110.228 85.7528 110.266 86.1389Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.185 83.6677C109.262 83.7835 109.34 84.3627 109.108 84.4399C108.838 84.5171 108.645 84.0924 108.567 83.8994C108.49 83.7449 108.336 83.2044 108.567 83.1272C108.76 83.0114 109.108 83.5133 109.185 83.6677Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.969 94.7487C103.278 95.212 102.39 95.2506 102.158 95.4051C102.081 95.4437 101.965 95.6754 101.888 95.6754C101.811 95.6754 101.579 95.2892 101.579 95.212C101.502 94.9031 101.888 94.517 102.119 94.324C102.274 94.2082 102.235 94.2082 102.428 94.2854C102.621 94.3626 102.892 94.5943 102.969 94.7487Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.525 62.3553C117.37 62.0078 117.756 61.3901 118.143 61.8148C118.49 62.2781 117.718 62.78 117.525 62.3553Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.355 55.8687C113.201 55.5212 113.587 54.9035 113.973 55.3282C114.32 55.7915 113.548 56.2934 113.355 55.8687Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.849 74.0154C101.695 73.6679 102.081 73.0501 102.467 73.4748C102.814 73.9382 102.042 74.4401 101.849 74.0154Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.602 66.8338C117.332 66.2547 117.641 65.328 118.22 66.0616C118.529 66.4091 118.529 67.0269 118.259 67.2199C117.988 67.4516 117.757 67.1427 117.602 66.8338Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.023 64.8262C117.293 64.4787 116.367 64.0154 116.135 63.9768C115.517 63.8996 115.749 64.3629 115.787 64.7876C115.826 65.0192 115.787 65.5598 116.096 65.637C116.405 65.6756 116.868 65.0192 117.023 64.8262Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.301 70.9267C119.571 70.5792 118.645 70.1159 118.413 70.0773C117.795 70 118.027 70.4634 118.065 70.8881C118.104 71.1197 118.065 71.6603 118.374 71.7375C118.645 71.7761 119.108 71.1583 119.301 70.9267Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.069 67.3744C119.34 67.0269 118.413 66.5636 118.181 66.525C117.564 66.4478 117.795 66.9111 117.834 67.3358C117.872 67.5674 117.834 68.108 118.143 68.1852C118.452 68.2238 118.915 67.5674 119.069 67.3744Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.602 57.1816C107.486 57.336 107.525 58.0696 107.409 58.1082C107.563 58.031 107.872 58.1468 108.027 58.1082C108.181 58.0696 108.336 57.9538 108.452 57.838C108.683 57.6449 108.645 57.6449 108.413 57.4133C108.258 57.2202 107.872 56.8341 107.602 57.1816Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.428 58.4556C112.544 58.5329 113.2 58.4556 113.316 58.3784C113.548 58.2626 113.664 57.9151 113.587 57.7221C113.548 57.6448 113.316 57.2587 113.239 57.2201C113.085 57.1429 113.046 57.1815 112.93 57.336C112.853 57.4132 112.197 58.3012 112.428 58.4556Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.15 68.6872C110.305 68.2625 109.494 67.4903 109.069 67.7606C108.76 67.9536 109.031 68.6486 109.069 68.9575C109.108 69.1891 109.494 69.305 109.841 69.3436C110.15 69.3822 110.034 68.9575 110.15 68.6872Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.417 86.2934C109.649 86.2934 109.726 85.5212 109.649 85.3667C109.571 85.2123 109.533 84.5173 109.069 84.5559C108.954 84.5559 108.529 84.8648 108.529 85.0578C108.529 85.2509 108.799 86.0231 108.915 86.1775C108.992 86.2548 109.262 86.2934 109.417 86.2934Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.895 61.1583C113.586 62.0463 115.247 61.6988 115.324 61.1583C115.362 60.9266 114.822 60.5019 114.629 60.5019C114.32 60.4633 114.011 60.888 113.895 61.1583Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.224 60.5021C119.417 59.9615 118.066 59.4596 117.795 60.3862C117.602 61.3515 119.031 61.0426 119.224 60.5021Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.031 76.3319C108.76 76.3319 108.181 76.8339 108.374 77.1042C108.529 77.2972 108.992 77.1428 109.224 77.1042C109.494 77.0655 109.803 77.0269 109.803 76.6794C109.842 76.4092 109.301 76.3319 109.031 76.3319Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.826 74.1699C115.556 74.1699 115.324 74.5173 115.517 74.7876C115.672 74.9807 115.826 74.9807 116.019 74.9421C116.289 74.9034 116.598 74.8648 116.598 74.5173C116.675 74.2085 116.135 74.1699 115.826 74.1699Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7991 77.3745C99.0694 77.6447 99.6099 77.4903 99.6099 77.1428C99.6099 76.4864 98.3744 76.9497 98.7991 77.3745Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.637 54.6717C116.907 54.749 117.641 53.4362 116.675 53.5907C116.096 53.7065 116.096 54.4401 116.637 54.6717Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.857 64.5174C103.973 64.4788 104.243 63.9382 104.166 63.7838C104.011 63.4749 103.394 63.3977 103.278 63.668C102.969 64.2471 103.394 64.6332 103.857 64.5174Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6794 89.2662C98.0655 89.4206 98.606 88.4167 97.9496 88.3395C97.6022 88.3009 97.3319 89.1117 97.6794 89.2662Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.231 84.3628C101.502 83.6292 100.305 83.3589 100.189 83.7064C100.15 83.8609 100.034 84.44 100.15 84.5558C100.498 84.8261 101.038 84.9419 101.231 84.3628Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.498 89.9612C100.112 89.8067 99.687 90.772 99.9958 90.8878C100.266 91.0037 100.691 91.0037 100.845 90.7334C101 90.4631 100.807 90.0384 100.498 89.9612Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.567 52.5869C108.027 52.3939 107.216 53.2047 107.872 53.4749C108.452 53.7066 108.567 52.5869 108.567 52.5869Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.123 83.6291C112.814 83.1272 111.579 84.5558 112.235 84.826C112.776 85.0577 113.355 84.0152 113.123 83.6291Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.907 68.5715C116.444 68.4171 115.594 69.9615 116.791 69.7684C117.718 69.6526 117.834 68.8804 116.907 68.5715Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.173 78.6486C115.749 78.803 115.478 80.5405 116.444 79.8455C116.753 79.6524 116.791 79.5752 116.675 79.2277C116.675 79.1119 116.405 78.5713 116.173 78.6486Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.123 57.4517C103.162 57.3745 102.119 57.1429 102.042 57.2973C101.733 57.8378 102.892 58.1081 103.123 57.4517Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.374 62.4324C108.181 62.9729 106.791 62.5096 107.216 61.6216C107.641 60.7335 108.567 61.8918 108.374 62.4324Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.517 73.8223C105.324 74.3628 103.934 73.8995 104.359 73.0115C104.784 72.1235 105.71 73.2817 105.517 73.8223Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.83 72.664C116.637 73.2045 115.247 72.7412 115.671 71.8532C116.096 70.9652 117.023 72.1235 116.83 72.664Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.633 80.5404C105.787 80.772 105.672 81.1581 105.479 81.3126C105.401 81.3512 105.208 81.5056 105.131 81.5056C105.015 81.5056 105.054 81.5056 104.977 81.3898C104.899 81.2354 104.745 80.8492 104.784 80.6562C104.899 80.4245 105.517 80.3473 105.633 80.5404Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.733 69.2277C101.926 69.3049 102.081 69.9227 102.042 70.1157C102.004 70.4246 101.81 70.6176 101.463 70.579C100.807 70.4632 101.27 69.0346 101.733 69.2277Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.436 70.7721C114.243 71.3126 112.853 70.8493 113.278 69.9613C113.702 69.0732 114.629 70.2315 114.436 70.7721Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.038 64.9036C121.193 64.9808 121.656 64.9422 121.733 65.0966C121.888 65.3283 121.502 65.6372 121.733 65.9074C121.926 66.1391 121.656 66.2163 121.656 66.6024C121.656 66.8341 120.923 66.5638 120.884 66.448C120.73 66.1777 120.73 65.8688 120.768 65.5986C120.768 65.5213 120.923 64.865 121.038 64.9036Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.39 81.1195C112.583 81.1967 112.776 81.3898 112.853 81.5828C113.046 81.9689 112.93 82.4709 112.312 82.3936C111.965 82.355 112.042 81.8917 112.003 81.6214C111.926 81.2353 111.965 80.9651 112.39 81.1195Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.76 81.4285C108.606 81.3513 108.413 81.2741 108.297 81.3513C108.143 81.4285 107.95 81.3899 107.795 81.3513C107.332 81.1969 107.448 80.8494 107.834 80.695C108.104 80.5791 108.606 80.4247 108.915 80.5791C109.34 80.7336 109.262 81.6602 108.76 81.4285Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.197 78.1468C102.004 78.6873 100.614 78.224 101.039 77.336C101.425 76.448 102.39 77.6063 102.197 78.1468Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.131 94.5557C105.247 94.6715 105.285 95.019 105.17 95.0962C105.092 95.1734 104.59 95.2507 104.513 95.1734C104.397 95.0962 104.397 94.6715 104.475 94.5943C104.552 94.4785 105.054 94.4399 105.131 94.5557Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.741 66.6409C113.857 66.7568 113.896 67.1043 113.78 67.1815C113.703 67.2587 113.201 67.3359 113.123 67.2587C113.008 67.1815 113.008 66.7568 113.085 66.6795C113.162 66.5637 113.664 66.5251 113.741 66.6409Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.807 72.7028C110.961 72.8958 111 73.3205 110.845 73.4364C110.73 73.5136 110.073 73.6294 109.957 73.5522C109.803 73.4364 109.764 72.8572 109.88 72.7414C109.996 72.6642 110.73 72.5869 110.807 72.7028Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.135 89.0732C105.942 89.6137 104.552 89.1504 104.977 88.2624C105.401 87.3743 106.367 88.5326 106.135 89.0732Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.305 68.6871C120.498 68.7643 120.807 69.1118 120.884 69.2662C120.922 69.4207 120.729 69.9998 120.536 69.9998C120.343 69.9998 119.996 69.9998 119.919 69.8068C119.764 69.6523 119.957 68.5713 120.305 68.6871Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.092 76.6024C115.092 76.5252 115.787 76.7568 115.826 76.7568C116.096 76.834 116.675 76.6796 116.56 76.2935C116.405 75.8302 114.938 76.0618 115.092 76.6024Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.475 73.2045C114.436 73.2045 114.397 73.0886 114.397 73.0886C114.359 73.05 114.282 73.0886 114.204 73.0886C114.011 73.1273 113.973 73.1659 113.895 73.3589C113.857 73.4747 113.702 73.8222 113.741 73.9381C113.741 73.9767 114.32 73.745 114.397 73.745C114.513 73.6678 114.513 73.6678 114.552 73.552C114.552 73.5134 114.513 73.2045 114.475 73.2045Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.305 75.135C111.193 74.8648 109.957 73.7065 109.455 73.9767C109.262 74.0926 109.223 74.7489 109.339 74.942C109.494 75.2122 110.034 75.2122 110.305 75.135Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.351 78.6871C112.274 78.5713 112.39 78.0694 112.467 77.9536C112.621 77.6833 112.969 77.8377 113.123 77.9536C113.278 78.108 113.432 78.4555 113.2 78.6485C113.007 78.803 112.505 78.9188 112.351 78.6871Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.046 87.2971C113.664 87.5288 113.046 88.4168 112.66 88.5326C111.617 88.8029 112.119 86.9882 113.046 87.2971Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.278 80.5792C113.162 80.502 112.969 79.807 113.007 79.6912C113.085 79.4595 113.509 79.5753 113.741 79.6139C114.166 79.7298 114.204 80.0386 113.895 80.3475C113.78 80.4634 113.471 80.6564 113.278 80.5792Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.2391 81.2353C93.7025 81.3898 94.0113 81.9303 93.2778 81.8917C92.5828 81.8145 92.6986 81.0423 93.2391 81.2353Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.59 63.0502C114.783 62.6255 113.741 62.4325 113.509 62.4711C112.892 62.5483 113.239 62.973 113.394 63.3205C113.509 63.5135 113.625 64.0541 113.934 64.0541C114.243 64.0155 114.513 63.2819 114.59 63.0502Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.413 68.3399C118.606 67.9152 117.564 67.7222 117.332 67.7608C116.714 67.838 117.062 68.2627 117.216 68.6102C117.332 68.8033 117.448 69.3438 117.757 69.3438C118.065 69.3052 118.336 68.5716 118.413 68.3399Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.255 64.9422C117.448 64.5174 116.405 64.3244 116.174 64.363C115.556 64.4402 115.903 64.8649 116.058 65.2124C116.174 65.4055 116.289 65.946 116.598 65.946C116.907 65.946 117.177 65.2124 117.255 64.9422Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.471 58.224C103.393 58.417 103.664 59.0734 103.548 59.1892C103.664 59.0734 104.011 59.112 104.127 59.0348C104.243 58.9575 104.397 58.8031 104.475 58.6487C104.629 58.3784 104.59 58.417 104.32 58.224C104.088 58.1081 103.664 57.8379 103.471 58.224Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.452 58.1467C108.606 58.1853 109.185 57.915 109.301 57.8378C109.494 57.6834 109.494 57.2973 109.378 57.1429C109.301 57.0656 108.992 56.7568 108.915 56.7568C108.76 56.7181 108.722 56.7568 108.645 56.9498C108.567 57.0656 108.181 58.0695 108.452 58.1467Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.031 68.6101C109.069 68.1854 108.066 67.6062 107.757 67.9923C107.525 68.2626 107.95 68.8417 108.066 69.1506C108.181 69.3823 108.567 69.3823 108.915 69.3437C109.224 69.2664 108.992 68.919 109.031 68.6101Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.046 85.7528C113.278 85.7142 113.162 84.942 113.008 84.7876C112.892 84.6717 112.66 84.0154 112.235 84.1312C112.158 84.1698 111.811 84.5559 111.849 84.749C111.888 84.942 112.351 85.5984 112.506 85.7528C112.621 85.8687 112.892 85.7914 113.046 85.7528Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.614 60.3862C110.536 61.3128 112.081 60.5406 112.003 60.0001C111.965 59.7684 111.347 59.4981 111.154 59.5367C110.845 59.614 110.652 60.0773 110.614 60.3862Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.571 59.7684C119.919 59.807 120.227 60.1159 120.614 59.8842C120.884 59.6912 120.922 59.3437 120.691 59.0734C120.536 58.8804 120.112 58.6487 119.88 58.7259C119.61 58.8032 119.224 59.7298 119.571 59.7684Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.594 58.3013C115.633 57.7221 114.166 57.6063 114.204 58.5715C114.204 59.5754 115.556 58.8804 115.594 58.3013Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.996 76.2936C109.725 76.3708 109.301 76.9886 109.571 77.2202C109.764 77.3747 110.189 77.1044 110.382 77.0272C110.614 76.9113 110.922 76.8341 110.845 76.448C110.807 76.1391 110.266 76.2164 109.996 76.2936Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.981 72.3552C115.71 72.4324 115.594 72.8185 115.865 73.0502C116.058 73.2046 116.212 73.166 116.405 73.0888C116.637 72.973 116.946 72.8957 116.869 72.5096C116.791 72.2008 116.251 72.278 115.981 72.3552Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.459 80.0773C100.807 80.2704 101.27 79.9615 101.154 79.6526C100.961 78.9576 99.9187 79.7684 100.459 80.0773Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.502 53.3592C111.772 53.3979 112.119 51.8921 111.27 52.3168C110.729 52.6257 110.922 53.3206 111.502 53.3592Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.421 57.336C120.459 57.4519 120.768 57.336 120.845 57.2974C121 57.1816 121.038 57.0271 121.116 56.8341C121.27 56.448 121.54 55.7916 120.961 55.5986C119.764 55.1739 120.189 56.8341 120.421 57.336Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.849 66.2934C101.926 66.2548 102.042 65.5985 101.965 65.4826C101.733 65.2124 101.116 65.3282 101.077 65.5985C100.923 66.2934 101.425 66.5637 101.849 66.2934Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.544 91.776C102.969 91.8146 103.201 90.6949 102.583 90.8108C102.235 90.888 102.158 91.776 102.544 91.776Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.668 86.1002C104.706 85.328 103.51 85.3666 103.471 85.7527C103.471 85.9072 103.51 86.525 103.625 86.5636C104.089 86.7566 104.629 86.718 104.668 86.1002Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.44 91.6989C105.015 91.6603 104.899 92.7028 105.208 92.7414C105.478 92.78 105.903 92.6642 105.98 92.3939C106.058 92.0464 105.749 91.7375 105.44 91.6989Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.162 53.5522C102.583 53.5136 102.042 54.5174 102.737 54.5947C103.355 54.6719 103.162 53.5522 103.162 53.5522Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.517 66.6796C115.015 66.641 114.629 68.3399 115.71 67.8765C116.598 67.4904 116.444 66.7569 115.517 66.6796Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.525 76.6024C117.139 76.8726 117.37 78.6487 118.104 77.6834C118.336 77.4132 118.374 77.3359 118.181 77.0271C118.104 76.9112 117.718 76.4865 117.525 76.6024Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.2237 59.6912C99.2237 59.614 98.1813 59.6526 98.1427 59.8456C97.9882 60.4634 99.1851 60.3862 99.2237 59.6912Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.633 63.0889C105.594 63.668 104.127 63.5908 104.282 62.6255C104.475 61.6603 105.672 62.5097 105.633 63.0889Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.942 74.8263C105.903 75.4055 104.436 75.3283 104.591 74.363C104.784 73.3977 105.981 74.2472 105.942 74.8263Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.521 70.6563C116.483 71.2355 115.015 71.1583 115.17 70.193C115.363 69.2278 116.56 70.0772 116.521 70.6563Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.872 81.2355C108.065 81.4285 108.065 81.8146 107.949 82.0077C107.911 82.0849 107.756 82.2393 107.679 82.278C107.563 82.3166 107.602 82.3166 107.525 82.2007C107.409 82.0849 107.139 81.7374 107.139 81.5444C107.1 81.3127 107.679 81.0811 107.872 81.2355Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.038 71.3901C101.27 71.3901 101.54 71.9692 101.579 72.1623C101.617 72.4712 101.502 72.7028 101.154 72.7414C100.498 72.8573 100.536 71.3515 101.038 71.3901Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.702 69.4981C113.664 70.0772 112.197 70 112.351 69.0347C112.544 68.0309 113.741 68.8803 113.702 69.4981Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.529 62.0463C118.683 62.0849 119.108 61.9305 119.262 62.0463C119.455 62.2394 119.146 62.6255 119.455 62.8185C119.726 63.0116 119.455 63.1274 119.571 63.4749C119.648 63.7065 118.876 63.6293 118.76 63.5521C118.529 63.3204 118.451 63.0502 118.451 62.7413C118.413 62.7413 118.374 62.0463 118.529 62.0463Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.513 80C114.745 80 114.938 80.1545 115.092 80.3475C115.363 80.695 115.401 81.1583 114.784 81.2742C114.436 81.3514 114.398 80.8495 114.282 80.6178C114.127 80.2317 114.05 79.9614 114.513 80Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.525 52.6643C117.525 52.4712 117.216 52.5098 117.1 52.4326C116.984 52.3168 116.946 52.0851 116.946 51.9307C116.907 51.4287 117.293 51.4287 117.564 51.7376C117.757 51.9693 118.104 52.3554 118.065 52.7029C118.027 53.1662 117.486 53.2048 117.525 52.6643Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.116 81.2742C110.923 81.2356 110.73 81.2356 110.652 81.3128C110.537 81.4287 110.305 81.4287 110.15 81.4287C109.648 81.3901 109.687 81.0426 109.996 80.7723C110.228 80.5793 110.691 80.2704 111 80.3476C111.463 80.4634 111.656 81.3515 111.116 81.2742Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.116 64.8651C121.656 64.9037 122.081 66.062 121.231 66.1006C120.807 66.1392 120.498 64.8265 121.116 64.8651Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.895 79.8841C103.857 80.4633 102.39 80.3861 102.544 79.4208C102.737 78.4556 103.934 79.305 103.895 79.8841Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.926 65.6757C112.042 65.7915 112.197 66.0618 112.081 66.1776C112.042 66.2548 111.579 66.4865 111.463 66.4478C111.347 66.4092 111.193 65.9845 111.27 65.9073C111.347 65.7915 111.849 65.5984 111.926 65.6757Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.768 72.3168C110.961 72.4712 111.116 72.8573 111 73.0118C110.922 73.1276 110.305 73.3979 110.15 73.3592C109.996 73.3206 109.803 72.7415 109.841 72.5871C109.957 72.4712 110.614 72.2396 110.768 72.3168Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.799 65.9075C118.992 65.9075 119.417 66.1777 119.494 66.3322C119.571 66.448 119.533 67.1044 119.378 67.143C119.224 67.1816 118.838 67.2588 118.722 67.143C118.567 66.9499 118.452 65.8689 118.799 65.9075Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.903 74.9034C115.865 74.8648 116.637 74.8648 116.637 74.8648C116.946 74.8648 117.448 74.5559 117.216 74.2084C116.984 73.8223 115.594 74.4401 115.903 74.9034Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.436 71.8148C114.398 71.8148 114.359 71.7376 114.32 71.7376C114.282 71.7376 114.204 71.7762 114.166 71.8148C113.973 71.892 113.934 71.9693 113.934 72.1237C113.934 72.2395 113.857 72.6256 113.934 72.7028C113.973 72.7414 114.475 72.3554 114.475 72.3167C114.552 72.2395 114.591 72.2009 114.552 72.0851L114.436 71.8148Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.884 74.7877C111.695 74.2858 110.151 73.5136 109.764 73.8997C109.61 74.0541 109.764 74.7105 109.919 74.8649C110.151 75.0966 110.652 74.9422 110.884 74.7877Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.857 77.6448C113.741 77.529 113.741 77.0657 113.78 76.9112C113.857 76.6023 114.243 76.6409 114.398 76.7568C114.591 76.8726 114.822 77.1429 114.668 77.3745C114.513 77.5676 114.05 77.8378 113.857 77.6448Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.76 70.1546C118.413 69.6141 118.915 68.533 119.61 69.1508C120.266 69.7685 119.146 70.7724 118.76 70.1546Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.208 79.2277C115.093 79.1891 114.706 78.5713 114.706 78.4555C114.706 78.2239 115.17 78.1853 115.401 78.1853C115.865 78.1466 115.981 78.4555 115.749 78.8416C115.71 78.9961 115.44 79.2663 115.208 79.2277Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0963 85.2509C96.5982 85.2895 97.0229 85.7142 96.328 85.8687C95.633 85.9845 95.5558 85.2123 96.0963 85.2509Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.536 65.3667C120.42 65.2123 119.687 65.135 119.648 64.9806C119.687 65.135 119.494 65.4053 119.532 65.5984C119.532 65.7528 119.648 65.9458 119.725 66.0617C119.88 66.2933 119.88 66.2933 120.15 66.1389C120.382 65.9845 120.806 65.7142 120.536 65.3667Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.745 58.6099C114.783 58.4555 114.475 57.9535 114.552 57.8763C114.475 57.9921 114.204 57.9921 114.089 58.0694C114.011 58.1466 113.934 58.301 113.857 58.4169C113.78 58.6485 113.78 58.6485 114.011 58.7257C114.282 58.803 114.668 58.9188 114.745 58.6099Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.382 53.2434C120.459 52.9731 120.073 52.3167 119.725 52.4712C119.494 52.5484 119.571 53.0889 119.532 53.282C119.494 53.5523 119.494 53.8611 119.803 53.9384C120.15 54.0156 120.305 53.5136 120.382 53.2434Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.046 52.2008C113.239 52.2008 113.664 51.8147 113.509 51.6216C113.393 51.4672 113.046 51.6216 112.892 51.6216C112.698 51.6602 112.467 51.6602 112.467 51.9305C112.428 52.2008 112.814 52.2008 113.046 52.2008Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.637 78.7645C116.367 79.0734 117.062 79.9614 117.37 79.3822C117.563 79.112 116.868 78.4942 116.637 78.7645Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.861 81.0811C115.131 80.7722 114.436 80 114.204 80.2316C114.011 80.4247 113.818 80.8108 114.011 81.0424C114.204 81.3127 114.668 81.3127 114.861 81.0811Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.915 69.9998C119.455 69.8068 118.297 68.301 117.911 68.8801C117.602 69.382 118.451 70.1542 118.915 69.9998Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.173 64.0541C115.865 63.8611 115.594 64.1313 115.401 64.2858C115.17 64.4788 115.092 64.6719 115.285 64.9807C115.749 65.7529 116.212 64.0927 116.173 64.0541Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.382 59.8841C110.614 59.8455 110.652 59.9613 110.729 59.691C110.807 59.4594 110.729 59.3822 110.498 59.3822C110.15 59.3822 109.803 59.9999 110.382 59.8841Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.903 54.247C115.787 54.1698 115.131 54.5173 115.092 54.6331C114.976 54.942 115.169 55.5983 115.633 55.5597C115.98 55.4825 116.25 54.44 115.903 54.247Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.965 55.7144C121.965 55.4055 120.613 54.6719 120.652 55.5213C120.652 55.8302 120.845 56.0619 121.077 56.1391C121.27 56.1777 121.965 55.9847 121.965 55.7144Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6058 72.8186C98.8375 72.7414 98.8761 72.278 98.8375 72.1622C98.6831 71.5831 98.297 71.7761 98.1425 72.1236C98.0653 72.278 97.9109 72.5483 98.0267 72.7028C98.2197 73.0889 98.3742 72.8572 98.6058 72.8186Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.266 76.4091C110.768 76.7179 111.54 75.4824 110.652 75.0577C109.764 74.633 109.764 76.1002 110.266 76.4091Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6019 64.5172C97.6791 64.4786 97.9108 64.1311 97.9108 64.0539C97.9494 63.8222 97.6019 63.6678 97.4089 63.745C97.2544 63.7836 97.1 64.1697 97.1 64.3242C97.1386 64.5172 97.4089 64.6331 97.6019 64.5172Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.903 73.8609C115.942 73.8609 116.366 73.8995 116.443 73.7451C116.559 73.5134 116.289 73.0115 116.212 72.9343C115.942 72.7026 115.517 73.0501 115.517 73.4362C115.555 73.5906 115.749 73.7451 115.903 73.8609Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.536 54.1312C100.613 54.1698 101.038 53.2045 100.884 53.0887C100.42 52.7026 99.9184 53.7837 100.536 54.1312Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.254 55.3668C106.714 55.0579 106.714 56.1776 107.061 56.2934C107.177 56.332 107.525 56.0617 107.563 55.9073C107.641 55.7142 107.409 55.444 107.254 55.3668Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.227 66.9499C109.996 66.6024 109.224 67.1815 109.726 67.6448C109.957 67.8379 110.034 67.9923 110.15 67.6834C110.189 67.4904 110.343 67.1043 110.227 66.9499Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.59 76.9496C104.204 76.718 104.784 75.7527 105.401 76.216C105.98 76.6794 104.977 77.2199 104.59 76.9496Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.389 66.8725C102.312 66.7181 102.428 66.525 102.505 66.3706C102.737 65.9459 103.084 66.1389 103.123 66.525C103.162 66.8339 103.2 66.9111 103.007 67.1814C102.737 67.5289 102.428 66.9883 102.389 66.8725Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.529 58.61C118.451 58.4555 118.142 58.108 118.297 57.9922C118.374 57.9536 118.799 57.3744 119.146 57.6061C119.532 57.8764 119.61 58.4941 119.532 58.5714C119.378 58.6486 118.567 58.6872 118.529 58.61Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.915 61.6217C119.108 61.5058 119.494 61.5444 119.61 61.6603C119.764 61.8533 119.532 62.4325 119.339 62.5097C119.223 62.5483 118.76 62.5483 118.683 62.4711C118.606 62.3552 118.837 61.5444 118.915 61.6217Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.521 48.3783C116.173 48.1853 116.521 47.915 116.791 48.0694C116.868 48.1467 116.984 48.3011 116.907 48.3783C116.83 48.4941 116.598 48.4169 116.521 48.3783Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.281 43.5908C114.474 43.2047 115.671 42.9344 115.401 43.4749C115.247 43.861 114.127 43.861 114.281 43.5908Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.181 49.421C107.872 49.2279 108.451 48.919 108.606 49.0735C108.683 49.1121 108.606 49.3824 108.567 49.421C108.451 49.5368 108.258 49.4982 108.181 49.421Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.428 63.2044C112.544 63.2817 112.699 63.7836 112.621 63.8994C112.505 64.1311 112.119 64.633 111.888 64.5172C111.463 64.3241 110.845 63.6678 111.27 63.3975C111.386 63.3203 112.235 63.05 112.428 63.2044Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.579 71.1582C111.695 71.1196 112.197 71.274 112.274 71.4285C112.351 71.6601 112.544 72.2779 112.312 72.3937C111.888 72.6254 111 72.7026 111.038 72.2393C111.038 72.0462 111.347 71.2354 111.579 71.1582Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.679 66.6408C117.795 66.718 117.949 67.2199 117.872 67.3358C117.756 67.5674 117.37 68.0693 117.139 67.9535C116.714 67.7605 116.096 67.1041 116.521 66.8338C116.675 66.7566 117.486 66.4863 117.679 66.6408Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.725 81.8146C109.841 81.5058 110.382 81.8146 110.614 81.9305C110.884 82.0463 110.922 82.3938 110.652 82.5868C110.498 82.7027 110.034 82.6255 109.841 82.5482C109.61 82.471 109.61 82.0849 109.725 81.8146Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.656 83.359C101.772 83.0502 102.312 83.359 102.544 83.4749C102.814 83.5907 102.853 83.9382 102.583 84.1312C102.428 84.247 101.965 84.1698 101.772 84.0926C101.54 83.9768 101.54 83.6293 101.656 83.359Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.752 75.7528C117.1 75.9459 116.405 76.8725 116.096 76.7953C115.556 76.7181 115.826 75.2123 116.752 75.7528Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.787 62.8958C105.478 63.0888 104.706 62.5869 105.054 62.3553C105.208 62.2394 106.057 62.7413 105.787 62.8958Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.822 69.9999C114.784 70.2702 113.934 70.3474 113.857 70.1544C113.857 70.1158 113.702 69.4208 113.664 69.4208C113.741 69.3822 114.359 69.2277 114.436 69.2663C114.668 69.4594 114.861 69.6524 114.822 69.9999Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.671 72.0848C105.401 72.5095 104.629 72.857 104.861 72.162C105.054 71.5056 105.98 71.5829 105.671 72.0848Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.023 50.1544C116.405 50.6563 117.293 51.5057 117.602 51.2355C117.718 51.1197 118.143 50.6949 118.104 50.5405C117.911 50.1158 117.486 49.7683 117.023 50.1544Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.228 59.4595C120.15 59.807 120.73 60.2704 121.039 60.309C121.425 60.3476 121.309 59.614 121.309 59.1893C121.309 58.4557 120.266 59.1121 120.228 59.4595Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.158 76.9111C102.119 76.8725 102.544 77.2972 102.544 77.2586C102.853 77.1814 103.239 76.6794 102.93 76.4092C102.544 76.0617 101.733 76.525 102.158 76.9111Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.174 75.5599C116.676 75.9846 116.676 75.2896 116.598 74.9808C116.521 74.7491 116.367 74.1313 116.135 73.9769C115.788 73.7452 115.517 74.17 115.479 74.5174C115.479 74.9035 115.903 75.3669 116.174 75.5599Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.262 52.3552C108.954 52.7413 108.413 52.278 108.683 52.8571C108.799 53.1274 109.262 53.5521 109.571 53.5521C110.421 53.5521 109.88 51.6216 109.262 52.3552Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.042 76.6796C112.042 77.1043 111.811 77.1429 112.274 77.3359C112.66 77.529 112.814 77.4131 112.853 77.027C112.93 76.4093 112.004 75.7143 112.042 76.6796Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.49 67.9537C118.76 68.0695 119.378 67.3745 119.533 67.1429C119.803 66.7954 119.648 66.5251 119.185 66.4479C118.606 66.2935 117.679 67.6448 118.49 67.9537Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.459 70.2316C110.73 70.0771 110.73 70.1157 110.768 69.7682C110.845 69.4207 110.691 69.3821 110.382 69.4207C110.15 69.4593 109.764 69.7296 109.803 70.0771C109.764 70.2702 110.305 70.3088 110.459 70.2316Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.602 63.6292C118.065 63.6292 118.915 62.0462 117.718 62.3937C117.37 62.5095 117.293 62.5482 117.293 62.8956C117.293 63.0501 117.409 63.6292 117.602 63.6292Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.896 64.7876C114.204 64.8262 115.093 63.5907 114.282 63.5135C113.973 63.4749 113.741 63.6293 113.625 63.861C113.548 64.054 113.625 64.749 113.896 64.7876Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.278 56.0231C112.815 56.6022 113.239 57.8377 113.896 57.1814C114.359 56.7567 113.625 55.5984 113.278 56.0231Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.254 67.1042C107.37 67.1814 107.949 66.8725 107.949 66.7567C107.988 66.6023 107.834 66.1003 107.679 66.0231C107.448 65.9459 106.946 66.2548 106.868 66.4478C106.791 66.7181 107.023 66.9111 107.254 67.1042Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.065 56.1392C118.104 56.2164 118.49 56.6025 118.606 56.6025C118.876 56.6797 119.146 56.2936 119.108 56.0233C119.069 55.8303 118.645 55.56 118.451 55.56C118.143 55.56 117.911 55.9075 118.065 56.1392Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.112 64.5561C110.305 64.9036 111.27 64.9808 111.502 64.5561C111.656 64.2858 110.961 63.475 110.691 63.475C110.305 63.5137 109.764 63.8998 110.112 64.5561Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.22 74.2469C108.181 74.2856 108.645 74.7103 108.799 74.5944C109.224 74.1697 108.645 73.7064 108.22 74.2469Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.096 57.529C106.482 57.7607 107.177 57.529 107.1 57.0657C107.023 56.4479 106.56 56.3321 106.019 56.4479C105.44 56.5251 105.633 57.2201 106.096 57.529Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.849 82.8569C102.235 82.3936 103.355 83.3202 102.66 84.0152C102.004 84.6716 101.502 83.2816 101.849 82.8569Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.363 48.4557C105.17 48.3013 105.092 48.0696 105.054 47.838C105.015 47.4132 105.247 46.9885 105.826 47.2202C106.135 47.3746 105.903 47.7607 105.864 48.031C105.826 48.4943 105.71 48.7646 105.363 48.4557Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.675 60.4248C116.482 60.2703 116.405 60.0387 116.367 59.807C116.328 59.3823 116.56 58.9576 117.139 59.1893C117.448 59.3437 117.216 59.7298 117.177 60.0001C117.139 60.4634 117.062 60.6951 116.675 60.4248Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.44 70.5406C115.556 70.7337 116.019 70.8109 116.019 70.8109C116.328 70.7337 116.714 70.2317 116.405 69.9615C116.019 69.614 115.247 70.2317 115.44 70.5406Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.393 68.8418C113.509 68.919 113.818 69.4209 113.664 69.5754C113.471 69.7684 113.085 69.4595 112.93 69.3051C112.814 69.1893 112.428 68.7645 112.583 68.6101C112.699 68.4557 113.278 68.7259 113.393 68.8418Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.293 54.7877C117.177 54.8649 116.675 54.9808 116.56 54.9035C116.367 54.7491 115.903 54.2858 116.058 54.0927C116.328 53.668 117.023 53.2047 117.255 53.6294C117.332 53.7452 117.486 54.6333 117.293 54.7877Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.069 48.533C118.799 48.8805 118.49 48.5716 118.451 48.2627C118.413 48.0311 118.374 47.5291 118.567 47.3747C118.76 47.1817 119.185 47.4133 119.301 47.645C119.417 47.838 119.224 48.3013 119.069 48.533Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.814 81.5057C113.316 81.776 112.505 82.2393 112.39 82.471C112.351 82.5482 112.351 82.7799 112.274 82.8185C112.197 82.8571 111.849 82.6254 111.772 82.5482C111.579 82.3165 111.733 81.776 111.888 81.5057C112.004 81.3513 111.926 81.3513 112.158 81.3127C112.312 81.3127 112.66 81.3899 112.814 81.5057Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.27 46.0617C110.961 45.8301 111.038 45.0965 111.579 45.3281C112.081 45.5212 111.617 46.332 111.27 46.0617Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.629 42.1236C104.32 41.892 104.397 41.1584 104.938 41.3901C105.44 41.5831 104.977 42.3939 104.629 42.1236Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.467 63.5136C102.158 63.2819 102.235 62.5483 102.776 62.78C103.316 62.973 102.853 63.7838 102.467 63.5136Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.316 50.0001C112.814 49.5753 112.66 48.6487 113.548 49.0348C113.973 49.2279 114.282 49.7298 114.089 50.0773C113.973 50.3475 113.625 50.2317 113.316 50.0001Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.174 41.7761C116.444 41.4287 115.479 40.9653 115.247 40.9653C114.629 40.8881 114.861 41.39 114.938 41.7761C114.977 42.0078 114.977 42.5483 115.286 42.587C115.556 42.6256 115.981 42.0078 116.174 41.7761Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.644 47.7992C118.915 47.4517 117.949 46.9884 117.718 46.9884C117.1 46.9112 117.332 47.4131 117.409 47.7992C117.447 48.0309 117.447 48.5714 117.756 48.61C118.027 48.6486 118.49 48.0309 118.644 47.7992Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.228 59.9613C120.498 59.6138 119.533 59.1505 119.301 59.1505C118.683 59.0733 118.915 59.5752 118.992 59.9613C119.031 60.193 119.031 60.7335 119.34 60.7721C119.649 60.8494 120.073 60.193 120.228 59.9613Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.297 44.2472C118.568 43.8997 117.602 43.4364 117.371 43.4364C116.753 43.3592 116.984 43.8611 117.062 44.2472C117.1 44.4789 117.1 45.0194 117.409 45.058C117.718 45.1353 118.143 44.4789 118.297 44.2472Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.482 34.4791C106.366 34.6335 106.444 35.3671 106.328 35.4443C106.482 35.3671 106.791 35.4829 106.946 35.4443C107.1 35.4057 107.254 35.2513 107.37 35.174C107.563 34.981 107.563 34.981 107.332 34.7493C107.1 34.4791 106.714 34.1316 106.482 34.4791Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.347 35.5599C111.463 35.6372 112.12 35.5213 112.235 35.4441C112.467 35.3283 112.544 34.9808 112.467 34.7877C112.429 34.7105 112.197 34.3244 112.12 34.2858C111.965 34.2086 111.927 34.2472 111.811 34.4016C111.734 34.5561 111.116 35.4441 111.347 35.5599Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.417 45.8689C109.533 45.4442 108.722 44.672 108.297 44.9808C107.988 45.2125 108.297 45.8689 108.336 46.1778C108.374 46.4094 108.76 46.5252 109.108 46.5639C109.455 46.5639 109.339 46.1391 109.417 45.8689Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.339 63.5136C109.571 63.5136 109.648 62.7414 109.533 62.5483C109.455 62.3939 109.378 61.6989 108.953 61.7375C108.838 61.7375 108.451 62.085 108.413 62.2395C108.413 62.4325 108.722 63.2047 108.838 63.3591C108.915 63.475 109.185 63.5136 109.339 63.5136Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.93 38.2241C112.66 39.1121 114.32 38.726 114.359 38.1469C114.359 37.9152 113.818 37.5291 113.625 37.4905C113.316 37.5291 113.007 37.9538 112.93 38.2241Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.143 54.4403C118.451 54.5561 118.722 54.9422 119.108 54.7878C119.417 54.6719 119.533 54.3244 119.378 54.0156C119.262 53.7839 118.915 53.475 118.683 53.475C118.413 53.5136 117.834 54.3244 118.143 54.4403Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.567 53.5521C108.297 53.5521 107.757 54.0541 107.95 54.3629C108.104 54.556 108.567 54.3629 108.799 54.3629C109.069 54.3243 109.34 54.2857 109.378 53.9382C109.378 53.5907 108.838 53.5521 108.567 53.5521Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.594 71.0425C115.324 71.0425 114.783 71.5444 114.976 71.8533C115.131 72.0464 115.594 71.8533 115.826 71.8533C116.096 71.8147 116.366 71.7761 116.405 71.4286C116.405 71.0811 115.864 71.0425 115.594 71.0425Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.328 78.4171C116.289 78.224 115.826 77.9151 115.633 78.1082C115.517 78.2626 115.71 78.5715 115.787 78.6873C115.865 78.8804 115.942 79.0734 116.212 79.0348C116.444 78.9962 116.366 78.6101 116.328 78.4171Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.324 51.1584C115.054 51.1584 114.822 51.5059 115.054 51.8148C115.208 52.0079 115.363 52.0079 115.556 51.9692C115.826 51.9306 116.096 51.892 116.135 51.5445C116.135 51.1584 115.595 51.1584 115.324 51.1584Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4129 54.9806C98.6832 55.2509 99.2237 55.0579 99.1851 54.7104C99.1851 54.054 97.9496 54.5945 98.4129 54.9806Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.008 41.9693C103.123 41.9307 103.355 41.3516 103.278 41.2357C103.123 40.9269 102.506 40.8882 102.39 41.1585C102.081 41.7377 102.506 42.0851 103.008 41.9693Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6793 66.8726C98.0654 66.9885 98.5673 65.9846 97.9109 65.946C97.602 65.9074 97.3318 66.7954 97.6793 66.8726Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.116 61.8533C101.347 61.0811 100.15 60.888 100.035 61.2355C99.996 61.39 99.8802 62.0077 99.996 62.085C100.382 62.3552 100.923 62.4324 101.116 61.8533Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.536 67.4905C100.15 67.3747 99.7643 68.3399 100.035 68.4558C100.305 68.533 100.73 68.533 100.884 68.3013C101.077 67.9924 100.845 67.5677 100.536 67.4905Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.648 65.9847C109.262 65.8688 108.876 66.8341 109.146 66.9499C109.417 67.0271 109.841 67.0271 109.996 66.7955C110.15 66.4866 109.957 66.1005 109.648 65.9847Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.293 29.8458C106.753 29.6527 105.98 30.5407 106.637 30.7724C107.177 30.9654 107.293 29.8458 107.293 29.8458Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.93 60.695C112.583 60.2317 111.424 61.6989 112.081 61.9305C112.621 62.1236 113.2 61.0811 112.93 60.695Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.177 61.1583C117.139 60.8109 116.405 60.5792 116.135 60.6564C115.749 60.7722 115.44 61.2742 115.556 61.6603C115.749 62.3553 117.216 61.5058 117.177 61.1583Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.382 61.8919C120.228 61.7761 119.764 61.8533 119.726 61.8533C119.494 62.0464 119.301 62.6641 119.687 62.78C120.189 62.973 120.691 62.1236 120.382 61.8919Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.174 45.5213C115.672 45.3669 114.938 46.9499 116.096 46.7569C117.023 46.5638 117.1 45.7916 116.174 45.5213Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.641 75.1739C117.602 75.2897 118.104 75.8688 118.22 75.8688C118.529 75.9075 119.146 75.56 118.992 75.1353C118.799 74.7492 117.756 74.7878 117.641 75.1739Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.826 55.6372C115.401 55.7917 115.17 57.5677 116.135 56.8341C116.405 56.6025 116.482 56.5639 116.366 56.2164C116.328 56.0619 116.019 55.56 115.826 55.6372Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.641 68.9189C117.332 68.9961 116.946 70.5019 117.756 70.2317C118.065 70.1544 118.22 69.9228 118.258 69.6525C118.258 69.4595 117.911 68.8417 117.641 68.9189Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.977 67.1044C114.861 66.9113 114.397 66.9499 114.282 67.0271C113.78 67.2974 114.05 67.6449 114.436 67.6835C114.59 67.7221 115.401 67.6835 115.556 67.5677C115.826 67.2588 115.054 67.2974 114.977 67.1044Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.842 64.4789C119.726 63.9383 118.838 64.2086 118.761 64.363C118.606 64.6333 118.838 65.0194 119.147 65.0194C119.494 65.058 119.919 64.7878 119.842 64.4789Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.004 34.9037C102.042 34.8265 101 34.6334 100.922 34.7879C100.614 35.367 101.772 35.56 102.004 34.9037Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.409 39.73C107.216 40.3092 105.826 39.8458 106.212 38.9578C106.637 38.0312 107.602 39.1509 107.409 39.73Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.977 51.1969C104.784 51.7761 103.394 51.3128 103.78 50.4247C104.166 49.5367 105.17 50.6178 104.977 51.1969Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.251 49.6139C116.058 50.193 114.668 49.7297 115.054 48.8417C115.44 47.9536 116.444 49.0733 116.251 49.6139Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.363 57.9152C105.517 58.1469 105.401 58.533 105.247 58.6874C105.17 58.7646 105.015 58.8805 104.899 58.8805C104.784 58.8805 104.822 58.8805 104.745 58.7646C104.668 58.6102 104.475 58.2241 104.513 58.031C104.591 57.7994 105.208 57.6836 105.363 57.9152Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.038 46.7183C101.27 46.7956 101.386 47.4133 101.386 47.6064C101.347 47.9152 101.193 48.1083 100.845 48.0697C100.15 47.9925 100.536 46.5639 101.038 46.7183Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.78 47.7993C113.587 48.3785 112.197 47.9151 112.583 47.0271C112.969 46.1391 113.973 47.2588 113.78 47.7993Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.119 58.224C112.351 58.3013 112.505 58.4557 112.621 58.6874C112.814 59.0735 112.737 59.5754 112.119 59.5368C111.772 59.5368 111.849 59.0348 111.772 58.8032C111.656 58.3399 111.695 58.0696 112.119 58.224Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.49 58.6487C108.297 58.5715 108.143 58.4943 108.027 58.5715C107.873 58.6487 107.68 58.6101 107.525 58.5715C107.062 58.4171 107.178 58.0696 107.525 57.9151C107.795 57.7993 108.297 57.6063 108.606 57.7607C109.031 57.9537 108.992 58.8804 108.49 58.6487Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5247 78.2626C97.8722 78.3784 98.0267 79.2664 97.4861 79.1506C97.1387 79.0734 97.1387 78.1081 97.5247 78.2626Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.81 55.6372C101.617 56.2164 100.227 55.7531 100.614 54.865C101 53.977 101.965 55.0967 101.81 55.6372Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.919 57.5291C119.841 57.4905 119.378 57.0658 119.455 56.95C119.533 56.7955 119.764 56.5639 119.88 56.6025C119.957 56.6411 120.614 56.8727 120.575 56.9886C120.536 57.1044 119.996 57.5291 119.919 57.5291Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.363 71.9304C105.479 72.0462 105.517 72.3551 105.401 72.4709C105.324 72.5481 104.822 72.6254 104.745 72.5868C104.629 72.5095 104.591 72.0848 104.668 72.0076C104.745 71.8918 105.286 71.8146 105.363 71.9304Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.969 43.7066C113.085 43.8224 113.123 44.1313 113.007 44.2471C112.93 44.3243 112.428 44.4016 112.351 44.363C112.235 44.2857 112.197 43.861 112.274 43.7838C112.351 43.668 112.892 43.6294 112.969 43.7066Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.174 63.8223C116.289 63.9768 116.367 64.3629 116.212 64.4787C116.135 64.5559 115.517 64.6717 115.44 64.5945C115.324 64.5173 115.247 63.9768 115.363 63.8995C115.44 63.7837 116.096 63.7065 116.174 63.8223Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.231 52.8573C121.347 53.0118 121.424 53.3979 121.27 53.5137C121.193 53.5909 120.575 53.7068 120.498 53.6295C120.382 53.5523 120.305 53.0118 120.421 52.9346C120.498 52.8187 121.116 52.7415 121.231 52.8573Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.266 49.8842C110.421 50.0773 110.459 50.502 110.344 50.6178C110.266 50.695 109.571 50.8495 109.455 50.7722C109.301 50.695 109.262 50.0773 109.34 49.9614C109.417 49.8456 110.15 49.7684 110.266 49.8842Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.231 71.5831C121.116 71.6989 120.807 72.0464 120.691 71.9692C120.614 71.892 119.957 71.6217 120.112 71.2356C120.266 70.7723 120.884 70.5793 120.961 70.6565C121.077 70.7337 121.309 71.5059 121.231 71.5831Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.174 66.4091C105.981 66.9883 104.591 66.525 104.977 65.637C105.363 64.7489 106.328 65.8686 106.174 66.4091Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.571 45.5213C119.764 45.5985 120.112 45.9074 120.15 46.1004C120.189 46.2549 120.035 46.834 119.842 46.8726C119.649 46.8726 119.301 46.8726 119.185 46.7182C119.069 46.4865 119.224 45.4441 119.571 45.5213Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.772 75.9458C111.656 76.3319 111.308 76.0616 111.424 75.7527C111.463 75.6369 111.579 75.5211 111.733 75.5597C111.81 75.6369 111.81 75.83 111.772 75.9458Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.386 70.8495C110.807 70.7336 110.073 69.2665 110.884 69.3823C111.425 69.4595 111.772 70.9267 111.386 70.8495Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.641 79.2277C107.216 79.1505 106.675 78.0308 107.293 78.1466C107.679 78.2238 107.949 79.3049 107.641 79.2277Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.629 53.5909C114.591 53.5136 115.324 53.7067 115.363 53.7453C115.633 53.8225 116.212 53.6295 116.096 53.2434C115.942 52.7801 114.475 53.0889 114.629 53.5909Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.934 50.2705C113.896 50.2705 113.857 50.1546 113.857 50.1546C113.818 50.116 113.741 50.1546 113.664 50.1546C113.471 50.1932 113.432 50.2318 113.355 50.4249C113.317 50.5407 113.162 50.8882 113.201 51.004C113.201 51.0427 113.78 50.811 113.818 50.7724C113.934 50.6952 113.934 50.6952 113.973 50.5407C114.012 50.5407 113.973 50.2705 113.934 50.2705Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.803 52.3167C110.691 52.0078 109.378 50.8881 108.915 51.197C108.722 51.3128 108.722 52.0078 108.838 52.1622C108.992 52.4325 109.533 52.3939 109.803 52.3167Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.177 57.9923C117.177 58.1081 117.332 58.6873 117.371 58.7645C117.564 58.9962 118.065 58.8031 118.143 58.5328C118.22 58.3398 117.988 57.8379 117.795 57.722C117.602 57.4904 117.216 57.6448 117.177 57.9923Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.004 55.7916C111.926 55.6757 112.004 55.1738 112.081 55.058C112.235 54.7877 112.583 54.9035 112.737 55.058C112.892 55.2124 113.085 55.5213 112.853 55.753C112.66 55.8688 112.158 56.0232 112.004 55.7916Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.529 49.6527C118.336 49.0349 119.069 48.1083 119.571 48.8805C120.073 49.6527 118.76 50.3477 118.529 49.6527Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.008 64.4015C113.625 64.5945 113.046 65.5212 112.66 65.637C111.618 65.9459 112.042 64.0926 113.008 64.4015Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.784 83.7836C114.668 84.1311 114.243 83.6292 114.359 83.4361C114.397 83.3589 114.668 83.3589 114.706 83.3975C114.822 83.4747 114.784 83.6678 114.784 83.7836Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.301 68.224C119.185 68.1468 118.915 67.3746 118.954 67.2202C119.031 66.9499 119.533 67.0658 119.803 67.1044C120.305 67.1816 120.382 67.5677 120.035 67.9152C119.919 68.0696 119.533 68.3013 119.301 68.224Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.969 57.6448C112.853 57.6062 112.621 56.9112 112.66 56.7568C112.737 56.5252 113.162 56.6024 113.394 56.6796C113.857 56.7568 113.896 57.0657 113.587 57.4132C113.471 57.529 113.162 57.7607 112.969 57.6448Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.988 51.0813C118.065 50.9655 118.49 50.6952 118.645 50.7338C118.876 50.811 119.455 51.0427 119.417 51.313C119.34 51.7763 118.838 52.5099 118.49 52.201C118.336 52.0466 117.911 51.2744 117.988 51.0813Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9689 59.0348C93.4322 59.1892 93.7797 59.6912 93.0461 59.6912C92.3511 59.6525 92.4284 58.8417 92.9689 59.0348Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.297 49.5755C107.872 49.6141 107.757 50.7338 108.413 50.5407C108.722 50.4635 108.645 49.5755 108.297 49.5755Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.907 55.5213C106.946 56.2935 108.143 56.1004 108.104 55.7143C108.104 55.5599 107.95 54.9421 107.834 54.9035C107.409 54.7877 106.869 54.9035 106.907 55.5213Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.44 50.0774C105.865 50.0388 105.865 48.9963 105.556 48.9963C105.285 48.9963 104.899 49.1508 104.822 49.4597C104.745 49.7685 105.092 50.0774 105.44 50.0774Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.942 44.7879C116.482 45.0195 116.675 43.1276 115.98 43.2821C115.401 43.4365 115.517 44.5948 115.942 44.7879Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.328 58.3397C116.56 58.6099 117.293 58.3783 117.486 58.1852C117.756 57.8763 117.061 57.5675 116.753 57.3358C116.173 56.8725 116.096 58.108 116.328 58.3397Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.204 63.0887C104.32 63.5521 103.664 63.7451 104.282 63.8609C104.591 63.9381 105.208 63.7837 105.363 63.5134C105.826 62.8571 103.934 62.2007 104.204 63.0887Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.027 53.2048C117.911 52.8573 117.563 52.8573 117.332 52.8573C117.023 52.8187 116.83 52.8959 116.753 53.282C116.56 54.1314 118.027 53.2434 118.027 53.2048Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.691 50.1544C120.459 50.1158 120.228 50.3861 120.15 50.5405C120.034 50.8494 120.15 50.8108 119.841 51.0038C119.648 51.1583 119.494 51.1969 119.687 51.5058C119.88 51.776 120.652 51.776 120.845 51.4671C120.923 51.3513 120.961 51.0038 121 50.8494C120.961 50.8494 120.768 50.193 120.691 50.1544Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.17 53.5907C114.938 53.5907 114.59 53.7065 114.475 53.8996C114.282 54.1698 114.397 54.2084 114.668 54.2857C114.938 54.3629 115.401 54.3243 115.594 54.0926C116.058 53.6293 115.479 53.5907 115.17 53.5907Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.22 62.8958C118.49 62.5097 117.718 60.9267 117.293 62.085C117.177 62.4325 117.177 62.5097 117.448 62.7413C117.563 62.8186 118.065 63.0888 118.22 62.8958Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.984 66.6022C117.216 66.3705 116.714 64.9033 116.173 65.5597C115.98 65.7914 115.942 66.0616 116.058 66.2933C116.173 66.4477 116.791 66.7952 116.984 66.6022Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.2238 32.8959C99.4554 33.0117 99.8029 32.7028 99.8415 32.587C100.112 32.0851 99.7257 31.9306 99.3782 32.0851C99.2238 32.1623 98.9535 32.2395 98.8763 32.394C98.799 32.8573 99.0693 32.7801 99.2238 32.8959Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.285 43.5137C105.44 44.0929 106.869 43.7068 106.482 42.7802C106.135 41.8535 105.131 42.9346 105.285 43.5137Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.494 62.0078C109.687 62.7414 110.961 63.0889 110.807 62.1623C110.729 61.5059 109.339 61.4673 109.494 62.0078Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.977 73.3203C115.092 73.2817 115.208 72.6253 115.131 72.5481C115.015 72.4323 114.513 72.2392 114.397 72.3164C114.204 72.4323 114.166 73.05 114.282 73.2045C114.436 73.5133 114.706 73.3975 114.977 73.3203Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.428 50.7724C112.544 50.7338 112.66 50.0774 112.583 50.0002C112.467 49.8843 111.965 49.6913 111.849 49.7685C111.656 49.8843 111.618 50.5021 111.733 50.6565C111.888 50.9268 112.158 50.8496 112.428 50.7724Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.39 58.1854C112.467 58.1854 113.007 58.0696 113.085 58.031C113.316 57.8765 113.162 57.4132 112.93 57.2974C112.737 57.2202 112.312 57.4132 112.158 57.5676C111.965 57.7607 112.119 58.1468 112.39 58.1854Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.382 53.0502C110.459 53.0502 111 52.9344 111.077 52.8958C111.309 52.7413 111.154 52.278 110.923 52.1622C110.73 52.085 110.305 52.278 110.15 52.4324C109.957 52.6641 110.112 53.0116 110.382 53.0502Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.259 55.0192C118.336 55.0192 118.876 54.9034 118.954 54.8648C119.185 54.7103 119.031 54.247 118.799 54.1312C118.606 54.054 118.181 54.247 118.027 54.4015C117.834 54.5945 117.95 54.9806 118.259 55.0192Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.243 26.1778C104.32 26.1778 104.745 26.1006 104.783 26.062C104.977 25.9461 104.822 25.56 104.629 25.4828C104.475 25.4056 104.127 25.56 104.011 25.6759C103.895 25.8303 104.011 26.1392 104.243 26.1778Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.591 69.5366C115.015 69.5752 115.633 68.8416 115.401 68.4169C115.247 68.1466 114.204 68.2239 114.05 68.4555C113.857 68.7258 113.857 69.4208 114.591 69.5366Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.116 45.5212C111.116 45.5598 111.425 45.8687 111.618 45.7915C111.888 45.6757 112.004 45.1351 112.004 45.0579C111.965 44.7104 111.425 44.6718 111.154 44.9421C111.038 45.0965 111.077 45.3282 111.116 45.5212Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.521 68.6873C106.946 68.4943 107.177 67.7993 106.714 67.5677C106.174 67.2974 105.787 67.6063 105.556 68.0696C105.324 68.6487 106.019 68.8804 106.521 68.6873Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.733 36.6025C111.811 36.1778 110.845 36.1005 110.884 36.7569C110.923 37.0658 110.884 37.2202 111.154 37.0658C111.309 36.9886 111.695 36.7955 111.733 36.6025Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.768 40.0388C100.652 39.6141 101.733 39.3052 101.849 40.0388C101.965 40.7724 100.884 40.4635 100.768 40.0388Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.783 50.9654C114.861 50.3863 116.328 50.618 116.058 51.5446C115.826 52.5098 114.706 51.5446 114.783 50.9654Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7217 64.0154C98.4901 64.0927 98.2584 64.0154 98.0653 63.8996C97.6792 63.6679 97.4862 63.2432 98.0267 62.8957C98.3356 62.7413 98.5287 63.166 98.7217 63.3205C99.0306 63.6679 99.185 63.861 98.7217 64.0154Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.054 61.7759C114.822 61.8531 114.591 61.7759 114.397 61.6601C114.011 61.4284 113.818 61.0037 114.359 60.6562C114.668 60.5018 114.861 60.9265 115.054 61.081C115.363 61.4284 115.517 61.6601 115.054 61.7759Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.058 31.1584C106.135 31.0039 106.328 30.9267 106.482 30.8881C106.946 30.7337 107.062 31.1198 106.83 31.4287C106.675 31.6603 106.637 31.7761 106.289 31.8148C105.865 31.892 106.019 31.2742 106.058 31.1584Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.957 69.3438C120.112 69.3051 120.652 69.3051 120.691 69.5368C120.73 69.8071 120.266 69.9229 120.073 70.0001C119.919 70.0387 119.34 70.116 119.301 69.8843C119.262 69.6912 119.803 69.3824 119.957 69.3438Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.722 45.9462C118.915 45.9848 119.108 46.2164 119.108 46.3709C119.108 46.5639 118.606 46.7956 118.49 46.7184C118.413 46.6798 118.104 46.4095 118.104 46.3323C118.104 46.2164 118.722 45.8689 118.722 45.9462Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.305 56.8341C120.227 56.8727 120.034 56.2936 120.034 56.255C120.034 56.0619 120.382 55.6372 120.614 55.8302C120.768 55.9461 120.536 56.7569 120.305 56.8341Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.602 49.7684C117.525 49.807 117.332 49.2278 117.332 49.1892C117.332 48.9962 117.679 48.5715 117.911 48.7645C118.065 48.919 117.834 49.7298 117.602 49.7684Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.896 48.5715C113.625 48.417 113.973 48.0695 114.089 47.9537C114.359 47.7607 114.591 47.529 114.899 47.722C115.401 48.0695 115.131 48.8417 114.668 49.0348C114.089 49.3437 114.359 48.8417 113.896 48.5715Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.691 54.6332C120.459 54.8649 120.228 54.4016 120.189 54.2471C120.073 53.9383 119.919 53.6294 120.228 53.4363C120.73 53.0502 121.347 53.5522 121.386 54.0541C121.463 54.6719 121.077 54.2858 120.691 54.6332Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.845 57.9923C110.845 58.1468 110.652 58.6101 110.498 58.6487C110.266 58.7259 109.61 58.8418 109.533 58.5715C109.339 58.1082 109.378 57.2588 109.841 57.336C110.034 57.3746 110.807 57.7607 110.845 57.9923Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.803 40.5794C109.919 40.6566 110.15 41.1199 110.112 41.2357C110.035 41.4674 109.726 42.0466 109.494 41.9693C109.031 41.8535 108.336 41.313 108.683 40.9655C108.838 40.8496 109.61 40.4636 109.803 40.5794Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.37 41.5058C117.37 41.6602 117.177 42.1235 117.023 42.1621C116.791 42.2393 116.135 42.3552 116.058 42.0849C115.865 41.6216 115.903 40.7722 116.367 40.8494C116.56 40.8494 117.332 41.2741 117.37 41.5058Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.344 48.1854C120.344 48.3398 120.15 48.8031 119.996 48.8418C119.764 48.919 119.108 49.0348 119.031 48.7645C118.838 48.3012 118.876 47.4518 119.34 47.529C119.533 47.5676 120.305 47.9537 120.344 48.1854Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.791 52.8957C106.907 53.3204 106.482 53.3976 106.212 53.2432C106.019 53.1274 105.594 52.8571 105.556 52.6255C105.517 52.3552 105.942 52.1621 106.173 52.2008C106.444 52.2394 106.714 52.6255 106.791 52.8957Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.154 47.0657C101.463 46.9499 101.617 47.5291 101.695 47.7607C101.772 48.031 101.617 48.3399 101.27 48.2627C101.077 48.224 100.768 47.8766 100.729 47.6835C100.614 47.4518 100.884 47.2202 101.154 47.0657Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2429 42.6642C94.5517 42.5483 94.7062 43.1275 94.7834 43.3591C94.8606 43.6294 94.7062 43.9383 94.3587 43.8611C94.1656 43.8225 93.8568 43.475 93.8182 43.2819C93.7409 43.0117 93.9726 42.78 94.2429 42.6642Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.421 47.4905C110.536 47.8766 109.417 48.0696 109.224 47.7994C108.915 47.3361 110.15 46.448 110.421 47.4905Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.969 41.9693C112.776 42.1237 112.119 41.6218 112.158 41.3901C112.158 41.3515 112.544 40.7724 112.505 40.7338C112.583 40.7724 113.162 41.0813 113.162 41.1585C113.239 41.4674 113.239 41.7376 112.969 41.9693Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.899 37.2203C104.436 37.3361 103.625 37.0659 104.243 36.7184C104.861 36.3709 105.44 37.0659 104.899 37.2203Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.228 57.7992C99.8416 57.915 99.301 57.4131 99.803 57.1428C100.266 56.8339 100.652 57.6834 100.228 57.7992Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1619 60.9267C92.7758 61.0425 92.2353 60.5406 92.7372 60.2703C93.2005 59.9614 93.5866 60.7722 93.1619 60.9267Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.262 75.0964C108.876 75.2123 108.336 74.7103 108.838 74.4401C109.339 74.1698 109.726 74.9806 109.262 75.0964Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.629 58.417C104.011 58.5715 103.162 58.1467 103.973 57.6834C104.359 57.4518 104.977 57.529 105.131 57.8379C105.286 58.1467 104.977 58.3398 104.629 58.417Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.231 68.1079C121.231 67.992 120.922 67.9534 120.845 67.9534C120.652 67.9534 120.536 68.1079 120.382 68.2237C120.073 68.494 119.532 68.9573 119.957 69.4206C120.807 70.3086 121.193 68.6484 121.231 68.1079Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.27 33.5135C110.961 33.2046 110.073 33.8996 110.614 34.247C110.922 34.4401 111.54 33.7837 111.27 33.5135Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.98 36.5252C105.44 37.1043 106.405 37.8379 106.675 37.529C106.791 37.4132 107.139 36.9113 107.061 36.7954C106.868 36.4093 106.405 36.1005 105.98 36.5252Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.992 31.7375C109.301 32.0464 110.073 31.3128 109.841 31.0812C109.648 30.8881 109.262 30.6951 109.031 30.8495C108.722 31.0812 108.722 31.5059 108.992 31.7375Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.301 64.0925C119.61 64.5944 121.038 63.6291 120.459 63.243C119.957 62.8955 118.915 63.4361 119.301 64.0925Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.984 54.4399C116.946 54.7874 117.602 55.1735 117.911 55.1735C118.297 55.1735 118.76 54.7488 118.722 54.3241C118.645 53.6291 117.023 54.0925 116.984 54.4399Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.282 49.8068C114.243 50.1542 114.899 50.5403 115.208 50.5403C115.594 50.5403 116.058 50.1156 116.019 49.6909C115.942 48.9959 114.32 49.4593 114.282 49.8068Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.305 45.3668C110.266 45.7143 110.923 46.1004 111.231 46.1004C111.618 46.1004 111.386 45.3668 111.347 44.9807C111.27 44.2471 110.343 45.0579 110.305 45.3668Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.552 64.9034C94.4748 64.8648 94.9768 65.2123 94.9768 65.2123C95.2856 65.0964 95.5945 64.5559 95.247 64.3242C94.8223 64.054 94.0501 64.5945 94.552 64.9034Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.035 55.9459C119.996 55.9073 120.652 55.5984 120.691 55.5984C120.961 55.4826 121.27 54.9806 120.923 54.749C120.536 54.4787 119.571 55.637 120.035 55.9459Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.297 61.853C108.876 62.2005 108.76 61.5055 108.645 61.2352C108.529 61.0036 108.297 60.4244 108.066 60.27C107.679 60.077 107.448 60.5403 107.486 60.8878C107.525 61.3125 107.988 61.6986 108.297 61.853Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5673 39.6911C98.297 40.1158 97.7179 39.7297 98.0653 40.2702C98.2198 40.5405 98.7217 40.888 99.0306 40.8494C99.88 40.7336 99.0692 38.8803 98.5673 39.6911Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.367 52.6641C116.367 52.7027 116.251 52.6254 116.212 52.6254C116.174 52.6254 116.135 52.7027 116.096 52.7413C115.981 52.8957 115.942 52.9729 116.058 53.1274C116.096 53.2432 116.212 53.5907 116.289 53.6679C116.328 53.7065 116.598 53.1274 116.637 53.0888C116.676 52.9729 116.676 52.9343 116.598 52.8185C116.598 52.8571 116.405 52.6641 116.367 52.6641Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.255 51.2356C117.679 51.5058 118.799 50.1545 117.641 50.0773C116.714 50.0001 116.444 50.7336 117.255 51.2356Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.672 61.1195C115.942 61.3511 116.521 60.965 116.56 60.7334C116.56 60.6562 116.212 60.2315 116.135 60.2315C115.865 60.2701 115.401 60.8878 115.672 61.1195Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.475 56.8726C114.977 56.0617 113.239 56.0231 113.085 56.5637C113.008 56.7567 113.432 57.2973 113.625 57.3745C113.934 57.4903 114.32 57.1428 114.475 56.8726Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.208 43.1273C115.401 42.8185 115.131 42.5482 114.977 42.3552C114.784 42.0849 114.59 42.0463 114.282 42.2393C113.548 42.664 115.208 43.166 115.208 43.1273Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.923 74.8262C111.347 74.5173 111.193 74.0154 110.961 73.7451C110.691 73.3976 110.459 73.3204 109.996 73.5907C108.953 74.1698 110.343 75.2123 110.923 74.8262Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.753 58.9573C117.177 58.6484 117.023 58.1465 116.791 57.8762C116.521 57.5288 116.289 57.4515 115.826 57.7218C114.784 58.301 116.212 59.3048 116.753 58.9573Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.32 63.5132C104.398 63.938 104.166 63.9766 104.629 64.131C105.015 64.2468 105.17 64.1696 105.17 63.7449C105.17 63.1271 104.166 62.5094 104.32 63.5132Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.61 54.0154C109.88 54.0926 110.421 53.3204 110.536 53.0887C110.73 52.7026 110.575 52.471 110.112 52.4324C109.533 52.3937 108.799 53.8223 109.61 54.0154Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.965 57.2585C102.197 57.0655 102.197 57.1041 102.235 56.7566C102.274 56.4091 102.12 56.4091 101.811 56.4863C101.579 56.5249 101.232 56.8724 101.309 57.1813C101.309 57.4129 101.811 57.3743 101.965 57.2585Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.343 53.9381C120.421 53.8223 120.073 53.1659 119.957 53.1273C119.648 53.0115 118.992 53.2045 119.031 53.6292C119.108 54.0539 120.15 54.2856 120.343 53.9381Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.587 50.8493C113.664 50.7335 113.316 50.0771 113.201 50.0385C112.892 49.9227 112.235 50.1157 112.274 50.5405C112.351 50.9266 113.394 51.1968 113.587 50.8493Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.007 41.3126C112.853 41.1196 112.544 40.9651 112.274 41.0038C111.965 41.0424 112.004 41.1582 112.158 41.4285C112.274 41.6601 112.621 42.0076 112.93 42.0076C113.587 41.969 113.2 41.5443 113.007 41.3126Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.258 49.8456C108.722 49.807 109.34 48.1467 108.22 48.6101C107.911 48.7645 107.834 48.8031 107.834 49.1506C107.872 49.305 108.027 49.8842 108.258 49.8456Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.706 51.467C105.015 51.467 105.749 50.1156 104.938 50.1543C104.629 50.1543 104.397 50.3087 104.32 50.579C104.243 50.772 104.436 51.467 104.706 51.467Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.007 42.8572C102.621 43.5136 103.2 44.6719 103.78 43.9383C104.166 43.3978 103.278 42.3553 103.007 42.8572Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3742 54.5558C98.49 54.633 99.0306 54.2469 99.0306 54.131C99.0306 53.9766 98.8375 53.4747 98.6831 53.4361C98.4514 53.3588 97.9881 53.7449 97.9495 53.938C97.8723 54.2469 98.1425 54.4013 98.3742 54.5558Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.2 37.3746C113.316 37.4519 113.857 37.0658 113.857 36.9499C113.857 36.7955 113.664 36.2936 113.509 36.255C113.278 36.1777 112.814 36.5638 112.776 36.7569C112.737 37.0658 112.969 37.2202 113.2 37.3746Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.757 42.3553C107.795 42.4325 108.258 42.7414 108.336 42.78C108.606 42.8572 108.838 42.4325 108.76 42.1622C108.683 41.9692 108.258 41.7761 108.065 41.7761C107.757 41.7761 107.602 42.1236 107.757 42.3553Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.15 37.4131C110.189 37.4903 110.652 37.7992 110.73 37.8378C111 37.915 111.232 37.4903 111.154 37.22C111.077 37.027 110.652 36.8339 110.459 36.8339C110.15 36.8339 109.996 37.1814 110.15 37.4131Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.05 44.5174C114.089 44.5946 114.552 44.9035 114.629 44.9421C114.899 45.0193 115.131 44.5946 115.054 44.3243C114.977 44.1313 114.552 43.9382 114.359 43.9382C114.089 43.9382 113.896 44.2857 114.05 44.5174Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.923 51.6986C101.154 52.0461 102.119 51.9689 102.313 51.5442C102.428 51.2353 101.618 50.5403 101.386 50.5789C101 50.6175 100.498 51.0809 100.923 51.6986Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.228 61.5443C100.189 61.6215 100.691 61.969 100.845 61.8145C101.231 61.3512 100.575 60.9651 100.228 61.5443Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0578 45.2124C96.4825 45.4054 97.1389 45.0966 97.0231 44.6332C96.8686 44.0541 96.3667 43.9769 95.8648 44.1313C95.2856 44.2858 95.5559 44.9807 96.0578 45.2124Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.853 53.1661C113.162 52.6642 114.397 53.4363 113.818 54.2085C113.239 54.9807 112.544 53.668 112.853 53.1661Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.668 39.2278C115.17 38.9189 115.981 40.1158 115.093 40.5791C114.243 41.0424 114.204 39.5752 114.668 39.2278Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9767 70.8492C95.2856 70.3473 96.5211 71.1195 95.9419 71.8917C95.3628 72.6639 94.6678 71.3511 94.9767 70.8492Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2045 36.2935C94.0115 36.1776 93.8956 35.946 93.8184 35.7143C93.7412 35.2896 93.9342 34.8263 94.5134 35.0193C94.8222 35.1352 94.6678 35.5599 94.6678 35.8301C94.6678 36.2935 94.5906 36.5637 94.2045 36.2935Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.946 46.7567C106.753 46.6408 106.637 46.4092 106.56 46.1775C106.483 45.7528 106.676 45.2895 107.255 45.4825C107.564 45.5984 107.409 46.0231 107.409 46.2933C107.409 46.7567 107.332 47.0269 106.946 46.7567Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.618 73.552C121.502 73.7064 121.811 73.8609 121.888 73.9381C121.965 74.0925 121.888 74.3242 121.811 74.44C121.618 74.8647 121.27 74.7103 121.154 74.3242C121.077 74.0153 120.961 73.5134 121.154 73.2431C121.425 72.8956 121.888 73.0887 121.618 73.552Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.776 59.9613C112.853 60.1929 112.621 60.6176 112.699 60.7335C112.776 60.9265 112.699 61.1582 112.621 61.3512C112.39 61.8917 111.965 61.6987 111.849 61.1968C111.772 60.8493 111.617 60.2315 111.849 59.9226C112.119 59.4593 112.621 59.4593 112.776 59.9613Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.98 67.5289C115.865 67.722 115.633 67.4131 115.633 67.3359C115.594 67.2586 115.517 66.9498 115.517 66.8725C115.44 66.5637 115.826 65.9845 116.135 65.9845C116.598 65.9459 117.255 66.2934 116.946 66.7953C116.83 66.9498 116.598 67.1814 116.405 67.2586C116.251 67.4131 116.096 67.3745 115.98 67.5289Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.946 56.9882C107.061 57.1426 107.563 57.1813 107.563 57.1813C107.872 57.0654 108.181 56.5249 107.834 56.2932C107.409 55.9844 106.714 56.6793 106.946 56.9882Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.706 55.5211C104.822 55.5984 105.208 56.023 105.054 56.2161C104.899 56.4477 104.475 56.1775 104.282 56.0617C104.127 55.9844 103.702 55.5983 103.857 55.4053C103.973 55.2123 104.552 55.4439 104.706 55.5211Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.876 58.3011C118.722 58.2625 118.49 57.8378 118.49 57.6833C118.451 57.3744 118.799 57.2586 118.992 57.2586C119.185 57.2586 119.571 57.4131 119.494 57.7219C119.417 57.9536 119.146 58.4169 118.876 58.3011Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.733 64.9421C111.926 65.2895 111.849 65.7529 111.463 65.9459C111 66.2162 110.729 65.8687 110.691 65.444C110.652 65.1351 110.691 64.7104 110.961 64.5173C111.309 64.2471 111.54 64.6718 111.733 64.9421Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.455 48.8803C119.301 48.7644 119.031 48.3783 119.031 48.1853C119.031 48.0309 119.34 47.4903 119.533 47.5289C119.726 47.5675 120.073 47.6448 120.112 47.8378C120.189 48.0695 119.764 49.0733 119.455 48.8803Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.127 81.1193C114.668 81.3896 114.899 82.5093 114.127 82.1618C113.625 81.9302 113.78 80.9263 114.127 81.1193Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.533 51.3514C118.992 51.0039 118.953 49.807 119.88 50.0773C120.729 50.3475 120.15 51.7375 119.533 51.3514Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.089 47.2585C114.011 47.2199 114.282 46.6794 114.32 46.6408C114.475 46.4863 114.977 46.4863 115.015 46.7566C115.054 46.9882 114.32 47.3743 114.089 47.2585Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.448 40.5018C117.37 40.4632 117.641 39.9226 117.679 39.884C117.834 39.7296 118.336 39.7296 118.374 39.9999C118.413 40.2315 117.679 40.6176 117.448 40.5018Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.247 71.9302C114.745 72.741 113.973 71.1966 114.359 70.8105C114.513 70.6561 115.17 70.8105 115.324 70.965C115.556 71.1966 115.401 71.6986 115.247 71.9302Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.98 46.0616C115.672 46.0616 115.865 45.5597 115.903 45.4053C116.058 45.0964 116.173 44.7875 116.521 44.8647C117.139 44.9806 117.177 45.7914 116.868 46.1388C116.482 46.6794 116.521 46.1002 115.98 46.0616Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.297 46.7954C118.413 46.8727 118.452 47.6063 118.374 47.7221C118.259 47.9151 117.834 47.7221 117.641 47.6449C117.216 47.4518 117.255 47.1429 117.641 46.8727C117.757 46.7568 118.143 46.641 118.297 46.7954Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.83 41.1196C106.753 41.2355 106.251 41.3899 106.135 41.3127C105.903 41.1969 105.401 40.8108 105.517 40.5791C105.71 40.1544 106.367 39.5752 106.637 39.9613C106.753 40.0772 106.984 40.9266 106.83 41.1196Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.803 62.1234C119.726 62.2393 119.224 62.3937 119.108 62.3165C118.876 62.2006 118.374 61.8146 118.49 61.5829C118.683 61.1582 119.34 60.5791 119.61 60.9651C119.726 61.1196 119.957 61.969 119.803 62.1234Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.795 34.6719C107.564 35.058 107.216 34.7491 107.139 34.4788C107.1 34.2858 106.984 33.7453 107.139 33.5908C107.332 33.3978 107.757 33.5908 107.872 33.7453C108.065 33.9769 107.95 34.4402 107.795 34.6719Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.259 26.5637C108.567 26.6796 108.22 27.2201 108.143 27.4518C108.027 27.6834 107.679 27.7606 107.486 27.4904C107.37 27.3359 107.448 26.8726 107.525 26.6796C107.641 26.4479 107.988 26.4865 108.259 26.5637Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.672 68.185C106.212 68.4167 105.44 68.9186 105.363 69.1889C105.324 69.2661 105.363 69.4978 105.285 69.5364C105.208 69.6136 104.822 69.382 104.784 69.3433C104.552 69.1503 104.629 68.5711 104.745 68.3009C104.822 68.1464 104.784 68.1464 104.977 68.1078C105.17 68.0692 105.517 68.1078 105.672 68.185Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7643 33.1662C99.4168 32.9731 99.4168 32.2395 99.9574 32.394C100.498 32.587 100.15 33.4364 99.7643 33.1662Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.66 30.1159C92.3125 29.9229 92.3125 29.1893 92.8531 29.3437C93.4322 29.4982 93.0461 30.3476 92.66 30.1159Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.2006 51.583C92.8531 51.3899 92.8531 50.6563 93.3936 50.8108C93.9728 50.9652 93.5867 51.8146 93.2006 51.583Z",
    fill: "#71BF5F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.313 36.8339C101.772 36.4864 101.502 35.5598 102.428 35.8686C102.853 35.9845 103.239 36.4864 103.123 36.8339C102.969 37.1428 102.621 37.0269 102.313 36.8339Z",
    fill: "#71BF5F"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3553 93.4751C64.1661 93.9384 65.0541 94.3245 65.9421 94.6334C66.8302 94.9423 67.7568 95.174 68.6835 95.2898C70.5367 95.5601 72.4672 95.4056 74.2433 94.8651C76.0194 94.3245 77.6796 93.3979 79.1082 92.1624C80.5367 90.9655 81.7722 89.5369 82.8533 87.9925L82.8147 88.0311C84.1275 85.6759 85.1699 83.2049 86.4441 80.7725C87.6796 78.3401 89.3784 75.9849 91.6178 74.286C93.8186 72.5486 96.444 71.4289 99.0695 70.6181C101.695 69.8073 104.436 69.4212 107.139 69.1123V69.2281C104.514 69.8845 101.849 70.5022 99.3398 71.4675C96.8302 72.3941 94.3977 73.5524 92.3514 75.2127C90.3051 76.8343 88.6448 78.9192 87.3321 81.2744C86.0194 83.591 84.8997 86.1006 83.4711 88.4558V88.4945C82.3514 90.0388 81 91.506 79.4943 92.7029C77.9885 93.8998 76.251 94.8651 74.3591 95.367C72.5058 95.8689 70.4981 95.9462 68.6062 95.6373C67.641 95.4828 66.7143 95.2126 65.8263 94.9037C64.9383 94.5562 64.0503 94.1701 63.2394 93.6296L63.3553 93.4751Z",
    fill: "#2D5B27"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4825 95.5985C96.1736 93.7066 96.0964 91.7375 96.2508 89.807C96.328 88.8417 96.5211 87.8765 96.7913 86.9112C97.0616 85.946 97.4863 85.0194 98.0655 84.1699C98.6446 83.3205 99.494 82.6255 100.459 82.1622C101.425 81.7375 102.506 81.6217 103.548 81.6989C105.594 81.892 107.448 82.7028 109.069 83.7838L109.031 83.8997C108.567 83.7838 108.104 83.668 107.641 83.5136L106.251 83.1661C105.787 83.0889 105.324 82.973 104.861 82.9344L104.166 82.8572C103.934 82.8572 103.703 82.8572 103.471 82.8572C102.583 82.8572 101.695 82.9344 100.884 83.2433C100.073 83.5136 99.3396 84.0541 98.7991 84.7491C98.2199 85.4441 97.7952 86.2549 97.4863 87.1429C97.1774 88.0309 96.9458 88.9576 96.7913 89.8842C96.4825 91.7375 96.4439 93.668 96.5597 95.5985H96.4825Z",
    fill: "#2D5B27"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5445 71.1586C42.6989 66.3324 43.3939 61.5061 44.6294 56.7957C45.9036 52.1239 47.7955 47.6066 50.4209 43.4753C53.0078 39.3441 56.2511 35.5989 60.1507 32.6646C62.0812 31.1974 64.1275 29.846 66.2897 28.7264C67.3707 28.1858 68.4518 27.6453 69.5715 27.182C70.6912 26.68 71.8109 26.2939 72.9692 25.8692L73.0078 25.9464C71.9267 26.4484 70.807 26.9117 69.726 27.4908C68.6449 27.9928 67.6024 28.6105 66.5599 29.1897C64.475 30.4252 62.5059 31.7379 60.614 33.2823C56.8688 36.2553 53.5484 39.8074 50.9229 43.8228C48.2974 47.8382 46.3283 52.2784 45.0155 56.9115C43.6642 61.5447 42.892 66.3324 42.6217 71.1586H42.5445Z",
    fill: "#98D891"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M75.9037 76.3705C75.0156 76.3705 74.1662 76.023 73.4712 75.3666L62.4674 64.6331C61.0774 63.2818 61.0774 61.081 62.3901 59.7297C63.7415 58.3397 65.9423 58.3397 67.2936 59.6524L75.865 67.9922L94.2048 49.7683C95.5562 48.417 97.7569 48.417 99.1083 49.7683C100.46 51.1197 100.46 53.3204 99.1083 54.6718L78.3361 75.328C77.6797 76.0616 76.7917 76.3705 75.9037 76.3705Z",
    fill: "#2D5B27"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9037 74.0542C75.0156 74.0542 74.1662 73.7067 73.4712 73.0504L62.4674 62.3168C61.0774 60.9655 61.0774 58.7647 62.3901 57.4134C63.7415 56.0234 65.9423 56.0234 67.2936 57.3362L75.865 65.6759L94.2048 47.452C95.5562 46.1007 97.7569 46.1007 99.1083 47.452C100.46 48.8034 100.46 51.0042 99.1083 52.3555L78.3361 73.0118C77.6797 73.7454 76.7917 74.0542 75.9037 74.0542Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_8666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161.205,
    height: 120,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminCreationSuccess);
export default __webpack_public_path__ + "static/media/admin-creation-success.a51c87f4e4cec40614452100e086cba6.svg";
export { ForwardRef as ReactComponent };